function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircuitBoard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "circuitBoard",
    viewBox: "0 0 1200 800",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radialGradient19941",
    cx: 557.43,
    cy: -725.57,
    r: 200,
    gradientTransform: "matrix(1.5 0 0 1.5 -308.71 677.07)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#0f0"
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#0f0",
      stopOpacity: 0
    },
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radialGradient1865",
    cx: 600,
    cy: 400,
    r: 90,
    gradientTransform: "matrix(1.1779 0 0 .58897 -106.76 164.41)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#22f122"
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#22f122",
      stopOpacity: 0
    },
    offset: 1
  }))), /*#__PURE__*/React.createElement("path", {
    id: "boardBackground",
    d: "m0 0h1200v800h-1200z",
    style: {
      fill: "#162e0d",
      strokeWidth: 1.5
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "cpuAndBackground",
    transform: "translate(-210.08 -11.329)",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1277.9,
    y: 74.283,
    width: 600,
    height: 600,
    style: {
      display: "inline",
      opacity: 0.28,
      strokeLinejoin: "round",
      strokeWidth: 5.5306
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.25 0 0 .25 1446.1 477.1)",
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 227.43,
    y: -711.29,
    width: 600,
    height: 600,
    style: {
      display: "inline",
      strokeLinejoin: "round",
      strokeWidth: 5.5306
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.43,
    y: -711.29,
    width: 600,
    height: 600,
    style: {
      display: "inline",
      fill: "url(#radialGradient19941)",
      opacity: 0.58527,
      strokeLinejoin: "round",
      strokeWidth: 5.5306
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.43,
    y: -611.29,
    width: 400,
    height: 400,
    style: {
      display: "inline",
      fill: "#333",
      strokeLinejoin: "round",
      strokeWidth: 3.6871
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.857 395.71)",
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m396.63-954.55-14.498 113.65h-12.242l-19.33-64.031-19.25 64.031h-12.565l-14.175-113.65h13.048l9.5846 92.382 16.753-55.897h13.209l16.833 56.058 9.7456-92.543z",
    style: {
      fill: "#009500",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      shapeInside: "url(#rect19947)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m479.99-840.9h-59.36v-113.65h58.877v11.517h-45.668v35.197h43.896v11.518h-43.896v43.896h46.151z",
    style: {
      fill: "#009500",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      shapeInside: "url(#rect19947)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m581.4-840.9h-61.857v-113.65h13.209v102.13h48.648z",
    style: {
      fill: "#009500",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      shapeInside: "url(#rect19947)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m684.09-847.99q-13.37 9.2624-31.009 9.2624-22.069 0-33.586-15.142-11.437-15.142-11.437-43.815 0-27.707 11.115-43.332 11.115-15.706 33.908-15.706 8.2154 0 16.27 2.0941 8.0543 2.094 12.967 5.5576l-4.3493 10.39q-11.356-6.4434-24.888-6.4434-15.706 0-23.357 11.437-7.6516 11.357-7.6516 36.003 0 47.359 31.009 47.359 13.128 0 26.901-8.0543z",
    style: {
      fill: "#009500",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      shapeInside: "url(#rect19947)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m350.4-775.27q19.089 0 29.076 15.142 10.068 15.061 10.068 43.896 0 28.673-9.9873 43.815-9.9873 15.142-29.156 15.142-19.008 0-29.076-15.061-9.9873-15.142-9.9873-43.896 0-28.754 9.9873-43.896 9.9873-15.142 29.076-15.142zm0 106.4q25.129 0 25.129-47.359 0-47.44-25.129-47.44-12.242 0-18.686 12.323-6.3629 12.242-6.3629 35.117 0 23.116 6.3629 35.278 6.3629 12.081 18.686 12.081z",
    style: {
      fill: "#009500",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      shapeInside: "url(#rect19947)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m486.11-659.45h-12.726v-97.457l-17.156 46.634h-12.484l-17.156-46.634v97.457h-12.726v-113.65h17.156l19.008 51.789 18.927-51.789h17.156z",
    style: {
      fill: "#009500",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      shapeInside: "url(#rect19947)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m578.9-659.45h-59.36v-113.65h58.877v11.518h-45.668v35.197h43.896v11.518h-43.896v43.896h46.151z",
    style: {
      fill: "#009500",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      shapeInside: "url(#rect19947)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m647.12-775.27q18.042 0 27.707 15.545 9.7456 15.464 9.7456 43.493 0 27.143-9.4235 43.09-9.4235 15.867-28.029 15.867-17.961 0-27.707-15.464-9.7457-15.464-9.7457-43.493 0-27.223 9.4235-43.09 9.504-15.947 28.029-15.947zm0 106.4q11.92 0 17.639-11.276 5.7991-11.357 5.7991-36.083 0-24.807-5.7991-36.003-5.7185-11.276-17.639-11.276-11.759 0-17.558 11.518-5.7991 11.518-5.7991 35.761 0 24.565 5.7185 36.003 5.7991 11.357 17.639 11.357zm-0.32206-59.44q5.0742 0 8.5375 3.5439 3.5439 3.4633 3.5439 8.5375 0 5.2353-3.5439 9.0208-3.5438 3.705-8.5375 3.705-4.9131 0-8.457-3.705-3.4633-3.7855-3.4633-9.0208 0-5.1547 3.3828-8.618 3.4633-3.4634 8.5375-3.4634z",
    style: {
      fill: "#009500",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      shapeInside: "url(#rect19947)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "circuits",
    transform: "matrix(.98454 0 0 .98291 -2.6563 -3.3221)",
    style: {
      stroke: "#76ff03"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m699 3c1.995 15.787-5.42 20.437-16 31-4.158 4.1516-8.416 9.7302-14 11.991-10.124 4.0985-18.126-1.503-25.397 10.009-2.637 4.1751-1.603 10.276-1.603 15 0 11.471 3.379 29.269-0.742 39.999-4.7 12.237-19.576 6.465-29.258 8.229-4.722 0.861-8.897 5.061-11.682 8.772-3.053 4.067-2.318 9.193-2.318 14 0 10.704-2.337 24.545 0.468 34.896 1.245 4.593 7.168 6.571 6.159 12.086-0.868 4.745-7.725 7.271-10.598 2.736-2.89-4.56 1.094-9.481 3.971-12.718",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m907 3c-8.266 8.2662-20.436 25.403-32 28.566-6.9 1.8875-15.873 0.4337-23 0.4337h-48c-7.446 0-19.221-2.2103-26 1.179-6.144 3.0718-11.201 10.023-16 14.821-8.837 8.8335-18.134 17.176-27 25.999-4.375 4.3543-11.86 8.7742-13.566 15.001-3.711 13.543 5.574 34.943-2.037 47-6.519 10.326-19.072 19.351-27.811 27.686-2.46 2.346-6.438 2.879-9.152 0.572-3.706-3.151-2.018-8.899 2.585-9.922 3.864-0.857 7.076 1.517 9.981 3.664",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1061 3c-12.8 7.8411-38.24 3-53 3-5.19 0-12.229-1.2067-17 1.179-9.138 4.5692-16.669 15.771-24 22.782-19.249 18.406-37.841 40.619-59 56.725-5.355 4.0758-12.655 3.314-19 3.314-12.602 0-27.664-2.2739-40 0.2786-11.398 2.3583-22.906 19.859-30.996 27.682-4.661 4.506-24.338 8.737-19.81 16.825 5.089 9.088 12.911-1.117 11.806-7.786",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m971 3c-16.836 16.836-33.955 33.358-51 49.985-5.955 5.809-14.898 17.365-23 19.581-7.758 2.1222-17.979 0.4337-26 0.4337-16.697 0-33.374 0.7985-50 0.9962-8.026 0.0954-22.005-2.7294-29 1.6033-5.637 3.4919-14.768 11.127-17.258 17.44-1.923 4.8725-0.742 11.802-0.742 16.961 0 11.891-1.719 25.248 0.148 36.985 0.818 5.145 8.073 8.252 6.205 13.971-1.851 5.663-9.926 5.903-11.655 0.025-1.281-4.35 2.656-8.145 5.302-10.981",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m959 3c-13.139 16.504-31.066 30.066-46 45-5.357 5.3566-12.16 15.343-20 16.772-23.38 4.2606-51.204 0.2284-75 0.2284-12.031 0-25.642-1.5626-35 7.0903-7.726 7.1441-22.734 17.847-26.397 27.91-2.934 8.058-0.568 20.646 0.227 29 1.431 15.029 2.647 35.152-0.058 50-1.176 6.45-8.01 9.144-10.169 15-3.091 8.386 9.752 22.103 3.079 27.127-3.843 2.892-9.804-0.538-10.02-5.131-0.169-3.608 2.779-6.064 5.338-7.996",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m945 3c-13.156 13.156-26.674 25.985-40 38.985-4.929 4.808-11.999 13.51-19 14.786-22.76 4.1477-49.835 0.2284-73 0.2284-9.471 0-22.452-2.596-30 4.1088-9.992 8.8756-30.314 23.256-34.968 35.891-2.07 5.622-0.041 12.169-0.032 18v44c0 5.514 1.925 12.755 0.343 18-3.127 10.367-16.462 16.96-23.125 25-4.247 5.124 0.774 19.764-8.218 20.172-4.57 0.208-7.808-5.06-5.781-9.063 1.684-3.325 5.589-3.99 8.781-5.109",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m930 3c-10.859 10.859-21.913 21.438-33 32.039-4.293 4.1048-8.987 11.135-15 12.643-7.829 1.9627-17.939 0.3179-26 0.3179-16.049 0-32.016 0.5938-48 0.9854-6.918 0.1694-16.457-1.7941-23 0.618-9.979 3.6788-20.523 17.957-28 25.397-5.087 5.062-13.588 10.784-16.972 17.089-2.745 5.1132-1.028 14.242-1.028 19.91v42c0 5.708 1.391 13.592-0.603 19-2.16 5.857-20.419 25.964-26.793 18.566-7.25-8.415 7.107-9.788 12.396-5.566",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m896.57 2.831c-6.925 5.6397-15.765 18.327-24.571 20.735-6.9 1.8872-15.872 0.4337-23 0.4337h-48c-7.446 0-19.221-2.2103-26 1.179-6.181 3.0903-11.303 10.016-16.286 14.741-11.243 10.661-22.759 21.13-33.714 32.08-4.699 4.6967-13.477 10.485-15.486 17.015-3.888 12.632 5.29 32.602-1.607 43.815-2.756 4.48-9.73 11.554-14.907 12.852-6.782 1.7-17.001-2.384-20.397 6.358-3.22 8.292-1.544 23.527 6.398 28.321 4.622 2.79 11.257 0.314 13.862 6.654 1.836 4.468-3.805 8.454-7.804 6.701-4.365-1.913-4.733-7.624-5.059-11.716",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m872 1.3022c-8.093 4.5331-17.992 5.6978-27 5.6978h-55c-7.092 0-17.486-1.886-23.996 1.3179-10.202 5.0208-20.361 18.393-28.29 26.512-15.187 15.553-38.201 29.997-49.972 48.209-6.106 9.4485 9.3 19.029 2.82 25.523-3.602 3.611-9.769 1.524-10.275-3.58-0.419-4.23 3.053-7.233 5.713-9.982",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m746.87 2.5612c-21.434 16.331-40.975 40.154-61.873 57.21-7.984 6.5165-20.559-0.0112-25.258 12.229-6.577 17.133 7.144 40.142-1.06 56.999-3.449 7.086-17.523 21.558-24.852 24.548-2.762 1.126-5.937 0-8.721 1.194-3.126 1.341-4.648 4.976-2.915 8.04 4.49 7.936 13.182-0.068 11.806-6.782",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m708 2.5612c0 5.7805 1.344 14.977-0.742 20.439-3.484 9.1199-22.603 26.493-31.258 30.821-8.723 4.3617-17.788-2.1399-24.258 8.1828-8.761 13.98 4.365 36.685-1.484 51.996-1.895 4.96-8.915 12.091-14.258 13.227-4.73 1.005-11.621-3.968-14.238 2.882-1.685 4.41 2.636 9.199 7.195 7.889 4.042-1.162 5.381-5.347 6.043-8.998",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m682 2.919c0 4.9689 1.038 12.399-0.858 17.081-2.273 5.6119-12.24 15.932-18.146 17.566-4.846 1.3418-10.237-0.6422-14.996 1.176-6.177 2.3599-15.861 11.684-19.397 17.258-4.274 6.7385-3.253 29.265-1.285 36.985 1.23 4.8244 6.988 7.2896 5.498 12.971-1.364 5.203-9.147 6.191-11.197 0.911-1.816-4.675 2.517-8.8376 5.381-11.867",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m650 2.8554c0 3.1263-0.55 8.0886 0.603 11.055 1.631 4.1988 6.864 6.7171 4.789 11.981-3.558 9.0257-17.294-1.2493-6.392-9.8912",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m616.06 3.1734c-3.089 10.449 3.0245 26.356-2.9205 35.737-8.635 13.625-25.544 24.922-37.143 36.1-4.059 3.912-9.756 7.6721-12.062 12.99-2.427 5.598-0.938 13.996-0.938 19.999v45c0 5.986 1.486 14.333-0.603 20-2.137 5.796-14.769 18.299-20.44 20.928-3.265 1.514-7.106-0.652-8.156-3.971-3.255-10.287 10.391-6.255 14.199-2.957",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m576.94 2.919c0 11.489 4.1785 34.045-1.7945 44.081-8.312 13.966-29.839 21.541-35.539 37-4.457 12.089-0.196 31.356 0.358 44 0.267 6.11 1.54 15.212-0.564 21-1.337 3.681-5.168 6.05-5.905 10-0.586 3.143 1.442 6.429 4.527 7.338 11.026 3.247 7.338-10.471 1.981-14.338",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m568 2.7919c0 10.358 3.555 30.127-1.858 39.208-9.221 15.468-34.221 23.865-40.539 41-2.184 5.9243-0.603 14.738-0.603 21 0 18.26 3.779 41.266-0.533 59-1.449 5.957-8.13 12.441-12.726 16.316-3.188 2.688-8.265 4.535-7.824 9.644 0.527 6.111 8.323 6.771 11.132 1.931 2.155-3.713-0.078-7.703-2.049-10.891",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m919.78 2.9826c-8.513 8.4901-19.262 17.506-27.777 26.017-3.959 3.9576-8.231 9.5277-14 10.721-21.446 4.4376-48.065 0.2786-70 0.2786-7.698 0-20.223-2.3691-27 1.7384-13.686 8.2954-24.173 23.057-36.039 33.69-4.787 4.2893-13.011 10.062-14.643 16.572-4.156 16.578-0.318 38.877-0.318 56 0 5.98 1.802 15.566-1.028 20.981-4.972 9.514-17.901 1.405-24.744 8.247-5.846 5.847-2.132 15.503-3.456 22.772-0.801 4.395-4.587 6.935-6.031 11-1.515 4.262-2.111 14.041-9.682 10.716-11.594-5.091 2.66-12.236 8.941-11.716",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m984.54 2.4739c-17.992 17.992-39.507 36.582-57.539 54.527-7.004 6.9699-16.266 20.534-26.015 23.486-23.019 6.9705-50.871-4.3642-73.896 1.831-12.274 3.3028-13.036 16.625-18.831 24.534-2.055 2.804-6.097 3.92-8.94 1.544-8.696-7.267 5.525-11.004 10.682-10.396",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m860.06 125.79c7.294-2.558 10.982 9.025 3.882 11.417-7.206 2.427-10.975-8.929-3.882-11.417m29.96 0.015c7.292-2.254 10.306 9.212 2.938 11.348-7.131 2.068-10.286-9.077-2.938-11.348",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m804 153.97c7.532-0.445 8.535 10.354 0.999 11.41-7.678 1.076-8.778-10.951-0.999-11.41",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37 3c4.2721 4.2725 10.929 9.1678 10.253 16-0.5043 5.0963-8.6168 9.3567-4.6343 14.772 3.262 4.4352 10.384 2.7362 11.245-2.7754 0.6111-3.9145-3.2878-6.7835-5.8634-8.9962",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22 3c5.411 12.823 1.0217 29.506 1 43-0.059 36.685-3 73.332-3 110 0 12.775-6.3814 40.53 2.3048 50.576 21.901 25.328 56.851 4.008 84.695 12.367 6.939 2.083 12.056 9.114 17 14.057 8.508 8.508 17.485 16.485 26 25 4.701 4.701 9.683 11.325 16 13.896 10.399 4.232 28.7 1.104 40 1.104h92c7.4 0 16.786 1.548 23.961-0.318 3.609-0.939 5.45-4.706 9.054-5.599 2.729-0.677 5.684 0.68 7.149 3.05 2.616 4.235-1.751 8.794-6.161 8.455-3.506-0.269-5.839-3.171-8.003-5.588",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m146 2.6647c-0.049 5.9331 0.475 17.022-2.179 22.335-2.013 4.029-6.371 6.484-7.503 11-4.109 16.391-1.318 39.024-1.318 56 0 8.283-2.846 23.108 2.318 30 15.26 20.367 38.63 37.035 56.682 54.999 7.185 7.15 17.547 20.648 27 24.259 5.453 2.083 13.238 0.742 19 0.742h42c10.4 0 23.958-2.312 34 0.434 4.059 1.11 6.313 4.796 10 6.504 4.322 2.001 12.935-0.16 13.454 7.074 0.371 5.18-6.174 8.233-10.11 5.242-3.544-2.694-3.33-7.272-3.344-11.254",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1223 169h-69.047c-10.68 0-22.45-1.396-33 0.305-11.01 1.775-14.73 16.188-26 16.676-27.82 1.204-56.19 1.019-84 1.019-10.95 0-27.747-3.174-38 0.742-6.939 2.651-12.858 11.116-18 16.258-12.183 12.183-24.82 23.82-37 36-5.449 5.449-11.646 14.298-19 17.107-5.967 2.278-14.667 0.891-21 0.893h-45c-6.453 0-16.101-1.77-22 1.179-10.854 5.427-16.737 18.692-27 25.079-6.175 3.844-14.459-0.082-19.682 5.886-7.406 8.464 2.213 21.561-12.318 27.114-6.436 2.459-24.828 2.649-31-0.437-5.989-2.994-8.711-9.321-16-9.777-32.057-2.006-64.873-0.044-97-0.044-15.734 0-35.718-3.336-51 0.314-9.525 2.275-18.364 15.05-25 21.686-15.335 15.335-31.511 29.832-47.001 45.015-6.41 6.283-14.367 17.17-22.999 20.257-7.918 2.832-19.643 0.728-28 0.728h-53c-8.244 0-17.92-1.396-26 0.279-13.183 2.731-18.887 22.121-32 25.403-9.875 2.472-22.821 0.318-33 0.318h-71c-72.238 0-144.68 1-217 1",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59 179c-2.2011 2.739-5.0418 6.349-8.9954 6.172-5.1594-0.231-7.6913-7.212-3.6867-10.568 5.8965-4.94 11.96 3.843 17.686 4.337 13.127 1.135 26.817 0.059 39.996 0.059 5.445 0 12.999-1.321 18 1.179 5.001 2.501 8.818 7.764 13 11.397 12.775 11.097 25.005 23.488 37 35.425 5.441 5.414 11.54 14.153 19 16.72 4.836 1.665 10.944 0.256 16 0.28 9.323 0.044 18.623 0.999 28 0.999 32.946 0 66.072-1.019 99 0.015 10.909 0.343 14.868 13.62 26 13.97 6.595 0.206 14.565 1.175 19.992-3.264 4.893-4.002 5.963-21.246 14.899-16.527 10.265 5.421-1.926 11.752-7.891 11.806",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m211.33 1.9951c13.349 13.349 28.834 27.684 42.338 40.857 5.36 5.2291 11.55 14.429 19 16.556 10.883 3.1064 29.89 4.3072 35.682-7.5702 5.807-11.908 1.175-29.516-10.682-35.428-5.043-2.5144-12.441 2.7763-15.449-3.6813-4.129-8.8658 11.243-11.309 11.449 0.1088",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m175.83 2.7224c14.433 10.997 8.736 18.529 12.445 33.445 1.267 5.0948 8.717 9.972 3.94 15.566-3.374 3.9506-9.773 1.4531-10.001-3.581-0.188-4.1448 3.14-7.2306 5.743-9.9846",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m113 3c2.372 2.3633 4.835 5.4919 8 6.8063 4.362 1.8115 10.322-0.36738 12.712 5.2508 2.072 4.8702-4.324 9.2408-8.565 6.8997-3.659-2.0201-3.855-7.2955-4.147-10.957",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66 3c6.2147 6.2146 19.196 14.336 21.566 23 3.5005 12.797 0.9317 31.826-0.1212 45-0.5013 6.2719-2.0187 15.166 1.0116 20.961 3.4951 6.6842 11.955 12.396 17.543 17.325 9.659 8.519 18.571 18.02 28 26.803 22.271 20.746 43.813 42.314 65.83 63.335 9.574 9.14 18.97 21.473 30.17 28.544 6.694 4.226 18.349 2.032 26 2.032h61c7.111 0 21.211 2.687 26.852-2.318 12.051-10.693-5.109-20.86-7.031-29.697-1.026-4.717 6.2-15.332-3.822-15.608-10.992-0.304-3.788 10.838 1.001 13.623",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51 3c8.7605 7.1342 22.761 17.632 27.566 28 3.1312 6.756 0.4336 17.621 0.4336 25 0 20.714-1 41.276-1 62 0 7.494 1.4494 21.583-2.6034 28-10.79 17.085-32.779 2.82-42.369 22-1.7926 3.585-2.3788 7.7753-2.6435 11.64-0.2491 3.637 0.0131 7.7917 1.3588 11.36 9.0668 24.038 47.283 16 67.257 16 4.595 0 10.631-1.007 15 0.603 4.308 1.589 7.608 6.026 11 8.973 11.193 9.722 20.807 21.125 32 30.848 3.775 3.279 7.298 8.073 12 10.012 13.37 5.515 34.706 1.564 49 1.564h111c10.507 1e-3 15.838 5.478 23.857 11.799 3.56 2.808 5.285 9.427 11.124 7.554 6.177-1.982 5.501-10.458-0.996-11.205-3.334-0.383-5.66 1.857-7.985 3.852",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m301.06 210.76c7.359-2.732 11.478 7.876 3.922 10.95-6.742 2.743-10.887-8.365-3.922-10.95m88.364 0.27c6.093-3.968 12.351 5.932 6.349 10.349-6.345 4.669-12.333-6.452-6.349-10.349m117.72 0.014c6.446-3.525 12.557 5.895 5.743 10.168-6.361 3.988-12.185-6.645-5.743-10.168",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1014.3 818.33c-16.833-15.505-36.526-34.813-53.277-50.416-6.384-5.947-12.697-15.512-21-18.763-7.507-2.939-18.052-1.148-26-1.148h-51c-7.463 0-16.746 1.489-24-0.318-14.796-3.685-19.982-24.76-36-26.508-14.669-1.601-30.242-0.174-45-0.174-6.263 0-14.244 1.7-20-1.314-19.588-10.256-18.019-43.018-15.258-62.427 0.622-4.367 7.424-6.035 6.287-11.154-2.093-9.425-18.686-1.51-8.029 7.895",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1002.3 818.6c-13.927-11.342-30.366-28.145-43.152-40.763-6.6-6.513-14.159-16.932-23.17-19.98-7.636-2.583-18.008-0.854-26-0.854-17.999 0-36.002-0.124-54 3e-3 -6.65 0.047-16.776 2.167-23 0.064-13.038-4.404-18.906-23.052-32-26.633-16.879-4.617-40.472-0.434-58-0.434-5.763 0-13.547 1.341-19-0.742-10.163-3.883-21.184-18.649-29-26.273-5.347-5.215-14.766-11.85-17.397-18.985-3.577-9.703 2.542-22.574 10.787-27.977 3.604-2.362 9.274-1.526 10.233-7.062 0.894-5.156-5.937-9.968-10.189-6.354-3.325 2.825-2.302 7.739-1.434 11.393",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m542.04 550.8c6.969-2.194 11.811 8.781 3.937 11.413-7.58 2.533-11.935-8.895-3.937-11.413m87.065-0.015c7.936-2.859 10.624 8.553 2.876 11.467-8.373 3.149-9.334-9.14-2.876-11.467",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m872.15 701.03c6.809-3.882 14.093 7.096 5.832 10.896-6.477 2.979-12.254-7.233-5.832-10.896",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m842.11 700.75c7.194-2.944 13.437 7.399 5.832 11.206-6.631 3.32-13.585-8.034-5.832-11.206",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m751.13 700.76c7.686-3.103 13.205 8.707 4.823 11.619-7.154 2.486-12.091-8.685-4.823-11.619",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m629.11 582.79c8.203-2.951 11.64 9.943 3.847 13.003-6.826 2.68-10.97-10.44-3.847-13.003m30-0.024c7.08-2.702 13.005 8.665 4.847 11.452-7.098 2.424-12.324-8.6-4.847-11.452",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m698 595c12.788 12.349 9 29.245 9 46 0 6.216 1.243 14.019-0.653 19.996-1.068 3.368-3.879 5.192-5.474 8.174-2.381 4.452 0.449 10.511-5.006 13.494-5.246 2.868-11.47-3.263-8.673-8.555 2.329-4.406 7.543-4.097 11.806-4.109",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m486 553c-6.988 0.063-18.733 9.793-6.956 13.338 8.536 2.569 7.68-9.134 9.845-13.338 2.817-5.471 10.073-11.999 16.111-13.467 9.794-2.38 21.945-0.533 32-0.533 22.032 0 44.045 2e-3 66 0.88 10.961 0.438 25.408-4.184 36-0.138 9.113 3.482 18.194 15.452 25 22.258 5.943 5.942 12.983 14.83 20.286 18.972 3.236 1.836 7.286 0.544 10.566 2.485 2.722 1.611 3.934 5.362 3.119 8.409-1.303 4.875-7.935 3.613-10.653 0.83-2.65-2.713-2.659-7.163-3.318-10.696",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m929.53 818.15c-12.826-7.9544-29.826-6.1474-40.534-6.1474-29.261 0-58.763 1.106-88-0.018-16.173-0.623-22.366-24.809-38-27.538-9.856-1.721-20.149 0.085-30 0.517-15.605 0.683-31.379 0.039-47 0.039-8.079 0-19.342 2.01-27-0.728-13.127-4.693-26.292-23.564-36-33.272-6.788-6.788-19.788-14.917-23.258-24-1.985-5.196-0.742-12.514-0.742-18 0-11.742-0.171-23.312-0.91-35-0.881-13.948 15.872-16.848 17.762-29 4.041-25.984-9.887-62.331 9.148-83",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m690.04 611.85c-7.529 2.172-6.016 15.227 2.941 12.101 8.038-2.805 5.016-14.396-2.941-12.101m299.28 206.39c-16.142-12.389-39.022-44.936-55.322-51.205-7.83-2.886-18.757-1.032-27-1.032h-54c-8.068 0-18.161 1.635-26-0.318-13.169-3.28-18.753-23.473-32-25.534-17.139-2.666-36.64-0.148-54-0.148-6.699 0-15.658 1.529-22-0.893-5.569-2.128-9.894-8.001-14-12.107-8.51-8.51-17.446-16.55-26-25.004-3.97-3.923-9.715-8.199-10.772-13.996-1.053-5.778-1.602-16.526 0.63-21.996 1.872-4.587 6.812-6.986 7.863-12.008 2.698-12.885-0.822-18.809 8.279-29.996",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m952.95 818.19c-6.831-6.831-18.647-21.01-27.95-24.454-9.362-3.465-24.056-0.738-34-0.738-26.295 0-52.72 0.781-79 0.12-14.948-0.376-20.817-23.766-35-25.972-24.404-3.796-52.275-0.148-77-0.148-8.499 0-21.009 2.31-29-0.742-6.385-2.439-11.175-9.55-16.039-14.092-11.428-10.672-27.582-22.237-36.219-35.255-3.395-5.118-1.742-14.038-1.742-19.911 0-7.365-1.96-18.049 0.603-25 4.335-11.751 22.546-23.363 31.397-32.015 4.06-3.968 6.942-9.722 11.224-13.221 2.847-2.327 7.699-3.432 8.114-7.782 0.744-7.808-11.093-9.999-12.86-1.967-0.714 3.245 1.128 6.21 2.522 8.985",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m604 541v72c0 9.057 3.183 21.492-0.148 30-2.496 6.376-9.13 11.278-13.852 16-3.362 3.362-7.848 6.765-10.126 11-1.833 3.408-0.994 7.679-3.463 10.852-1.767 2.271-4.643 3.458-7.352 2.101-10.923-5.47 1.953-13.105 8.941-11.953",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m721.02 582.21c7.959-0.424 9.258 11.922 0.981 12.116-7.712 0.181-8.939-11.693-0.981-12.116",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m568.13 583.05c6.357-3.348 13.069 7.173 5.808 10.91-6.965 3.585-12.998-7.123-5.808-10.91",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m940.46 818.01c-4.116-4.116-11.614-11.776-17.187-13.906-7.872-3.007-19.922-2.107-28.269-2.107h-63c-8.768 0-24.304 2.965-32-1.564-9.856-5.799-16.802-21.364-28-24.119-7.86-1.933-17.916-0.317-26-0.317h-54c-7.954 0-19.515 2.117-27-0.742-12.651-4.833-25.548-22.806-35-32.258-5.966-5.966-18.418-14.135-21.397-22.015-4.008-10.606-0.34-27.66-0.618-38.985-0.116-4.744-1.946-9.652 0.757-13.996 5.829-9.369 18.42-14.337 22.368-25.004 2.015-5.443 0.36-11.45-0.021-17-0.614-8.974 0.426-18.04-0.089-27",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m810.06 612.05c6.444-3.226 12.964 6.987 5.832 10.759-6.983 3.692-13.442-6.95-5.832-10.759",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m782.02 612.02c8.71 0.224 8.323 13.126 0.024 12.322-6.897-0.668-7.877-12.523-0.024-12.322",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m720.1 611.79c6.971-2.476 12.272 8.297 4.836 11.341-7.753 3.173-12.986-8.446-4.836-11.341",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m757.04 818.1c-2.767-7.1114-22.347-6.1024-31.04-6.1024h-59c-7.284 0-19.63 2.347-25.961-1.742-12.573-8.122-23.385-22.727-34.039-33.254-12.835-12.682-28.912-24.339-39.566-39.004-2.886-3.972-1.849-9.04-4.868-12.911-6.644-8.519-18.608-14.229-23.538-24.089-3.857-7.713-1.028-22.462-1.028-31 0-3.329-0.716-7.731 0.603-10.867 1.423-3.38 5.62-4.065 7.368-7.241 1.859-3.377 0.557-7.908-3.03-9.48-10.487-4.597-8.074 9.985-4.941 14.588",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m977.28 818.1c-12.659-11.29-30.355-36.126-46.277-42.209-7.872-3.007-19.653-0.893-28-0.893-14.238 0-28.797-0.883-43 0.089-12.441 0.852-26.708 2.695-39-0.407-12.892-3.253-18.843-23.487-32-25.534-17.139-2.666-36.64-0.148-54-0.148-6.664 0-15.661 1.549-21.961-0.89-9.455-3.659-17.965-16.117-25.039-23.106-9.432-9.32-24.97-19.001-30.972-31.004-3.848-7.695-2.427-28.885-0.028-37m128.33 160.97c-5.773-6.619-16.331-19.822-24.334-23.534-8.695-4.034-21.813-1.153-31-0.523-15.193 1.04-30.77 0.089-46 0.089-9.234 0-24.704 2.941-32.961-1.573-13.891-7.594-25.792-24.388-37.038-35.412-7.117-6.977-17.057-13.556-22.398-22.015-3.668-5.81-0.543-13.045-5.022-19-7.957-10.578-25.293-18.293-29.978-31-3.708-10.059 4.723-21.034 11.811-27.302 3.245-2.869 8.371-3.674 9.209-8.701 0.957-5.734-6.868-10.249-10.881-5.563-3.107 3.629-0.959 8.666 0.258 12.566m92.148-13.957c-6.689 3.713-3.413 17.188 5.743 11.803 7.312-4.299 1.569-15.861-5.743-11.803",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m964.59 818.06c-9.256-9.257-24.099-28.411-36.591-33.164-7.884-2.999-19.644-0.893-28-0.893h-58c-8.365 0-18.877 1.716-27-0.318-12.833-3.212-18.33-21.783-31-25.248-16.594-4.539-39.769-0.434-57-0.434-6.646 0-16.128 1.735-22-1.893-9.404-5.812-17.165-16.362-25-24.103-9.759-9.643-21.939-18.404-30.427-29.174-5.061-6.42-3.607-12.689-10.573-18.83m-10.721-11.971c6.222-3.879 14.921 6.359 9.118 10.943-6.349 5.015-16.911-6.086-9.118-10.943",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m630.06 701.12c7.095-3.214 12.401 8.283 4.896 11.806-7.186 3.374-12.215-8.491-4.896-11.806",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m772.06 817.8c-2.5513-4.5264-10.515-11.27-16.853-13.692-6.325-2.416-15.61-1.11-22.212-1.107h-50c-11.266 0-31.813 3.959-41-3.344-10.155-8.072-18.649-18.633-27.999-27.617-10.047-9.653-22.31-18.864-30.683-30.039-4.036-5.386-2.417-12.299-6.948-18-7.955-10.008-22.63-17.576-28.342-29-2.998-5.996-1.545-18.392-0.969-25 0.53-6.089 6.157-8.654 8.199-14 2.484-6.505-1.726-14.333 3.89-19.772 7.082-6.857 18.117 0.228 25.638-5.086 3.989-2.818 4.19-7.721 4.213-12.142 0.055-10.53 3.782-30.461-3.278-38.981-6.809-8.217-19.205-6.019-28.721-6.019-20.359 0-40.715 0.755-61 0.996-8.802 0.105-21.713-2.463-29.999 0.607-8.938 3.312-6.558 19.11-15.006 19.931-4.614 0.448-9.092-5.217-6.233-9.306 2.559-3.662 7.301-3.637 11.238-3.228",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m587.59 818.28c-12.186-12.186-28.025-27.609-40.592-39.371-5.518-5.166-10.538-12.176-16.999-16.169-11.107-6.864-26.321 4.535-33.972-10.742-5.639-11.258 2.437-25.679 2.933-37 1.409-32.192 0.091-64.774 0.039-97-0.018-11.512-6.691-13.533-10.726-23-1.968-4.617-1.737-14.584-10.165-11.381-11.054 4.2 1.933 12.327 7.891 12.381",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m602.14 818.01c-20.635-20.635-50.581-43.435-67.708-67.012-3.573-4.918-1.295-11.082-4.868-16-5.735-7.895-18.019-13.923-21.534-23.039-1.998-5.185-0.177-10.654-0.047-15.961 0.278-11.319 0.015-22.677 0.015-34 0-11.068-3.623-29.893 0.988-40 4.791-10.5 17.744-18.081 25.012-27m4.059-11.928c7.036-3.373 12.054 7.954 4.882 11.49-8.567 4.225-12.266-7.951-4.882-11.49",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m452.31 818.28-28.309-27.282c-3.5487-3.4199-8.644-7.246-10.397-12-3.787-10.272-0.603-27.06-0.603-38 0-29.351 0.65-58.726 0.996-88 0.263-22.21-19.073-38.761 4e-3 -58m6.012-12.033c9.437-0.564 7.997 12.312-1.007 12.785-8.395 0.441-5.645-12.387 1.007-12.785",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m632.69 818.06c-23.897-23.897-54.78-49.152-76.349-75.096-3.554-4.276-2.456-9.683-5.662-13.961-6.52-8.7-20.269-15.667-24.079-26-3.034-8.231-0.603-21.258-0.603-30 0-9.121-3.758-28.944 1.028-36.772 4.058-6.637 16.701-1.6 22.933-4.237 4.62-1.956 6.965-7.482 12.039-8.58 5.081-1.099 10.354 3.994 14.392-1.559 3.475-4.78-2.084-10.9-7.333-9.066-3.878 1.355-4.372 5.739-5.059 9.214",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m539 612.62c8.417-1.919 11.757 10.094 2.981 11.895-8.132 1.668-12.022-9.835-2.981-11.895m79.856 205.44c-16.167-16.167-36.643-34.917-52.86-51.056-6.347-6.316-14.27-11.711-19.566-19.001-3.388-4.664-1.091-10.333-4.037-15-6.246-9.893-19.137-15.436-24.37-26-4.054-8.184-1.027-23.942-1.027-33 0-18.621-7.587-49.905 15-56",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m522.32 817.97c-12.666-12.666-28.625-28.331-41.322-40.967-4.619-4.597-13.059-9.747-15.397-16.016-3.434-9.203-0.603-24.181-0.603-33.985v-58c0-8.363-1.718-18.879 0.318-27 1.048-4.182 7.412-12.593 11.072-14.976 3.631-2.365 10.974-1.754 10.974-8.024 0-5.411-7.327-8.101-11.046-4.562-3.03 2.882-2.171 6.968-1.318 10.562",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m485.28 817.92c-11.058-12.679-27.367-27.013-39.277-38.923-4.234-4.234-11.139-8.811-13.972-14.089-4.397-8.192-1.028-25.682-1.028-34.911 0-29.055 0.46-57.986 1.005-87 0.24-12.779 11.114-14.359 19.976-18.448 3.161-1.459 5.774-4.947 3.972-8.443-5.142-9.976-12.88 1.713-12.953 7.891",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m419.02 612.79c8.068-1.095 10.925 11.796 2.937 13.614-7.224 1.644-11.442-12.46-2.937-13.614m47.694 205.26c-8.309-8.309-21.158-20.896-29.709-28.958-4.347-4.097-10.933-8.686-13.57-14.128-5.28-10.893-1.434-30.996-1.434-42.961v-104",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m447.15 643.03c6.772-3.859 13.86 6.924 5.807 10.746-6.875 3.263-12.432-6.969-5.807-10.746",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m570.74 818.33c-8.338-10.027-21.499-22.088-30.738-31.327-4.773-4.773-9.899-11.922-16-14.972-8.688-4.344-20.18 0.842-29-1.466-4.903-1.282-9.741-6.638-12.682-10.562-5.045-6.733-2.318-20.92-2.318-29v-73m-1.941-15.123c8.842-3.551 12.648 9.748 3.926 13.063-6.766 2.571-10.999-10.224-3.926-13.063",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m507.23 741.03c6.814-4.053 14.28 6.247 6.663 10.726-6.773 3.982-13.461-6.683-6.663-10.726",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1134 3c-12.85 12.853-25.72 25.713-39 38.09-5.31 4.9461-10.45 12.607-17 15.883-10.6 5.3017-25.93-4.1219-35.58 4.4221-20.89 18.52-40.46 39.067-60.421 58.621-7.347 7.199-16.262 20.523-25.999 24.243-5.196 1.985-12.514 0.742-18 0.742h-39c-5.775 0-13.719-1.393-19 1.318-7.278 3.736-13.279 11.961-19 17.682-11.181 11.181-22.818 21.818-34 33-8.858 8.858-15.648 18.979-29 19-3.789 6e-3 -8.269-0.642-11.961 0.318-4.141 1.077-11.912 10.41-15.435 2.454-4.38-9.895 7.834-9.576 12.396-3.772",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1119 3c-8.95 11.652-21.57 21.573-32 32-4.61 4.6102-9.76 11.875-16 14.258-10.11 3.8635-23.51-3.2183-33 2.7747-13.95 8.8079-24.61 32.62-41 36.65-6.98 1.7162-15.826 0.3171-23 0.3171-17.242 0-34.802-0.9434-52 0.3812-7.356 0.5666-10.901 7.9421-18 8.5601-11.568 1.0071-28.324-3.672-39 1.1983-19.789 9.0274-30.398 34.074-49 45.132-6.881 4.091-20.132-2.203-25.397 4.046-4.767 5.658 0.157 16.166-1.265 22.682-0.966 4.425-5.215 6.875-6.735 11-1.664 4.518 0.155 10.89-6.618 11.547-5.115 0.496-8.723-5.026-5.381-9.268 2.685-3.408 7.496-3.246 11.396-3.279",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "firstTarget",
    d: "m2.4613 407.09c9.0916 0 22.993 2.3921 31.539-0.83193 13.787-5.2 21.647-22.097 34.17-29.359 7.4537-4.322 20.49-1.899 28.83-1.899 51.58 0 104.56-3.539 156 0.09 9.6 0.677 12.631 9.187 21 11.476 13.55 3.707 33.952 1.106 48 0.394 9.914-0.502 14.356-11.313 24-11.916 24.128-1.51 48.82-0.044 73-0.044 9.094 0 22.41 2.466 31-0.6 9.218-3.289 17.231-14.705 24-21.396 15.089-14.916 30.991-28.995 46-44.004 6.549-6.549 15.724-19.142 25-21.57 7.256-1.899 16.523-0.43 24-0.43 23.485 0 50.924 3.968 74-0.228 14.589-2.653 20.059-23.959 34-27.454 16.55-4.149 36.948 4.819 53-1.466 13.026-5.1 19.842-25.044 34-27.624 12.535-2.284 27.254-0.228 40-0.228 4.932 0 11.46 1.091 16-1.179 8.311-4.156 15.481-14.302 22-20.821 14.506-14.506 29.49-28.49 44-43m4.059-11.214c-7.226 2.53-4.921 14.789 3.922 11.32 7.842-3.077 3.597-13.952-3.922-11.32",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0.11671 361s257.63-3.9779 263.88 0.019l18.549 8.8736c2.902 1.9076 38.451 1.7894 38.451 1.7894 6.3969-0.18741 11.347-7.6137 15-7.663l73-0.019 30.935-0.86425c0.38436-0.0129 1.1228-0.20529 1.889-0.77319l16.461-14.853 36.715-31.51 52-49.996 20.193-21.168c0.71455-0.88568 0.80465-0.96358 0.852-1.8552l0.99979-19.195",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m625.4 265.03c6.436-3.851 13.586 5.964 6.623 9.936-6.101 3.479-13.066-6.082-6.623-9.936",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2 264c8.1141 0 21.912-2.638 29 1.742 9.709 6 16.548 20.852 29 21.243 87.139 2.733 174.81 0.015 262 0.015 19.727 0 45.413-4.843 61.576 6.475 3.996 2.798 17.936 0.418 13.816 10.311-4.432 10.641-12.339-1.913-12.392-7.786",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2 275c15.46 0.13 20.298 14.009 32 21.397 4.7855 3.021 12.565 1.603 18 1.603 80.533 0 162.7-4.588 243 0.911 18.296 1.253 37.655 0.834 55.985 0.227 5.157-0.17 14.654-8.963 17.303 0.881 2.667 9.914-10.244 8.652-13.288 0.981",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.2818 289.19c5.1613 5.161 11.767 14.411 18.718 17.067 6.4729 2.472 16.139 0.742 23 0.742h268c9.508 0 21.814-2.078 31 0.434 4.699 1.285 7.283 6.067 12 7.248 10.696 2.677 18.123-1.762 27.424 6.1 3.837 3.243 19.749 1.811 15.353 11.175-5.339 11.373-12.753-1.245-12.777-7.957",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2 324h244c8.461 0 21.096-2.342 29 0.858 8.179 3.311 12.61 12.682 20 17.248 11.87 7.336 17.383-4.538 27-7.351 4.838-1.415 15.425 4.748 16.338-4.766 0.93-9.692-12.368-6.675-13.338 2.011",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m300.06 323.8c7.372-2.452 11.637 8.631 3.902 11.441-7.36 2.675-11.467-8.925-3.902-11.441",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m219.04 400.71c8.102-1.337 9.731 10.523 1.946 12.338-7.963 1.857-10.074-10.996-1.946-12.338m938.96-397.71c-15.18 15.182-30.83 29.834-46 45-5.11 5.1036-14.86 11.751-16.68 19-2.26 9.0223 0.24 19.885 0.64 29 0.17 3.8207-0.74 8.458 1.07 11.985 4.64 9.052 16.62 13.526 22.27 22.016 11.64 17.505-9.45 38.695-23.3 47.257-8.01 4.947-24.79 1.742-34 1.742-20.38 0-40.61 1-61 1-9.276 0-22.155-2.31-31 0.564-7.812 2.538-14.378 11.816-20 17.436-11.181 11.177-22.82 21.82-34 33-5.374 5.374-11.13 13.386-18 16.821-6.12 3.06-16.298 1.179-23 1.179h-43c-6.562 0-14.651-1.257-20.999 0.573-10.674 3.076-15.601 17.561-26.001 21.534-9.089 3.472-21.628-2.789-30 2.496-9.849 6.218-17.32 22.151-29 25.079-13.787 3.457-30.826 0.318-45 0.318-30.044 0-60.008 1-90 1-11.989 0-27.378-2.596-39 0.318-8.061 2.021-15.091 12.941-21.039 18.397-17.621 16.164-34.517 33.132-52 49.459-6.209 5.798-13.517 17.083-21.961 19.392-10.337 2.828-24.292 0.417-35 0.434-22.88 0.037-46.055 0.583-69 1.005-8.878 0.163-12.693 8.656-21 9.806-20.53 2.842-43.261 0.189-64 0.189-6.313 0-14.764-1.0075-21-0.742-6.3369 0.10511-17.196 2.5395-21.799 5.3208",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160.06 402.03c7.361-3.889 12.755 7.312 4.897 10.885-6.672 3.035-11.674-7.304-4.897-10.885",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2 431c10.712-2.55 23.024-1 34-1h273c24 0 48-0.049 72 0 5.767 0.012 20.028 10.653 22.248 0.957 2.543-11.104-11.989-4.598-15.248-0.957",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.4613 548.54c26.53-26.53 55.676-51.393 82.539-77.555 7.4516-7.257 15.196-14.199 22.715-21.395 3.751-3.59 8.058-8.97 13.285-10.272 9.009-2.244 20.721-0.318 30-0.318h62c36.388 0 72.612-1 109-1 15.272 0 32.986-2.508 48 0.228 12.71 2.316 16.482 16.713 21.934 25.602 2.663 4.341 10.453 13.149 0.062 15.418-10.072 2.2-6.729-10.72-1.996-14.248",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.7431 562c27.157-27.154 57.434-52.569 85.257-79.039 7.8672-7.484 16.118-14.542 24-21.996 4.487-4.245 9.138-10.513 15.001-12.817 6.216-2.443 14.436-1.148 20.999-1.148h199c5.153 0 12.11-1.2 17 0.603 6.653 2.453 12.607 10.424 12.96 17.397 0.399 7.87-2.346 18.647 7.041 22.258 3.882 1.493 8.915 0.742 12.999 0.742 10.393 0 27.289 3.245 35.995-3.419 5.618-4.299 4.636-15.878 11.049-17.73 4.242-1.225 9.667 3.747 7.819 8.09-2.09 4.916-8.537 4.676-12.863 4.059",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1072.8 2.7283c-3.24 3.242-6.6 7.5782-11 9.2577-17.2 6.5707-39.72-4.8795-57 1.8904-9.555 3.7426-8.793 20.229-17.012 21.425-5.064 0.7371-8.499-5.2927-5.381-9.2947 2.831-3.6335 7.447-2.9781 11.393-2.2786",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1070 105.97c6.78-1.449 10.12 9.337 2.92 11.317-7.18 1.972-10.45-9.707-2.92-11.317",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1144.2 140.04c6.64-3.688 13.37 7.189 5.79 10.723-6.37 2.973-12.25-7.134-5.79-10.723",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1096 147c-23.3 0-46.83 1.443-70 0.871-10.89-0.269-28.121-4.331-38 1.717-9.478 5.803-18.148 16.56-26 24.412-13.844 13.843-28.172 27.177-42 41-7.537 7.534-16.911 21.253-27 25.107-7.109 2.715-17.475 0.893-25 0.893-19.966 0-42.274-2.826-62 0.147-9.525 1.436-13.496 12.862-22 16.111-9.239 3.529-20.575-1.626-29.985 1.395-7.309 2.346-11.715 10.725-18.015 14.747-7.769 4.959-20.83-10.273-24.377-0.341-3.669 10.272 9.257 8.052 13.377 2.941m377.04-134.21c-8.39 2.888-2.12 13.44 4.85 10.533 7.46-3.111 2.19-12.955-4.85-10.533",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1223.3 177h-64.301c-10.86 0-23.4-1.344-34 1.318-10.63 2.67-13.71 16.301-26 16.667-27.61 0.822-55.37 0.015-83 0.015-10.4 0-26.249-2.983-36 0.742-6.989 2.67-12.76 11.132-18 16.243-13.215 12.891-26.5 25.798-39.83 38.591-4.989 4.787-10.509 12.375-17.17 14.821-5.675 2.083-14.008 0.603-20 0.603h-44c-6.843 0-15.481-1.371-22 1.032-10.104 3.726-17.974 16.74-26 23.678-2.216 1.915-4.927 4.584-8 4.856-4.5 0.398-15.768-4.402-14.377 5.422 1.593 11.257 12.395 3.116 13.377-3.988",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1223.3 186h-62.301c-9.27 0-19.88-1.442-29 0.228-10.19 1.866-13.71 16.264-25 16.753-27.55 1.192-55.43 1.019-83 1.019-11.27 0-27.27-2.922-38 0.564-8.162 2.652-15.122 12.558-21 18.436-11.189 11.189-22.596 22.082-34.001 33.039-5.669 5.447-11.118 13.111-17.999 17.023-6.113 3.475-15.235 1.938-22 1.938-16.961 0-40.783-4.355-57 0.514-6.464 1.94-16.067 11.576-19.111 17.486-2.349 4.561-0.217 11.501-6.904 13.288-5.228 1.397-8.353-5.017-5.956-9.141 2.243-3.86 7.164-3.551 10.971-3.147",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1222.8 194c-25.88 0-60.623-5.033-85.793 1.318-7.08 1.786-11.26 10.203-17 14.234-3.73 2.616-9.57 2.222-14 2.409-26.56 1.12-53.41 0.039-80 0.039-9.84 0-24.75-2.808-34 0.603-8.682 3.202-17.949 15.651-24.286 22.308-14.01 14.72-30.552 35.222-47.714 46.057-5.318 3.357-12.97 2.032-19 2.032-13.804 0-31.624-3.03-45 0.318-14.695 3.678-24.058 25.387-37 32.744-12.728 7.235-33.891-0.108-48 2.086-6.664 1.036-9.725 7.608-17 7.837-11.62 0.364-27.014-3.643-34.258 8.016-2.796 4.501-1.742 10.929-1.742 15.999 0 12.521-3.781 29.918 9.001 37.297 3.171 1.831 6.813 1.144 9.999 2.731 2.933 1.461 4.896 4.348 8 5.524 4.021 1.523 9.384 0.22 11.968 4.673 2.562 4.415-2.083 10.25-6.949 8.407-4.976-1.885-5.003-7.2-5.019-11.632",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1223.3 250.76c-17.337 0.12624-44.331 0.23696-62.301 0.23696-50.11 0-101.05-2.51-151 0.911-13.62 0.932-29.769-2.91-43 0.407-4.898 1.228-8.584 6.266-12 9.682-8.139 8.138-20.186 24.409-31 28.397-19.336 7.129-44.594-5.838-64 2.167-14.667 6.05-21.202 26.587-36 32.578-17.197 6.962-39.656-6.754-55 6.287-8.56 7.275-23.103 18.414-28.033 28.571-2.322 4.782 6.52 16.496-3.982 17.534-11.48 1.135-4.879-11.858 1.015-14.534",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1222.5 259c-57.03 0-116.58 1-173.54 1h-52c-7.091 0-17.304-1.865-24 0.603-17.482 6.445-25.631 31.868-43 38.504-18.978 7.249-44.08-5.593-63 1.635-14.95 5.712-22.13 28.961-38 32.94-15.265 3.827-36.799-5.604-51 1.497-5.945 2.973-16.841 13.026-17.851 19.821-0.852 5.73 13.235 21.324 0.847 22.534-11.204 1.094-4.413-11.919-0.996-15.534",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1223 268h-167.05c-17.06 0-33.96 1-51 1-8.967 0-20.296-1.864-29 0.318-4.898 1.228-8.584 6.266-12 9.682-8.427 8.426-18.97 23.718-30.039 28.437-18.301 7.802-42.083-3.175-60.961 1.997-15.211 4.167-22.272 27.198-37 32.824-12.918 4.935-30.486-4.227-42.999 1.755-7.636 3.65-7.406 18.903-15.002 19.441-5.105 0.361-8.231-6.13-5.137-10.021 2.77-3.483 8.258-2.756 12.138-2.433",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1224.2 276c-55.05 0-114.2 1-169.19 1h-50c-6.814 0-16.562-1.77-23 0.603-16.923 6.24-25.65 30.379-42 38.373-17.604 8.606-44.413-6.591-62 2.203-10.549 5.275-24.074 20.868-31.424 30.106-3.407 4.284-0.453 11.841-6.631 14.096-11.343 4.141-10.171-17.678 4.055-10.381",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1223.3 285c-16.4-2.028-37.671 0-54.301 0h-106c-19.21 0-38.89-1.196-58 0.69-5.395 0.532-11.828-0.882-17 0.899-16.085 5.538-25.801 27.844-40 36.808-13.727 8.665-36.962-3.541-52 3.616-18.572 8.839-27.837 33.666-46 42.963-6.087 3.116-19.69 3.569-26 1.015-3.766-1.524-6.221-5.147-10-6.54-4.099-1.512-11.887-0.134-12.534-6.493-0.474-4.66 5.351-8.194 9.32-5.926 3.514 2.008 4.026 6.359 4.214 9.968",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1223 295c-14.04-5.95-38.887-2-54.047-2-38.68 0-77.4 1-116 1h-40c-5.76 0-13.547-1.341-19 0.742-17.231 6.583-24.769 31.933-42 38.516-15.29 5.841-35.178-2.907-51 1.06-6.282 1.575-11.6 9.282-16 13.682-10.769 10.769-21.313 22.805-33.086 32.448-4.145 3.395-11.734 15.544-17.596 10.103-8.679-8.056 4.867-12.509 11.682-7.551m-100.89-88.153c-7.025 2.236-3.19 14.516 3.848 11.785 7.58-2.942 3.683-14.182-3.848-11.785",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1222.2 309c-11.57-9.457-24.738-8-39.158-8-22.67 0-45.28 1-68 1h-81c-10.4 0-26.25-2.983-36 0.742-17.393 6.645-25.477 32.684-43.039 39.07-14.487 5.269-37.846-5.488-50.961 2.791-14.774 9.327-28.573 26.971-41 39.397-4.798 4.798-9.857 11.75-16 14.821-14.174 7.087-35.744-2.257-51 1.496-9.06 2.229-11.208 24.231-19.891 19.64-10.802-5.712 1.768-11.939 7.891-11.957",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1222.3 359c-5.54 5.187-36.041 6.108-40.311-1.059-9.07-15.229 7.57-47.019-21.99-47.812-34.8-0.933-70.23 0.871-105 0.871-13.68 0-35.18-4.123-48 0.603-17.514 6.458-25.546 31.987-43 38.655-16.271 6.216-37.699-4.665-54 1.345-6.441 2.375-13.154 10.613-18 15.401-12.851 12.698-25.718 30.461-41 40.126-4.818 3.048-20.188-2.433-18.458 7.855 2.042 12.136 12.221 1.279 13.458-4.985",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1221.9 369h-52.904c-6.39 0-16.39 1.878-22-1.6-4.82-2.982-12.02-8.743-13.57-14.4-2.48-9.087 3.17-26.083-10.43-27.867-25.08-3.288-52.69-0.133-78-0.133-10.08 0-25.47-2.897-34.91 0.728-15.389 5.905-22.121 29.119-38.09 33.699-17.618 5.054-39.891-5.22-57 1.315-6.236 2.382-11.39 9.648-16 14.258-11.034 11.034-21.569 23.487-33.787 32.839-3.924 3.003-4.662 8.299-0.103 11.112 9.654 5.955 10.126-7.643 5.89-12.951",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1066.9 353.08c7.84 0.246 7.94 12.166 0 12.166-7.96 0-8.41-12.43 0-12.166",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1149.1 205.76c7.52-2.793 12.33 9.025 3.92 11.387-6.82 1.918-10.9-8.798-3.92-11.387",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1222.9 376c-29.41 0-63.71 3.151-92.92-0.129-4.95-0.556-12.56-1.431-17-3.68-4.08-2.068-8.84-7.677-13.57-3.498-4.1 3.632-0.51 10.486 4.57 10.595 3.83 0.082 6.68-3.773 9-6.288",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1002.1 370.76c6.97-2.72 12.25 8.41 4.81 11.361-7.077 2.808-11.954-8.572-4.81-11.361",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m930.11 380.03c6.907-3.765 13.424 6.968 5.831 10.77-6.545 3.277-12.761-6.992-5.831-10.77",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.018 127.97c7.2646-1.526 9.9205 10.453 1.9668 11.602-7.4031 1.07-9.1148-10.101-1.9668-11.602",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m70.109 241.05c6.6416-3.423 11.68 7.472 4.8326 10.906-6.853 3.436-11.676-7.379-4.8326-10.906",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.0568 343.08h253.03c15.455 6e-3 18.136 12.466 30.521 18.648 5.3766 2.6843 17.769 1.8518 23.629 0.78633 5.4839-0.99766 8.28-6.6396 13.784-7.4937 27.1-4.2069 57.223 0.55535 84.67-0.16021 3.463-0.0899 9.1182 0.28862 14.211-0.21871l0.0797-0.0106c0.62092-0.10243 1.5219-0.19441 2.5063-0.8276 0.8593-0.55273 1.0956-1.0272 1.5743-1.6517 2.854-3.7234 4.4089-9.5251 10.72-7.5685 4.8375 1.4994 5.2353 8.9725 0.99238 11.348-3.9514 2.2153-7.887-0.13567-11.207-2.2742",
    style: {
      fill: "none",
      strokeWidth: 0.98372,
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2 332h177c29.147 0 58.916-1.776 88 0.044 9.893 0.619 15.817 11.849 23.015 17.423 4.847 3.754 10.123 3.674 15.985 3.518 8.721-0.231 12.711-8.422 21-8.941 16.86-1.055 34.105-0.044 51-0.044 6.965 0 16.614 1.694 22.956-1.688 9.924-5.294 0.698-21.295 12.049-25.824 8.724-3.481 15.541 1.731 23.085 3.628 4.155 1.045 13.193-0.536 12.444 6.883-0.47 4.655-6.619 7.137-10.217 4.255-2.82-2.259-2.898-6.956-3.317-10.254",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2 315h282c15.746 0 36.83-3.716 52 0.434 6.319 1.728 8.99 9.079 15 11.101 4.215 1.418 17.531-8.432 17.248 3.45-0.226 9.558-11.059 4.458-13.248-0.985",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m498 3.1734c0 44.901 4.041 92.22-0.058 136.83-0.743 8.088-9.142 10.919-13.084 17.089-3.597 5.631-1.096 12.794-0.901 18.911 0.519 16.304-16.925 20.783-23.933 33.004-2.422 4.223-2.495 16.835-10.965 12.773-10.972-5.262 2.06-11.728 7.941-11.777",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m489 2.9826c0 4.9486 1.046 12.33-0.742 17.017-1.584 4.1499-5.841 6.6096-6.94 11-1.483 5.9235-0.562 13.912-0.299 20 0.254 5.8701 8.781 12.164 4.377 17.721-6.627 8.3604-14.229-4.9913-5.396-11.721",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m481 3.1098c-1e-3 5.7024 0.453 13.065-3.299 17.801-4.678 5.9043-13.928 9.8789-14.642 18.09-1.03 11.83-3.643 33.906 0.544 44.985 2.422 6.4075 9.726 8.5849 11.068 16.015 1.715 9.501 0.329 20.355 0.329 30 0 14.521 1.099 29.53-0.093 44-0.503 6.1-5.51 14.692-12.817 13.72-3.499-0.466-5.606-4.173-9.093-4.973-3.951-0.906-8.198 1.899-7.57 6.253 1.305 9.053 10.259 4.447 13.573 0",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m461.75 6.7454c6.265-4.1259 13.112 5.5042 7.248 10.099-6.387 5.0052-13.361-6.0732-7.248-10.099",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m449 3.237v57.763c0 7.2231-1.862 15.996-0.757 23 1.419 8.9979 12.701 13.246 16.578 21 2.27 4.54 1.179 11.068 1.179 16v36c0 5.397 0.536 11.565-4.214 15.297-7.096 5.575-16.964 0.585-24.785 3.292-7.726 2.673-8.391 23.398-17.853 18.075-11.015-6.198 4.595-11.661 9.852-11.664",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m419 2.6647v124.34c0 11.077-2.197 21.496-2.795 32-0.158 2.785 1.249 5.703 3.854 6.917 3.753 1.75 8.665-1.834 8.279-5.931-0.375-3.976-4.27-6.202-7.338-7.986",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m375 3.0462v97.954c0 14.103-3.108 32.337 0.318 46 4.227 16.86 32.392 21.321 31.638 41-0.684 17.85-18.255 9.293-26.808 17.344-6.265 5.897-1.543 16.243-3.582 23.652-1.27 4.618-5.625 7.248-6.886 12.008-1.249 4.711-4.843 13.39-11.282 8.25-9.936-7.932 6.526-11.253 11.602-11.254",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m358 3.0462c0 36.246-1 73.624-1 109.95 0 14.707-3.254 33.754 0.318 48 2.494 9.947 16.555 13.269 19.248 23.004 3.671 13.265-11.153 20.147-18.244 28.22-2.745 3.124-2.036 7.761 1.787 9.729 9.639 4.961 8.689-9.462 4.891-13.953",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m315.35 2.7919 0.06348 42.208c0.0133 8.8408 0.922 16.318-6.019 22.906-6.925 6.5738-12.853 3.3175-20.981 5.5278-5.807 1.5791-13.152 8.5485-16.258 13.566-4.052 6.5472-3.356 26.544-1.424 33.961 1.201 4.611 8.11 7.585 5.61 13.019-2.479 5.391-10.566 4.966-11.961-1.073-0.854-3.697 2.534-6.834 5.033-8.907",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m606.06 2.9016c0 8.0751 2.3005 22.752-1.5205 30.059-6.716 12.845-25.772 26.123-36.543 35.87-4.462 4.0371-11.233 8.3023-13.397 14.17-2.279 6.1817-0.603 15.462-0.603 22 0 19.372 3.248 41.963-0.228 61-2.869 15.711-23.431 2.397-28.169 15.005-3.129 8.329-1.724 22.728 6.398 27.331 4.38 2.483 11.486 0.426 13.337 6.682 1.513 5.113-4.95 9.209-9.11 6.224-3.592-2.577-3.217-7.339-3.228-11.242",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m629 22c0.112 5.443 2.265 11.755 0.142 17-7.802 19.275-35.767 27.638-44.963 46-4.043 8.0731-1.179 23.082-1.179 32 0 26.236 2.285 52.852 0.96 79-0.312 6.155-4.295 8.794-6.678 14-1.458 3.184-0.801 6.956-2.885 9.902-1.577 2.23-4.485 4.375-7.288 3.077-11.52-5.334 1.835-13.728 8.891-12.979",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m252.06 59.758c7.58-2.9182 11.914 8.2214 3.922 10.58-6.393 1.8867-10.681-7.9784-3.922-10.58",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m626.11 210.79c7.379-2.655 11.889 8.888 3.847 11.212-6.876 1.986-10.743-8.73-3.847-11.212",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m450.02 238.85c7.317-2.078 10.724 9.222 2.966 11.487-7.236 2.112-10.519-9.343-2.966-11.487m29.025 0c7.233-2.09 10.875 9.554 2.937 11.438-7.397 1.754-10.31-9.308-2.937-11.438m30-0.089c8.059-1.279 10.275 10.648 1.952 11.656-6.992 0.847-9.29-10.492-1.952-11.656m29.064 0.024c7.192-2.601 11.636 8.922 3.848 11.378-7.352 2.317-10.84-8.849-3.848-11.378m88.04 0.286c6.476-3.357 11.908 7.374 4.793 10.694-6.637 3.097-10.891-7.534-4.793-10.694m58.911-0.31c7.516-2.791 12.112 9.068 3.922 11.387-6.822 1.931-10.895-8.799-3.922-11.387m29.05 0.281c6.402-3.386 12.172 6.222 5.743 9.925-6.802 3.919-13.109-6.029-5.743-9.925m58.325-0.014c5.688-3.865 13.601 4.714 7.414 9.367-6.317 4.75-13.639-5.139-7.414-9.367",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m389.06 268.03c6.493-3.432 12.938 5.916 5.882 9.865-6.584 3.684-13.192-6.001-5.882-9.865",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m419.06 296.07c6.727-3.227 12.011 7.525 4.882 10.845-6.65 3.098-11.976-7.443-4.882-10.845",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m419.06 324.12c6.868-3.108 12.475 8.297 4.882 11.116-6.946 2.579-12.034-7.88-4.882-11.116",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m884 3c-3.839 3.8293-8.011 9.1238-13.089 11.312-7.349 3.1658-17.108 1.6883-24.911 1.6883h-50c-6.868 0-16.488-1.7239-23 0.5995-7.343 2.62-13.649 11.049-19 16.4-11.48 11.48-23.265 22.739-35 33.961-5.817 5.5623-15.285 11.258-18.258 19.039-3.158 8.2668 1.064 18.395 0.084 27-0.639 5.607-4.435 8.224-6.683 13-2.03 4.311-0.711 12.976-8.139 12.454-4.756-0.335-7.36-6.49-4.4-10.151 2.798-3.46 7.534-2.711 11.396-2.303",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m761 3c-8.788 4.0981-16.391 13.798-23.286 20.576-14.104 13.866-28.243 27.855-42.714 41.335-8.103 7.5482-20.953 16.05-25.972 26.09-7.019 14.038 6.33 35.54-5.086 48-4.65 5.075-11.8 9.772-14.914 16-2.189 4.377 0.154 9.63-2.056 13.996-2.288 4.521-7.385 6.768-10.079 11.019-2.759 4.355-1.764 17.353-10.834 14.072-4.261-1.541-5.226-7.469-1.741-10.345 2.824-2.33 7.277-1.74 10.682-1.742",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m944.15 64.072c6.445-3.3405 12.002 7.4759 4.793 10.644-6.623 2.9113-10.913-7.4721-4.793-10.644",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m959.15 97.047c6.221-3.3661 12.71 7.1119 5.742 10.755-6.841 3.578-12.364-7.172-5.742-10.755",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m926.43 118.03c6.152-4.12 13.299 6.01 6.418 9.936-6.175 3.522-12.157-6.094-6.418-9.936",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m712.23 155.03c6.595-3.987 13.415 5.892 6.544 9.939-6.079 3.579-13.076-5.99-6.544-9.939",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m939.02 169.97c7.399-1.549 9.8 10.462 1.963 11.602-7.401 1.078-9.109-10.107-1.963-11.602",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m804.02 181.92c8.063-0.692 9.549 11.626 0.994 11.626-6.818 0-8.176-11.01-0.994-11.626",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m366 3v103c0 16.399-2.37 34.809 0.148 51 1.007 6.475 14.446 20.763 20.227 23.817 4.005 2.116 9.077 0.076 11.553 5.24 2.498 5.21-4.267 9.547-8.7 6.911-3.712-2.207-3.217-7.271-3.228-10.968",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m560.17 3c-5.829 5.8284-17.913 13.256-18.891 22-0.361 3.2226-0.697 7.845 0.494 10.91 1.736 4.4708 7.989 8.133 4.369 13.694-5.233 8.0392-15.355-4.167-5.972-11.605",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m529 3c-6.481 6.2543-17.992 13.451-21.258 22-5.59 14.633-0.172 38.304 2.045 53 2.12 14.053 0.213 29.784 0.213 44 0 8.12-2.286 20.334 0.603 27.961 1.805 4.765 9.433 9.089 3.959 14.605-3.904 3.934-10.263 0.803-10.266-4.567-2e-3 -3.753 3.319-6.534 5.704-8.999",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m626.23 8.0316c7.618-4.537 12.627 6.7059 5.664 11.401-6.358 4.2876-11.778-7.7593-5.664-11.401",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m330.15 155.03c6.994-3.988 12.979 7.016 5.547 10.896-6.21 3.243-11.796-7.332-5.547-10.896",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m449.11 154.76c6.701-2.557 12.112 7.794 4.832 10.699-7.096 2.833-12.291-7.853-4.832-10.699",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m567.11 182.84c7.453-2.474 11.991 8.855 3.872 11.363-6.835 2.112-10.84-9.049-3.872-11.363",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2 735c2.5406-15.853 19.82-7.549 22.471 4 2.7721 12.076-0.4707 25.766-0.4707 38 0 9.29-2.9044 24.595 1.4568 32.982 4.1776 8.033 18.063 7.844 21.199-0.997 4.2723-12.044 2.2844-26.443 2.3449-38.985 0.0834-17.292 1.9992-34.697 1.9992-52 0-10.08-0.8413-29.448 14.999-26.768 9.7152 1.644 10.44 15.047 9.9113 22.768-1.7302 25.266-1.7633 50.699-2.8711 76-0.5244 11.975 0.6611 31.048 17.917 24.517 9.719-3.678 6.8596-21.391 7.0587-29.517 0.7254-29.612 2.9833-59.373 2.9853-89 1e-3 -10.916-3.7695-36.313 14-34.876 13.959 1.129 10.437 19.79 10.039 28.876-1.337 30.541-2.039 61.446-2.039 92 0 10.612-4.381 35.498 13 33.52 15.128-1.722 12-22.639 12-33.52 0-35.288-0.511-71.891 2.83-107 0.964-10.13-5.508-39.704 11.169-39.623 15.694 0.076 10.001 30.185 10.001 39.623 0 36.585 0.634 74.6-2.83 111-1.188 12.483-2.136 32.09 15.826 28.772 6.414-1.185 8.222-8.107 8.83-13.772 1.649-15.344 1.174-31.556 1.174-47 0-44.992 0.994-90.096 2.961-135 0.753-17.209-4.373-40.685 1.642-57 8.291-22.486 47.691-16 66.397-16h75c9.712 0 23.864 2.597 33-0.894 13.394-5.116 19.798-23.321 33-28.364 12.962-4.951 31.443 4.509 44-1.77 19.872-9.936 11.66-46.703 12.005-64.971 0.119-6.308 11.563-15.218 2.886-19.807-11.103-5.872-7.901 10.319-2.891 14.806",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.8329 576c28.648-28.057 59.836-54.767 89.167-82.09 11.592-10.798 25.389-30.009 40-36.396 14.383-6.287 39.429-1.514 55-1.514h130c7.938 0 19.56-2.124 26.961 1.009 4.459 1.888 6.319 6.872 10.464 9.013 4.143 2.139 13.631-1.07 13.823 6.99 0.106 4.406-5.513 7.631-9.189 5.341-3.763-2.345-4.012-6.392-4.059-10.353",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2 591c33.56-25.57 63.425-58.95 94-88.039 11.58-11.017 25.796-29.373 40.001-36.504 11.13-5.588 32.651-1.457 44.999-1.457h110c11.215 0 21.98-0.034 33 1.541 4.381 0.626 10.454-0.605 12.712 4.568 2.086 4.778-4.179 10.083-8.653 7.844-4.238-2.121-4.045-6.913-4.059-10.953",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.2818 605c31.385-31.298 65.618-60.487 97.718-91.039 9.947-9.467 19.703-19.164 30-28.246 4.047-3.57 7.837-9 13-10.973 5.964-2.278 14.687-0.742 21-0.742h44c31.475 0 66.848-6.082 98-0.775 8.719 1.485 12.229 11.064 20 14.033 11.807 4.51 26.813-1.995 39 1.06 7.274 1.823 10.999 10.532 18 13.079 4.387 1.597 10.391 0.603 15 0.603 10.1 0 23.187 2.228 32.961-0.318 3.369-0.878 5.02-4.082 8.078-5.46 3.343-1.506 7.147 0.411 8.338 3.821 3.831 10.968-10.604 6.337-14.377 1.957",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m257.87 818.09c0-11.97-3.078-42.064 3.691-52.087 9.932-14.706 34.306-24.53 39.783-42 5.423-17.295-0.246-40.834 1.483-59 0.487-5.11-1.099-11.45 1.773-16 3.346-5.3 11.116-13.186 17.397-14.686 5.493-1.312 11.939 1.289 16.945-2.056 8.624-5.763 1.845-17.201 8.334-24.11 6.285-6.692 17.384-0.906 24.721-7.281 10.086-8.764 24.118-19.319 30.991-30.867 4.227-7.102-0.812-17.021 7.064-22.397 8.778-5.991 22.629 2.04 31.945-3.46 14.561-8.597 23.312-28.934 39-35.285 5-2.024 11.706-0.743 17-0.873 10.336-0.253 20.606-0.985 31-0.985h144c5.229 0 12.07-1.138 17 0.858 9.015 3.65 28.413 21.506 30.517 31.142 1.767 8.094-2.515 19.769 2.225 26.911 10.266 15.466 27.285 1.091 39.125 9.692 7.693 5.59 1.753 17.847 8.281 24.169 7.082 6.858 19.933-1.175 25.279 8.283 5.647 9.988-2.525 25.277 10.859 31.828 3.824 1.872 8.63-1.372 12.396 1.145 7.518 5.024-5.977 19.579-11.118 7.928-1.064-2.411-1.235-5.371-1.564-7.956",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1207 554c0.04 4.219 0.19 8.76 4.11 11.378 4.48 2.994 9.63-1.428 8.55-6.363-1.62-7.442-9.68-3.998-14.24-7.203-12.73-8.95-24.39-30.626-41.42-30.633-12.8-5e-3 -16 12.587-27 14.593-16.79 3.059-37.92-4.909-54 0.827-10.23 3.651-14.52 18.01-26 19.292-20.14 2.249-41.73 0.109-62 0.109-11.245 0-25.034 2.177-36-0.303-7.289-1.649-10.64-10.127-18-11.469-23.38-4.26-51.204-0.228-75-0.228h-48c-5.594 0-15.082-1.35-19.682 2.599-7.887 6.771-1.844 29.203 5.683 33.877 4.528 2.813 11.757-0.942 14.237 5.629 1.821 4.822-3.461 9.922-8.18 7.672-3.779-1.802-4.545-6.068-5.058-9.777m-152-60c0.822 6.363 10.987 20.163 14.11 6.982 1.493-6.301-6.785-7.862-11.11-7.913-14.271-0.168-28.632-1.069-43-1.069h-82c-11.989 0-27.378-2.596-39 0.318-4.136 1.037-6.966 4.774-10 7.512-7.422 6.7-16.99 13.749-22.512 22.17-2.908 4.434-0.705 11.083-6.543 13.766-5.234 2.406-10.396-3.804-7.761-8.657 2.213-4.078 6.768-4.072 10.816-4.109",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m152.04 482.04c7.476-3.723 12.95 8.207 4.915 11.534-7.392 3.061-12.614-7.699-4.915-11.534",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2 634c37.675-28.705 69.821-66.395 105-98.17 10.678-9.645 21.969-25.621 35-31.817 6.135-2.917 13.704 0.62 20-1.755 6.797-2.563 10.632-9.897 17-13.079 4.541-2.269 11.067-1.179 16-1.179h59c9.27 0 19.877-1.437 29 0.228 4.201 0.767 5.938 3.959 9.285 6.087 4.031 2.562 16.711 0.771 13.914 9.641-4.028 12.774-12.473-2.245-13.199-7.956",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2 620c30.453-30.201 62.999-58.396 94-88.039 14.363-13.734 31.196-36.738 50-43.961",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.3716 648c31.632-30.979 64.172-61.466 97-91.17 12.523-11.331 26.328-30.542 41.628-37.817 10.413-4.951 28.559-0.319 40-1.102 39.545-2.709 79.381 0.594 119-0.93 10.21-0.392 13.348-10.934 22-14.239 8.252-3.152 21.211-0.742 30-0.742",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m417.23 526.03c6.696-4.04 13.794 5.529 6.662 10.21-6.51 4.274-13.492-6.089-6.662-10.21",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m327.15 526.03c6.92-3.943 13.175 7.056 5.743 10.922-6.786 3.53-12.277-7.197-5.743-10.922",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m387.11 555.03c7.034-3.811 13.195 6.818 5.832 10.951-8.697 4.882-13.769-6.65-5.832-10.951",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m209 818.85c0-27.308 2-60.529 2-87.85 0-16.755-2.857-36.665 1.317-53 2.931-11.47 19.368-14.535 21.378-27 2.413-14.959 1.231-32.826 1.304-48 0.029-6.052-1.892-15.542 2.319-20.424 4.11-4.766 10.7-12.767 16.682-14.973 6.695-2.468 16.91-0.603 24-0.603 17.655 0 35.473 0.304 53-0.129 6.563-0.162 13.448-1.973 20-1.58 3.093 0.185 5.84 2.339 8.999 1.971 2.804-0.328 5.538-2.539 6.339-5.277 1.36-4.649-4.04-8.648-8.294-7.199-3.631 1.237-4.741 5.021-6.044 8.214",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m228 818.2c0-18.361-0.342-40.908 0.91-59.197 0.396-5.782-1.006-12.361 0.408-18 2.471-9.855 15.746-14.041 20.225-23 5.098-10.196 2.457-28.741 2.457-40 0-18.722 1-37.313 1-56 0-8.169-1.854-17.557 4.059-23.999 13.343-14.539 45.43-8.001 63.941-8.001",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m267.13 496.76c7.532-3.042 12.456 7.463 4.823 11.195-6.937 3.392-11.954-8.315-4.823-11.195m89.966 0.271c7.496-4.128 14.345 6.882 5.857 10.737-6.458 2.933-12.962-6.825-5.857-10.737",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.5636 663c33.344-33.344 69.331-66.037 104.35-97.589 12.647-11.396 26.031-30.363 41.09-38.093 5.056-2.595 12.478-1.318 18-1.318h106c10.913 0 23.241 1.608 34-0.225 6.363-1.083 9.748-7.657 16-8.627 6.257-0.971 18.045-1.762 23.996 0.455 3.405 1.269 5.011 4.762 8.174 6.28 4.577 2.198 11.161-0.703 13.168 6.136 1.353 4.609-4.005 9.073-8.279 6.934-4.278-2.14-4.531-7.801-5.059-11.953",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m419.02 553.89c7.12-1.683 10.569 10.105 2.962 12.259-7.67 2.171-10.977-10.364-2.962-12.259",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m218 818.32c0.221-26.637 2-57.652 2-84.324 0-15.249-2.377-35.263 1.318-50 2.965-11.828 20.044-15.153 21.508-28 2.806-24.633-9.723-66.416 17.174-79.821 6.79-3.384 18.545-1.179 26-1.179h64c13.149 0 23.084 1.826 33-8",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m159.11 576.04c6.729-3.558 12.92 6.897 5.782 10.773-7.113 3.863-13.191-6.855-5.782-10.773",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m327.02 584.05c6.965-3.308 12.803 7.893 4.929 11.08-7.607 3.078-12.982-7.255-4.929-11.08",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m403 817.99c0-51.345 1-105.6 1-156.99 0-5.58 1.523-13.897-1.028-19-2.218-4.438-7.75-7.061-9.05-12-1.463-5.559 7.813-14.201-2.926-16.522-12.362-2.673-5.39 11.082 4e-3 14.522",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m271 818.07c0-11.365-3.942-35.946 1.573-46.031 8.526-15.593 31.169-23.656 38.199-40.054 4.92-11.476 2.228-33.424 2.228-45.985 0-6.07-1.55-14.154 3.148-18.852 6.067-6.067 15.124-0.564 21.833-4.89 7.758-5.003 3.677-12.518 7.047-19.258 4.07-8.141 12.916-12.786 18.654-19.224 2.056-2.307 2.902-5.803 0.714-8.342-3.178-3.689-10.071-2.338-11.024 2.61-0.697 3.62 1.767 7.117 3.628 9.956",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m246 818.58c0-12.934-1.6263-37.694-0.11026-50.541 0.59622-3.6161 1.0246-5.191 2.8-7.7518 7.199-11.113 20.92-18.895 30.31-28.285 4.038-4.038 9.79-8.291 11.427-14 4.207-14.666 1.573-36.657 1.573-52 0-5.829-1.634-14.676 1.028-20 3.111-6.222 18.739-23.031 25.972-23.944 3.738-0.472 6.239 3.656 9.999 3.648 3.418-8e-3 6.888-3.123 6.535-6.689-1.146-11.58-12.582-2.291-15.534 1.985",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m237 818.96v-41.96c0-5.425-1.037-12.136 1.858-17 9.901-16.635 35.221-25.605 42.248-44 2.521-6.598 0.894-16.025 0.894-23 0-17.21-2.195-39.211 1.279-56 0.94-4.544 5.093-9.718 9.721-10.821 4.515-1.076 11.693 0.703 12.338-6.183 0.497-5.3-6.016-8.427-10.035-5.253-3.019 2.384-3.15 6.752-3.303 10.257",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m266.09 613.79c7.772-2.725 11.389 8.886 3.887 12.128-7.216 3.117-11.83-9.342-3.887-12.128",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.058 641.9c8.0285-3.001 12.413 9.616 3.8997 12.297-7.064 2.224-11.055-9.622-3.8997-12.297",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1223.7 721h-62.682c-9.16 0-20.02-1.601-29 0.279-8.6 1.801-12.05 12.645-21 14.873-11.13 2.773-23.71 0.318-35 0.184-14.13-0.168-28.99 1.363-43 0.571-5.54-0.314-13.85 0.387-19-1.51-10.43-3.847-22.094-19.552-30-27.393-4.87-4.83-7.661-19.708-14.995-19.708-10.148 0-4.539 15.563 5.995 12.704m-948.96-11.238c-7.8507 2.839-3.1736 14.992 3.9367 12.101 7.7461-3.149 3.9729-14.962-3.9367-12.101",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m342 817.88c-5e-3 -46.031-1.832-96.91 1.044-142.88 0.378-6.046 6.97-14.806 12.165-17.872 3.863-2.28 12.63-3.226 10.168-10.038-1.793-4.962-8.472-6.068-11.634-1.862-2.377 3.163-1.192 7.203-0.743 10.772",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m394 817.88c0-19.276-0.804-42.623 0.039-61.879 0.623-14.219 3.506-30.908 0.617-45-1.894-9.234-12.978-14.847-18.338-22-8.069-10.769-0.581-26.685 6.682-35m4.059-10.953c6.877-3.441 12.127 7.681 4.882 11.13-8.85 4.215-12.494-7.322-4.882-11.13",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m386.15 673.03c7.24-4.171 14.042 6.792 5.808 10.925-6.891 3.458-12.266-7.205-5.808-10.925",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m381 814c-5.189-2.608-9.285-2.863-15-3.015-7.359-0.196-15.908-7.169-6.941-13.243 5.456-3.696 13.25-0.83 18.832-4.06 2.359-1.365 4.041-3.865 3.567-6.67-1.932-11.422-29.489-2.3-25.796-14.997 3.558-12.229 25.658-1.209 26.56-14.015 1.031-14.637-28.084-1.341-26.756-15.003 1.233-12.685 20.507-3.897 25.752-12.106 7.574-11.854-19.61-9.534-22.476-16.896-2.169-5.572-2.115-19.372 0.152-24.906 1.429-3.489 5.434-5.393 6.394-9.092 1.007-3.883-2.597-7.392-6.288-7.66-11.845-0.859-4.264 12.105 0 15.663",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m330 813c-4.517-11.242-19.053-7.984-29-8-4.609-7e-3 -11.473 0.329-13.377-5.054-1.851-5.231 3.985-8.973 8.377-9.721 6.576-1.121 31.364 4.05 31.364-7.185 0-4.262-5.193-4.925-8.364-5.025-6.018-0.188-25.364 3.055-25.364-7.018 0-9.305 12.859-7.142 18.364-8.721 5.003-1.435 11.171-6.808 13.682-11.365 2.967-5.385 1.187-13.957 1.333-19.911 0.351-14.321 0.985-28.615 0.985-43m-1.891-15.238c8.471-3.231 12.231 9.501 3.876 13.066-7.287 3.11-10.928-10.377-3.876-13.066",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m235.02 702.88c7.897-1.072 10.144 10.897 1.97 12.496-8.08 1.581-10.388-11.352-1.97-12.496m29.044 0.162c7.46-3.838 12.93 8.06 4.922 11.734-7.285 3.343-11.917-8.135-4.922-11.734",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1225.2 383c-28.43 0-63.966-3.047-92.206 0.109-6.07 0.678-9.15 6.596-15 7.663-14.39 2.622-31.36 0.228-46 0.228h-82c-12.167 0-27.138-2.38-39 0.303-17.765 4.019-24.732 31.54-42 36.263-14.685 4.017-33.783-0.193-49 0.473-10.427 0.457-23.818 3.5-34 0.308-3.987-1.25-6.386-4.65-10-6.462-4.522-2.267-12.262 0.101-13.458-6.9-0.838-4.911 4.975-8.418 9.129-5.953 3.484 2.067 4.132 6.32 4.329 9.968",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1222.3 390-48.367-2.2891c-7.8513-0.37158-23.287 0.85412-30.967 2.5921-8.16 1.847-11.09 11.564-19 14.044-13.66 4.283-33.69 0.653-48 0.653h-88c-10.94 0-27.728-3.184-38 0.603-5.472 2.018-9.979 8.376-14 12.397-9.214 9.214-18.433 18.403-27.83 27.424-4.033 3.872-7.548 9.374-13.17 11.062-6.942 2.084-26.835 2.8-33-1.089-5.305-3.347-18.955-19.91-24.941-17.774-5.831 2.079-4.131 9.706 0.96 11.464 3.502 1.209 6.339-1.136 8.981-3.087",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1221.8 396c-19.92 0-48.78-4.766-67.84 1.228-11.91 3.744-14.84 16.41-29 16.757-39.27 0.965-78.69 0.015-118 0.015h-35c-4.875 0-11.37-1.104-16 0.603-5.472 2.018-9.979 8.376-14 12.397-9.55 9.549-19.071 19.328-29.039 28.424-3.632 3.315-7.094 8.568-11.976 10.003-8.803 2.589-31.479 3.158-39.985-0.285-4.512-1.826-7.2-6.622-12-7.824-7.38-1.848-15.62 1.214-23-0.636-3.749-0.94-5.769-4.192-9-5.99-4.456-2.479-12.358 0.555-13.623-6.731-0.941-5.416 5.361-8.399 9.475-5.357 3.383 2.502 3.135 6.639 3.148 10.396",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1222 410c-19.28 1.522-42.085-2.328-60.975 0.188-8.21 1.095-11.55 9.626-19 11.494-16.87 4.229-39.58 0.318-57 0.318-29.35 0-58.72-0.321-88 0.961-11.636 0.509-25.703-2.475-37 0.357-5.314 1.332-9.168 7.021-13 10.592-9.836 9.166-19.459 18.592-29 28.091-5.163 5.14-10.218 12.226-18 12.905-11.442 0.998-28.926 2.685-40-0.34-5.729-1.565-8.875-7.386-15-8.352-12.478-1.968-29.331 3.883-41-1.152-8.128-3.508-14.409-12.761-21-18.486-4.508-3.917-8.664-9.948-14-12.687-3.449-1.771-7.603-0.063-10.852-2.492-2.228-1.666-3.493-4.625-2.525-7.338 3.535-9.91 12.669 0.543 12.377 6.941",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1092 441c3.04-1.753 6.46-3.452 9.98-1.782 4.82 2.289 6.26 8.645 0.91 11.281-7.9 3.894-8.48-7.438-13.12-10.181-4.22-2.5-11.06-1.318-15.77-1.318-26.19 0-55.1-2.538-80.982 1.189-7.281 1.048-5.502 12.326-13.015 12.326-5.414 0-8.067-7.515-4.565-11.197 3.067-3.226 7.747-2.226 11.562-1.318",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m959.15 452.03c6.915-3.948 13.192 7.082 5.743 10.921-6.341 3.268-11.957-7.372-5.743-10.921",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m980 454c0 13.971-13.321 31.881-27 37.106-8.378 3.201-21.107 0.894-30 0.894-21.864 0-44.182 1.313-66-0.044-8.779-0.546-14.37-6.878-24-5.782-5.377 0.613-8.857 4.888-14 5.678-8.567 1.315-19.859-2.554-27.917 0.89-5.897 2.521-2.968 18.256-13.024 13.707-10.832-4.9 1.776-12.393 7.941-12.449",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1222.2 417c-16.47 0-39.204-3.326-55.244 0.303-9.84 2.227-13.01 13.54-24 13.693-40.32 0.563-80.68 4e-3 -121 4e-3 -16.95 0-38.539-3.619-55 0.314-5.607 1.339-9.09 6.783-13.039 10.517-10.133 9.582-20.094 19.302-29.961 29.169-4.151 4.151-8.847 10.895-15 11.852-14.046 2.185-38.215 3.22-52-0.169-5.721-1.407-8.788-7.114-15-7.625-11.851-0.975-27.304-1.938-39 0.17-8.89 1.603-14.181 5.772-24 5.772-8.319 0-18.895-1.754-26.961 0.317-5.07 1.302-9.035 9.012-14.721 4.015-3.855-3.388-1.546-10.34 3.687-10.595 3.448-0.169 6.048 2.881 7.995 5.263",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1224.8 434.24c-21.1 0-30.53 23.125-46.93 33.258-12.95 8.002-35.52-1.571-50 2.06-8.17 2.048-11.15 12.585-20 13.573-11.67 1.305-21.1-4.943-27.26-14.891-3.84-6.217-2.97-13.788-11.75-16.486-11.16-3.428-27.33-0.514-38.99-0.514-4.36 0-10.79-1.171-14.85 0.603-5.92 2.585-1.2 12.175-9.16 13.919-5.354 1.172-9.853-4.675-6.383-9.294 2.939-3.913 8.083-3.585 12.393-3.228",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1222.1 452c-9.81 9.813-25.08 29.28-38.11 34.258-14.13 5.398-32.39-2.603-47 1.06-7.6 1.906-11.18 11.207-19 13.252-15.92 4.165-37.53 0.43-54 0.43-8.59 0-21.92-2.509-29.89 0.894-3.7 1.579-4.52 6.076-8.16 7.744-3.05 1.393-6.42 0.02-8.16-2.748-6.42-10.201 9.47-8.542 14.21-4.89",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1057 461.97c7.09-1.485 10.7 10.303 2.96 12.139-7.02 1.664-10.79-10.502-2.96-12.139",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1222.1 494h-55.065c-8.24 0-17.92-1.401-26 0.279-8.32 1.73-11.15 12.112-20 13.507-19.59 3.09-40.41-2.684-60 0.362-9.4 1.463-12.39 12.801-23 12.823-17.11 0.035-40.432 4.058-57-0.695-8.431-2.418-11.97-12.742-21-14.058-7.134-1.041-15.679 0.782-23 0.782h-59c-7.313 0-21.335 2.673-27.697-1.318-2.943-1.846-3.237-6.06-5.582-8.533-2.236-2.359-5.513-3.627-8.323-1.402-9.02 7.143 4.569 11.894 10.602 10.253",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1221.9 508.72c-8.56 0-20.495 0.7376-28.885-0.9984-4.66-0.963-7.46-5.287-12-6.404-10.14-2.492-24.74-1.777-35-0.169-8.75 1.372-12.21 12.249-21 13.638-19.16 3.028-41.3-4.468-60 0.648-8.93 2.441-12.1 13.608-22 14.472-13.79 1.203-28.15 0.094-42 0.094-6.829 0-15.386 1.375-22-0.434-8.662-2.369-12.523-13.402-22-14.457-29.541-3.29-61.258-0.109-91-0.109-10.113 0-22.094 1.771-32-0.279-5.164-1.068-7.99-6.155-13-7.403-5.456-1.359-17.935-1.812-23 0.71-4.44 2.211-6.884 6.221-12 7.338-6.517 1.423-15.003-1.357-20.999 1.662-6.319 3.181-8.269 24.831-17.852 17.418-9.73-7.527 5.455-11.442 10.851-11.446",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1221.8 522.75c-7.6795 0.35686-20.806 1.1595-27.796-2.5225-5.58-2.939-9.12-9.241-15-11.489-7.31-2.792-22.28-1.794-30-0.594-8.72 1.357-11.93 12.408-21 13.663-18.49 2.56-40-4.3-58 0.623-8.97 2.454-12.32 14.665-22 15.507-16.07 1.4-32.86 0.059-49 0.059-8.022 0-18.247 1.879-26 0.098-8.345-1.917-11.507-12.629-20-13.95-26.931-4.189-57.713-0.148-85-0.148-11.294 0-26.1 2.544-37-0.434-10.249-2.799-14.627-11.512-27-8.132-10.285 2.809-12.53 13.25-19.419 18.962-2.797 2.319-6.941 1.299-8.962-1.544-6.215-8.742 7.319-9.77 12.381-6.852",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1222.4 535.36c-4.5 0.112-19.112 0.9543-23.382-0.8837-9.18-3.955-13.91-14.616-23-18.538-5.64-2.435-15.95-1.506-22-0.829-9.06 1.012-12.26 12.071-21 13.663-13.46 2.453-29.31 0.228-43 0.228-4.77 0-11.42-1.175-15.91 0.603-8.63 3.416-12.17 15.964-22.09 17.264-17.7 2.32-37.13 0.133-55 0.133-9.27 0-21.004 1.938-30-0.318-8.678-2.176-12.561-13.187-22-14.493-26.563-3.676-55.27 0.811-82 0.811-12.001 0-31.623 3.757-42.698-1.148-3.031-1.343-3.631-5.269-6.411-7.094-3.089-2.028-7.128-0.977-8.844 2.351-4.747 9.209 8.486 8.668 12.953 4.891",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1139 586c3.54 4.861 16.22 7.79 13.34-1.988-1.11-3.763-5.59-6.478-9.3-4.79-2.84 1.295-4.19 4.576-7.25 5.46-6.1 1.764-14.46 0.318-20.79 0.318-13.22 0-26.82 0.936-40-0.055-12.67-0.952-17.62-19.263-30-20.176-28.66-2.114-58.195 0.231-87 0.231-18.964 0-40.277-2.757-59 0.148-6.913 1.073-15.896 10.709-18.718 16.852-2.161 4.703-1.174 13.289-9.267 11.522-10.826-2.364-2.005-14.148 6.985-11.522",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1226.9 614.02c-11.498 0.28192-18.391-0.44122-24.431 2.9178-3.83 2.135-5.77 5.986-10.42 6.834-6.5 1.184-13.58-1.061-20 0.546-5.05 1.265-7.74 6.494-13 7.454-18.4 3.353-40.27 0.267-59 0.228-13.16-0.027-16.72-13.004-28-17.258-7.49-2.825-16.01 1.668-23-3.315-7.92-5.65-14.9-18.358-25-20.199-14.08-2.565-30.675-0.228-45-0.228-5.579 0-13.897-1.524-19 1.028-12.653 6.326-19.304 26.297-34 28.667-20.177 3.254-43.467 0.305-64 0.305-7.201 0-18.445 2.103-24.961-1.314-6.686-3.506-10.655-10.998-17.039-14.944-4.095-2.53-8.72-0.849-13-2.484-4.737-1.81-8.09-6.592-11.995-9.664-4.392-3.455-10.094-13.385-16.777-9.411-5.134 3.053-2.557 10.247 2.777 11.17 3.583 0.62 6.5-2.254 8.995-4.353",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1003 606c-10.751 0-30.35-3.797-40 1.028-10.387 5.193-16.107 21.576-28 23.744-24.929 4.542-54.625 0.228-80 0.228-13.032 0-25.614-2.896-34 9",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m325.15 644.03c7.363-4.241 14.366 6.748 5.808 10.921-6.52 3.18-12.173-7.256-5.808-10.921",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1222.3 668h-132.34c-20.64 0-42.49 2.057-63-0.174-10.88-1.183-15.14-11.681-25-14.268-9.453-2.48-20.312 0.256-30-0.729-5.903-0.6-10.349-4.186-16-5.35-8.51-1.753-18.334-0.479-27-0.479-23.262 0-46.763 0.985-70-0.019-6.103-0.264-17.692-12.529-21.377-1.937-4.552 13.083 13.361 5.755 17.377 1.956",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m790 654c13.236 12.953 36.52 8 54 8h69c9.904 0 22.38-2.048 32 0.317 6.75 1.66 10.314 9.195 17 11.11 5.456 1.564 16.715 1.824 21.911-0.65 2.982-1.421 4.664-4.822 8.103-5.4 3.186-0.536 6.201 1.668 7.2 4.642 3.246 9.674-9.711 8.12-13.214 1.981",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1224.3 584.52c-7.64 0-18.99 2.092-26-1.318-10.91-5.311-17.32-17.991-28-23.824-4.55-2.486-10.01-0.335-14.86-2.341-5.37-2.227-4.42-12.466-12.12-11.14-5.03 0.864-6.01 6.99-2.7 10.305 2.98 2.988 7.02 2.186 10.68 1.318",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m780.02 552.97c-7.729 1.598-5.569 12.922 1.981 12.098 8.653-0.946 5.602-13.666-1.981-12.098m442.73 52.37c-8.337-0.2795-43.828 0.30585-49.263 2.0492-4.9457 1.5862-11.196 10.731-16.481 12.176-11.37 3.111-26.34 0.577-38 0.438-7.27-0.087-15.9 1.451-23 0.102-7.02-1.334-11.23-8.809-17-12.364-6.08-3.745-13.77 0.138-20-3.06-9.85-5.057-15.56-17.801-26-21.788-6.85-2.619-16.75-0.894-24-0.894-17.306 0-34.704-0.527-52 0.015-15.566 0.489-22.996 22.338-36 28.667-5.858 2.851-14.648 1.318-21 1.318-16.219 0-35.056 2.677-51-0.228-7.023-1.28-19.954-13.879-21.682-20.772-1.304-5.202 0.747-10.872-1.211-16-1.491-3.902-5.199-6.249-6.883-10-1.873-4.172-0.421-9.306-5.283-11.806-5.406-2.779-10.889 3.431-7.909 8.592 2.21 3.829 7.066 4.122 10.968 4.214m22.109-13.238c-7.446 2.844-2.317 14.072 4.847 11.476 7.993-2.895 2.135-14.144-4.847-11.476",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1223.6 597.16c-9.48 0-25.47 3.062-34-1.318-9.88-5.073-16.16-19.284-27-22.248-15.02-4.108-34.66 4.847-49-1.372-5.34-2.316-9.03-8.013-13-12.062",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1092 548.24c6.36-2.002 13.15 9.615 5.89 12.187-7.92 2.802-14.87-9.358-5.89-12.187",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m901.04 581.85c7.518-2.179 11.55 10.423 2.952 12.178-7.2 1.47-10.392-10.022-2.952-12.178",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1010 599.85c7.83-2.275 12.25 9.338 3.97 12.106-7.52 2.513-12.97-9.488-3.97-12.106",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1063 622.85c6.97-2.011 11.2 8.922 3.92 11.642-7.44 2.777-11.99-9.309-3.92-11.642",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1030 628.85c6.91-1.963 12.64 11.139 4.92 13.106-8.1 2.066-14.02-10.52-4.92-13.106m192.54 6.149c-13.06-0.108-30.665-3.054-43.525 0.318-5.65 1.48-7.71 7.866-14.04 8.573-25 2.794-51.83 0.109-77 0.109-14.1 0-37.76 4.5-50-3",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1165 817.92c-7.81-7.814-22.65-25.213-33.04-29.181-7.74-2.956-19.77-0.742-28-0.742-18.98 0-38.07-1.79-57-0.961-7.72 0.339-19.72 2.76-27 0.064-6.29-2.329-11.04-9.371-16-13.679-11.755-10.212-22.978-21.42-34-32.424-6.106-6.096-13.198-14.654-21-18.543-6.369-3.175-16.058-1.457-23-1.457-18.11 0-39.201 3.02-57-0.228-13.706-2.502-5.48-21.366-17.171-27.608-13.694-7.313-31.15 3.16-44.829-1.902-11.327-4.193-20.087-18.092-29-25.838-3.914-3.401-8.785-7.009-9.772-12.424-2.263-12.422 2.575-28.101-1.97-40-3.592-9.402-29.189-21.003-17.976-30.663 0.70398-0.60648 2.7796-1.3968 4.7182-0.33722 6.5793 3.5959 4.898 8.725 1 14",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1137.6 818.06c-8.3512-7.4133-25.581-6.0574-35.591-6.0574h-54c-8.06 0-18.17 1.642-26-0.318-8.55-2.141-16.99-13.679-23-19.682-12.016-11.997-24.646-23.444-37.004-35.089-5.482-5.167-11.257-13.113-18.085-16.478-7.481-3.687-19.757-1.433-27.911-1.433-22.749 0-47.52 2.993-70 0.181-13.97-1.747-22.624-23.026-35-29.154-5.551-2.749-12.46 0.715-18-2.055-7.433-3.716-11.544-13.576-20-15.655-8.102-1.992-18.583 2.527-26-2.059-13.267-8.203-8.978-26.857-9-40.258-8e-3 -4.675-1.828-10.519-0.432-15 1.276-4.097 4.811-7.697 7.432-11m5.109-12.214c7.684-2.765 12.021 9.02 3.872 11.935-9.37 3.353-11.165-9.311-3.872-11.935",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m780.11 641.76c6.598-2.606 14.287 8.392 7.573 11.638-7.35 3.553-16.44-8.136-7.573-11.638",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m872.06 671.07c6.813-3.303 14.263 6.738 5.932 10.897-7.145 3.566-13.622-7.17-5.932-10.897m324.21 146.98c-13.44-13.409-29.02-28.965-42.69-42.132-5.65-5.439-12.92-15.107-20.58-17.406-8.81-2.645-20.83-0.409-30-0.518-19.31-0.23-38.63-1.797-58-0.957-9 0.391-25.81 3.017-34-1.067-7.72-3.848-14.896-12.951-21-18.976-12.751-12.583-26.329-24.345-39-36.996-6.873-6.862-15.284-17.614-24-21.972-10.289-5.145-31.52-1.028-43-1.028",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m842.11 670.76c6.934-2.646 14.048 9.428 5.857 12.162-7.724 2.579-14.046-9.038-5.857-12.162m338.83 147.29c-10.59-9.751-24.31-22.539-34.63-32.578-4.54-4.41-11.016-11.32-17.306-13.041-8.33-2.279-19.38-0.434-28-0.434h-58c-8.23 0-20.26 2.214-28-0.742-7.37-2.817-13.41-11.875-19-17.219-15.014-14.356-31.083-34.948-49-45.475-10.18-5.981-27.68 0.085-39-2.387-7.615-1.662-11.179-10.582-18-13.743-6.633-3.075-14.852 0.149-22-1.733-5.572-1.468-9.58-6.589-15-8.701",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m812.04 670.8c7.521-2.466 11.807 8.992 3.937 11.81-7.339 2.628-11.963-9.178-3.937-11.81",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m751.11 670.79c8.036-2.89 13.144 9.78 3.876 12.363-7.264 2.024-10.922-9.829-3.876-12.363m399.02 147.41c-4.03-3.947-12.82-12.466-18.13-14.629-7.93-3.232-18.62-1.563-27-1.563-17.65 0-35.45-0.729-53 0.039-8.65 0.379-20.66 2.337-29-0.639-8.19-2.921-14.9-12.532-21-18.361-17.05-16.303-34.919-38.919-55-51.297-6.523-4.02-18.574-1.742-26-1.742h-48c-7.127 0-16.1 1.454-23-0.434-10.61-2.902-20.555-18.503-29-25.472-7.138-5.89-14.364-1.664-21.999-5.029-9.656-4.256-14.609-16.341-24.001-21.037-3.737-1.869-8.938-1.028-13-1.028",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1097.1 683.03c6.49-3.651 13.45 6.939 6.71 10.784-6.66 3.805-13.78-6.81-6.71-10.784",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1208.1 685.76c7.5-2.969 12.42 8.574 4.79 11.48-6.87 2.614-11.98-8.634-4.79-11.48",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1204 742c-3.95-0.699-8.56-1.355-11.39 2.279-3.04 3.899 0.27 10.753 5.39 10.255 7.8-0.758 5.37-8.886 7.89-13.49 2.91-5.305 12.074-5.041 17.284-5.044",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m733.13 337.76c7.55-3.054 12.361 8.76 4.758 11.29-6.473 2.153-11.647-8.504-4.758-11.29",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m716.13 402.89c7.524-3.038 12.987 7.639 4.848 11.156-6.459 2.79-11.925-8.299-4.848-11.156",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m738.11 452.07c6.36-3.134 12.697 6.982 5.758 10.734-6.966 3.765-13.291-7.022-5.758-10.734",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m747.11 496.03c6.907-3.765 13.424 6.968 5.831 10.77-6.545 3.277-12.761-6.992-5.831-10.77",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m358.13 410.04c7.361-3.889 12.755 7.312 4.897 10.885-6.672 3.035-11.674-7.304-4.897-10.885",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m867.04 436.85c7.361-3.889 12.755 7.312 4.897 10.885-6.672 3.035-11.674-7.304-4.897-10.885",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m420 467.09c7.361-3.889 12.755 7.312 4.897 10.885-6.672 3.035-11.674-7.304-4.897-10.885",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m714.55 496.27c7.361-3.889 12.755 7.312 4.897 10.885-6.672 3.035-11.674-7.304-4.897-10.885",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m420.57 409.79c7.095-3.214 12.401 8.283 4.896 11.806-7.186 3.374-12.215-8.491-4.896-11.806",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m502.41 402.97c6.6416-3.423 11.68 7.472 4.8326 10.906-6.853 3.436-11.676-7.379-4.8326-10.906",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m477.61 451.84c6.6416-3.423 11.68 7.472 4.8326 10.906-6.853 3.436-11.676-7.379-4.8326-10.906",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1095.8-13.828c-8.8116 11.453-21.236 21.204-31.505 31.453-4.5387 4.5314-9.609 11.672-15.753 14.014-9.9536 3.7975-23.146-3.1633-32.49 2.7273-13.734 8.6574-21.656 22.155-37.793 26.116m0.13393-0.03348c-0.61227 0.14546-1.5047 0.30002-2.4425 1.0003-0.8187 0.61128-1.0214 1.1011-1.4554 1.7574-2.5876 3.9133-3.7342 9.8093-10.166 8.2972-4.9302-1.1586-5.8479-8.5858-1.781-11.251 3.7874-2.4854 7.8773-0.41439 11.338 1.4875",
    style: {
      fill: "none",
      strokeWidth: 0.98372,
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m159.99 0.65429c-0.28896 13.946-1.0766 49.141-1.0766 65.826 0 8.1415-2.802 22.713 2.2822 29.487 15.024 20.019 38.033 36.402 55.806 54.059 7.0739 7.0278 17.276 20.295 26.582 23.844 5.3687 2.0474 12.927 0.72932 18.6 0.72932h0.0845c0.62928-7e-3 1.5338 0.0394 2.603-0.43659 0.93341-0.41554 1.2392-0.84852 1.8073-1.3929 3.3874-3.2457 5.807-8.7434 11.747-5.8491 4.553 2.2181 3.809 9.6646-0.74595 11.367-4.2425 1.5882-7.7745-1.3342-10.73-3.953",
    style: {
      fill: "none",
      strokeWidth: 0.98372,
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m232.55-2.3552c6.9065 5.534 36.774 32.947 37.16 32.975l0.15077 0.07154c0.98682 0.47801 1.5827 0.85479 2.4548 0.96971 0.75409 0.09937 1.4993-0.08709 2.2669-0.26009 4.5766-1.0314 9.4867-4.491 13.08 1.0538 2.7546 4.2499-1.7265 10.244-6.5063 9.3504-4.4535-0.82964-5.97-5.1558-7.1499-8.9246",
    style: {
      fill: "none",
      strokeWidth: 0.98372,
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m194.39 1.5016c11.631 11.58 24.638 23.982 22.656 38.244l-0.0112 0.08993c-0.0854 0.62349-0.26351 1.5115 0.0509 2.6389 0.27444 0.98418 0.65801 1.35 1.1134 1.9917 2.715 3.826 7.7992 7.0241 4.0669 12.476-2.8606 4.1793-10.118 2.3534-11.135-2.4016-0.95019-4.4293 2.4578-7.4955 5.481-10.036",
    style: {
      fill: "none",
      strokeWidth: 0.98372,
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m539.52 3.1545c-10.055 7.6484-18.127 15.483-18.706 28.504l-4e-3 0.08253c-0.0358 0.62829-0.13911 1.4004 0.26354 2.4994 0.35146 0.95938 0.76279 1.2937 1.2675 1.8974 3.0092 3.5991 8.3306 6.3849 5.0414 12.115-2.5209 4.3926-9.9001 3.1467-11.29-1.5129-1.2977-4.3402 1.8569-7.6665 4.6696-10.439",
    style: {
      fill: "none",
      strokeWidth: 0.98372,
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1079.8 227.16c7.52-2.793 12.33 9.025 3.92 11.387-6.82 1.918-10.9-8.798-3.92-11.387",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m450.67 266.34c7.2646-1.526 9.9205 10.453 1.9668 11.602-7.4031 1.07-9.1148-10.101-1.9668-11.602",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m419.32 267.41c7.453-2.474 11.991 8.855 3.872 11.363-6.835 2.112-10.84-9.049-3.872-11.363",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m446.43 672.53c6.696-4.04 13.794 5.529 6.662 10.21-6.51 4.274-13.492-6.089-6.662-10.21m57.533 145.52-37.978-37.146-13.791-15.207c-1.7448-1.924-2.2916-2.6613-2.5429-5.5203l-0.65114-20.184 0.74607-55.098",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1197.1 769.1c6.97-2.011 11.2 8.922 3.92 11.642-7.44 2.777-11.99-9.309-3.92-11.642",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m344.54 0.93144c-0.15607 0.48861-0.70929 1.3656-0.70929 1.3656-0.74933 1.4427-6.1664 0.45542-8.8138 0.39459-5.3086-0.12202-14.791 5.664-6.746 10.429 4.1075 2.433 9.2832-0.06133 13.503 1.7519 2.0823 0.89474 3.3041 2.9842 2.8542 5.2513-1.4433 7.2847-23.261 0.62975-18.843 11.624 2.8955 7.2081 18.786-1.3539 18.786 9.067 0 10.746-19.108 1.0152-19.108 10.816 0 10.198 22.947 1.4213 18.786 12.671-2.4869 6.7261-12.869 2.9362-18.035 4.3503-4.7327 1.295-3.4626 6.9011-7.2245 9.2042-4.7563 2.9126-30.764-2.4936-28.521 7.1541 1.0348 4.4562 6.4093 4.8982 10.09 4.9495 10.497 0.14606 21.007 3e-3 31.505 0.0037 3.9795 1.97e-4 10.61-0.94664 12.147 3.9886 3.1072 9.9796-19.096 6.4559-23.961 6.8815-3.4331 0.29979-7.7414 2.5831-6.3778 6.7654 3.5473 10.879 25.69-2.5782 30.26 8.0274 6.6919 15.534-4.3694 37.051 1.3212 52.97 3.4823 9.7446 18.289 5.9781 19.713 13.852 0.91266 5.0414-5.1137 8.2132-9.1759 5.6291-3.0983-1.9707-3.1102-6.4115-3.2519-9.6522",
    style: {
      fill: "none",
      strokeWidth: 0.98372,
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1224.2 708.27s-94.796-3e-3 -141.07 3e-3c-15.424 2e-3 -30.856 0.46762-46.273 0.0118-2.4784-0.0733-5.136 0.51109-7.4252-0.44133-2.9995-1.2479-4.9072-4.2616-7.2681-6.4933-0.083-0.0787-0.243-0.24307-0.243-0.24307-0.445-0.44499-1.2919-0.82772-1.9094-1.8222-0.5393-0.86776-0.5494-1.3978-0.7141-2.1671-0.9821-4.5875 0.1006-10.496-6.4396-11.433-5.013-0.71937-8.5762 5.8615-5.7616 9.8266 2.62 3.6955 7.1833 3.2589 11.1 2.7502",
    style: {
      fill: "none",
      strokeWidth: 0.98372,
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1111.1 355.11c0.1994 3.9441 0.5851 8.5121 4.6893 10.43 4.4043 2.0609 10.243-2.621 8.639-7.425-2.0914-6.2675-7.7111-4.1465-12.4-4.2931-0.7865-0.0246-1.3097 0.0602-2.2599-0.31544-1.0887-0.4299-1.7171-1.0817-2.1341-1.5531l-2.3406-2.6456c-4.0066-4.5287-8.1879-9.1688-13.624-11.51-4.9128-2.1172-11.499-1.0714-16.737-1.0714-12.494 0-24.889 0.9839-37.412 0.98292-5.7202 0-13.429-2.244-18.706 0.31256-13.163 6.3722-19.809 26.104-34.459 29.746-14.121 3.511-32.696 0.41184-47.258 0.41184-5.5784 0-13.801-1.5147-18.706 1.5756-8.088 5.0974-23.375 18.677-22.551 28.895 0.4775 5.9201 9.8434 11.751 6.7529 17.507-4.8725 9.0752-17.51-2.2636-6.8465-10.626",
    style: {
      fill: "none",
      strokeWidth: 0.98372,
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1228.3 423.94c-8.6344 0-24.879-2.706-32.509 1.8262-11.017 6.5482-17.456 22.323-29.536 26.932-12.444 4.7445-32.21 2.484-45.263 4.8123l-2.0226 0.36078c-0.6194 0.11049-1.4983 0.3301-2.4216 1.0498-0.806 0.62781-0.9987 1.1216-1.4193 1.7866-2.5073 3.9651-3.5337 9.8833-9.9951 8.5025-4.9528-1.058-6.0215-8.4649-2.0096-11.213 3.736-2.562 7.8672-0.57465 11.366 1.2564",
    style: {
      fill: "none",
      strokeWidth: 0.98372,
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1225.1 442.45c-19.848 0.23393-28.379 30.974-47.233 34.181-14.266 2.4258-30.284-2.9762-44.304 0.53372-7.0296 1.7584-10.072 10.175-16.737 12.719-12.179 4.6443-34.519 3.5186-47.258 0.71065-2.1916-0.48308-5.8689-1.9122-12.799-3.1718-13.035-2.3693-37.567-3.1709-50.354 0.41857l-9.9052 2.7805c-1.1684 0.35758-1.3415 0.7447-2.5099 0.81663-1.0197 0.0632-1.491-0.17924-2.2465-0.39922-4.5044-1.3114-9.1921-5.067-13.12 0.24592-3.0112 4.0721 1.092 10.331 5.9179 9.7335 4.4961-0.55367 6.2762-4.7782 7.6861-8.4671",
    style: {
      fill: "none",
      strokeWidth: 0.98372,
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1223.7 647.55s-26.068-3.2367-38.221 0.5927c-5.6694 1.7864-8.9131 6.1153-14.591 7.8739-12.54 3.8837-27.582 1.7944-44.555 2.2078-16.974 0.41337-39.759 0.19833-59.638 0.15323-10.502-0.0238-21.589 3.2338-31.505-0.2241-9.8365-3.4301-15.32-14.552-24.613-19.258l-0.5108-0.25863c-0.5614-0.28431-1.4831-0.39278-2.3753-1.1506-0.779-0.66111-0.9507-1.1625-1.3429-1.8447-2.3385-4.067-3.1153-10.023-9.6289-8.9149-4.9929 0.84892-6.3719 8.2044-2.479 11.118 3.6251 2.7167 7.836 0.9047 11.409-0.77768",
    style: {
      fill: "none",
      strokeWidth: 0.98372,
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1127.7 606.25c2.8586 2.7247 6.2818 5.774 10.579 4.3413 4.6139-1.5352 5.6287-8.9497 1.1595-11.332-5.8302-3.1087-8.4485 2.2972-11.952 5.4174-0.5876 0.52335-0.9089 0.94488-1.8569 1.3261-1.0859 0.43728-1.9889 0.37939-2.6172 0.34148l-16.483-0.99462c-5.2421-0.31631-8.4671-9.0064-13.784-10.087-8.2701-1.6808-17.781 2.3138-25.598-0.9495-10.121-4.2255-15.339-17.034-25.598-20.807-6.0844-2.2381-15.221-0.5927-21.66-0.5927h-46.273c-7.2521 0-17.77-1.9265-24.613 0.5927-13.363 4.9195-19.654 27.136-34.459 28.788-17.714 1.9766-41.548 3.1266-56.119-6.2946-4.2965-2.7777-17.31-1.0507-14.155-10.289 3.8111-11.158 12.836 0.44919 13.17 6.8617",
    style: {
      fill: "none",
      strokeWidth: 0.98372,
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1222.4 574.25s-13.075 1.2267-20.082-1.5933c-7.2374-2.9127-6.8525-5.7268-13.829-12.805l-0.3094-0.28236c-0.4383-0.45172-1.108-1.0614-1.5221-2.1563-0.3618-0.95551-0.2693-1.4774-0.2826-2.2642-0.079-4.6907 2.1235-10.279-4.1129-12.461-4.7803-1.673-9.5463 4.0968-7.5494 8.5305 1.8579 4.1316 6.4198 4.5834 10.361 4.84",
    style: {
      fill: "none",
      strokeWidth: 0.98372,
      stroke: "#76ff03"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "cpuNodes",
    transform: "translate(-1.802 -20.164)",
    style: {
      stroke: "#76ff03"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m630.03 382.7c6.791-3.877 13.449 7.068 5.793 10.745-6.4 3.074-12.071-7.16-5.793-10.745",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m599.69 413.34c6.677-3.639 12.821 5.918 5.831 10.182-6.392 3.899-12.818-6.374-5.831-10.182",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m661.37 473.81c6.956-2.655 11.85 7.8 4.832 11.166-6.899 3.31-12.303-8.316-4.832-11.166",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m539.02 413.07c7.361-3.889 12.755 7.312 4.897 10.885-6.672 3.035-11.674-7.304-4.897-10.885",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m630.49 413.11c7.361-3.889 12.755 7.312 4.897 10.885-6.672 3.035-11.674-7.304-4.897-10.885",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m660.89 413.05c7.361-3.889 12.755 7.312 4.897 10.885-6.672 3.035-11.674-7.304-4.897-10.885",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m660.9 382.7c7.361-3.889 12.755 7.312 4.897 10.885-6.672 3.035-11.674-7.304-4.897-10.885",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m660.87 443.8c7.361-3.889 12.755 7.312 4.897 10.885-6.672 3.035-11.674-7.304-4.897-10.885",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m539.16 474.22c7.361-3.889 12.755 7.312 4.897 10.885-6.672 3.035-11.674-7.304-4.897-10.885",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m569.38 474.28c7.361-3.889 12.755 7.312 4.897 10.885-6.672 3.035-11.674-7.304-4.897-10.885",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m599.93 474.21c7.361-3.889 12.755 7.312 4.897 10.885-6.672 3.035-11.674-7.304-4.897-10.885",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m630.48 474.27c7.361-3.889 12.755 7.312 4.897 10.885-6.672 3.035-11.674-7.304-4.897-10.885",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m539.02 351.97c7.361-3.889 12.755 7.312 4.897 10.885-6.672 3.035-11.674-7.304-4.897-10.885",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m569.38 351.88c7.361-3.889 12.755 7.312 4.897 10.885-6.672 3.035-11.674-7.304-4.897-10.885",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m600.04 351.85c7.361-3.889 12.755 7.312 4.897 10.885-6.672 3.035-11.674-7.304-4.897-10.885",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m630.56 351.85c7.361-3.889 12.755 7.312 4.897 10.885-6.672 3.035-11.674-7.304-4.897-10.885",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m660.85 351.67c7.361-3.889 12.755 7.312 4.897 10.885-6.672 3.035-11.674-7.304-4.897-10.885",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m569.51 382.58c7.361-3.889 12.755 7.312 4.897 10.885-6.672 3.035-11.674-7.304-4.897-10.885",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m569.44 443.55c7.361-3.889 12.755 7.312 4.897 10.885-6.672 3.035-11.674-7.304-4.897-10.885",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m630.49 443.5c7.361-3.889 12.755 7.312 4.897 10.885-6.672 3.035-11.674-7.304-4.897-10.885",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m569.62 413.37c7.361-3.889 12.755 7.312 4.897 10.885-6.672 3.035-11.674-7.304-4.897-10.885",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m600.09 382.09c7.095-3.214 12.401 8.283 4.896 11.806-7.186 3.374-12.215-8.491-4.896-11.806",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m539.23 381.95c7.095-3.214 12.401 8.283 4.896 11.806-7.186 3.374-12.215-8.491-4.896-11.806",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m539.23 443.25c7.095-3.214 12.401 8.283 4.896 11.806-7.186 3.374-12.215-8.491-4.896-11.806",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m600.17 443.01c7.095-3.214 12.401 8.283 4.896 11.806-7.186 3.374-12.215-8.491-4.896-11.806",
    style: {
      fill: "none",
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 524.11,
    y: 340.84,
    width: 152.36,
    height: 152.61,
    style: {
      display: "none",
      fill: "#450",
      opacity: 0.49728,
      strokeWidth: 1.0166,
      stroke: "#76ff03"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "circuits-full-board",
    transform: "translate(-210.08 -11.329)",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m699 3c1.995 15.787-5.42 20.437-16 31-4.158 4.1516-8.416 9.7302-14 11.991-10.124 4.0985-18.126-1.503-25.397 10.009-2.637 4.1751-1.603 10.276-1.603 15 0 11.471 3.379 29.269-0.742 39.999-4.7 12.237-19.576 6.465-29.258 8.229-4.722 0.861-8.897 5.061-11.682 8.772-3.053 4.067-2.318 9.193-2.318 14 0 10.704-2.337 24.545 0.468 34.896 1.245 4.593 7.168 6.571 6.159 12.086-0.868 4.745-7.725 7.271-10.598 2.736-2.89-4.56 1.094-9.481 3.971-12.718",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m907 3c-8.266 8.2662-20.436 25.403-32 28.566-6.9 1.8875-15.873 0.4337-23 0.4337h-48c-7.446 0-19.221-2.2103-26 1.179-6.144 3.0718-11.201 10.023-16 14.821-8.837 8.8335-18.134 17.176-27 25.999-4.375 4.3543-11.86 8.7742-13.566 15.001-3.711 13.543 5.574 34.943-2.037 47-6.519 10.326-19.072 19.351-27.811 27.686-2.46 2.346-6.438 2.879-9.152 0.572-3.706-3.151-2.018-8.899 2.585-9.922 3.864-0.857 7.076 1.517 9.981 3.664",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m930 3c-10.859 10.859-21.913 21.438-33 32.039-4.293 4.1048-8.987 11.135-15 12.643-7.829 1.9627-17.939 0.3179-26 0.3179-16.049 0-32.016 0.5938-48 0.9854-6.918 0.1694-16.457-1.7941-23 0.618-9.979 3.6788-20.523 17.957-28 25.397-5.087 5.062-13.588 10.784-16.972 17.089-2.745 5.1132-1.028 14.242-1.028 19.91v42c0 5.708 1.391 13.592-0.603 19-2.16 5.857-20.419 25.964-26.793 18.566-7.25-8.415 7.107-9.788 12.396-5.566m221-183c-13.156 13.156-26.674 25.985-40 38.985-4.929 4.808-11.999 13.51-19 14.786-22.76 4.1477-49.835 0.2284-73 0.2284-9.471 0-22.452-2.596-30 4.1088-9.992 8.8756-30.314 23.256-34.968 35.891-2.07 5.622-0.041 12.169-0.032 18v44c0 5.514 1.925 12.755 0.343 18-3.127 10.367-16.462 16.96-23.125 25-4.247 5.124 0.774 19.764-8.218 20.172-4.57 0.208-7.808-5.06-5.781-9.063 1.684-3.325 5.589-3.99 8.781-5.109m239-205c-13.139 16.504-31.066 30.066-46 45-5.357 5.3566-12.16 15.343-20 16.772-23.38 4.2606-51.204 0.2284-75 0.2284-12.031 0-25.642-1.5626-35 7.0903-7.726 7.1441-22.734 17.847-26.397 27.91-2.934 8.058-0.568 20.646 0.227 29 1.431 15.029 2.647 35.152-0.058 50-1.176 6.45-8.01 9.144-10.169 15-3.091 8.386 9.752 22.103 3.079 27.127-3.843 2.892-9.804-0.538-10.02-5.131-0.169-3.608 2.779-6.064 5.338-7.996m226-205c-16.836 16.836-33.955 33.358-51 49.985-5.955 5.809-14.898 17.365-23 19.581-7.758 2.1222-17.979 0.4337-26 0.4337-16.697 0-33.374 0.7985-50 0.9962-8.026 0.0954-22.005-2.7294-29 1.6033-5.637 3.4919-14.768 11.127-17.258 17.44-1.923 4.8725-0.742 11.802-0.742 16.961 0 11.891-1.719 25.248 0.148 36.985 0.818 5.145 8.073 8.252 6.205 13.971-1.851 5.663-9.926 5.903-11.655 0.025-1.281-4.35 2.656-8.145 5.302-10.981m287-147c-12.8 7.8411-38.24 3-53 3-5.19 0-12.229-1.2067-17 1.179-9.138 4.5692-16.669 15.771-24 22.782-19.249 18.406-37.841 40.619-59 56.725-5.355 4.0758-12.655 3.314-19 3.314-12.602 0-27.664-2.2739-40 0.2786-11.398 2.3583-22.906 19.859-30.996 27.682-4.661 4.506-24.338 8.737-19.81 16.825 5.089 9.088 12.911-1.117 11.806-7.786",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m568 4c0 10.358 3.555 28.919-1.858 38-9.221 15.468-34.221 23.865-40.539 41-2.184 5.9243-0.603 14.738-0.603 21 0 18.26 3.779 41.266-0.533 59-1.449 5.957-8.13 12.441-12.726 16.316-3.188 2.688-8.265 4.535-7.824 9.644 0.527 6.111 8.323 6.771 11.132 1.931 2.155-3.713-0.078-7.703-2.049-10.891m64-176c0 11.489 4.115 32.964-1.858 43-8.312 13.966-29.839 21.541-35.539 37-4.457 12.089-0.196 31.356 0.358 44 0.267 6.11 1.54 15.212-0.564 21-1.337 3.681-5.168 6.05-5.905 10-0.586 3.143 1.442 6.429 4.527 7.338 11.026 3.247 7.338-10.471 1.981-14.338m76-148c-3.089 10.449 3.088 25.53-2.857 34.91-8.635 13.625-25.544 24.922-37.143 36.1-4.059 3.912-9.756 7.6721-12.062 12.99-2.427 5.598-0.938 13.996-0.938 19.999v45c0 5.986 1.486 14.333-0.603 20-2.137 5.796-14.769 18.299-20.44 20.928-3.265 1.514-7.106-0.652-8.156-3.971-3.255-10.287 10.391-6.255 14.199-2.957m102-183c0 3.1263-0.55 6.944 0.603 9.9105 1.631 4.1988 6.864 6.7171 4.789 11.981-3.558 9.0257-17.294-1.2493-6.392-9.8912m33-12c0 4.9689 1.038 11.318-0.858 16-2.273 5.6119-12.24 15.932-18.146 17.566-4.846 1.3418-10.237-0.6422-14.996 1.176-6.177 2.3599-15.861 11.684-19.397 17.258-4.274 6.7385-3.253 29.265-1.285 36.985 1.23 4.8244 6.988 7.2896 5.498 12.971-1.364 5.203-9.147 6.191-11.197 0.911-1.816-4.675 2.517-8.8376 5.381-11.867m81-91c0 5.7805 1.344 13.538-0.742 19-3.484 9.1199-22.603 26.493-31.258 30.821-8.723 4.3617-17.788-2.1399-24.258 8.1828-8.761 13.98 4.365 36.685-1.484 51.996-1.895 4.96-8.915 12.091-14.258 13.227-4.73 1.005-11.621-3.968-14.238 2.882-1.685 4.41 2.636 9.199 7.195 7.889 4.042-1.162 5.381-5.347 6.043-8.998m109-125c-21.434 16.331-38.102 38.715-59 55.772-7.984 6.5165-20.559-0.0112-25.258 12.229-6.577 17.133 7.144 40.142-1.06 56.999-3.449 7.086-17.523 21.558-24.852 24.548-2.762 1.126-5.937 0-8.721 1.194-3.126 1.341-4.648 4.976-2.915 8.04 4.49 7.936 13.182-0.068 11.806-6.782m238-152c-8.093 4.5331-17.992 3-27 3h-55c-7.092 0-17.486-1.886-23.996 1.3179-10.202 5.0208-20.361 18.393-28.29 26.512-15.187 15.553-38.201 29.997-49.972 48.209-6.106 9.4485 9.3 19.029 2.82 25.523-3.602 3.611-9.769 1.524-10.275-3.58-0.419-4.23 3.053-7.233 5.713-9.982m209-91c-6.925 5.6397-14.194 17.158-23 19.566-6.9 1.8872-15.872 0.4337-23 0.4337h-48c-7.446 0-19.221-2.2103-26 1.179-6.181 3.0903-11.303 10.016-16.286 14.741-11.243 10.661-22.759 21.13-33.714 32.08-4.699 4.6967-13.477 10.485-15.486 17.015-3.888 12.632 5.29 32.602-1.607 43.815-2.756 4.48-9.73 11.554-14.907 12.852-6.782 1.7-17.001-2.384-20.397 6.358-3.22 8.292-1.544 23.527 6.398 28.321 4.622 2.79 11.257 0.314 13.862 6.654 1.836 4.468-3.805 8.454-7.804 6.701-4.365-1.913-4.733-7.624-5.059-11.716",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m918 4c-8.513 8.4901-17.485 16.488-26 25-3.959 3.9576-8.231 9.5277-14 10.721-21.446 4.4376-48.065 0.2786-70 0.2786-7.698 0-20.223-2.3691-27 1.7384-13.686 8.2954-24.173 23.057-36.039 33.69-4.787 4.2893-13.011 10.062-14.643 16.572-4.156 16.578-0.318 38.877-0.318 56 0 5.98 1.802 15.566-1.028 20.981-4.972 9.514-17.901 1.405-24.744 8.247-5.846 5.847-2.132 15.503-3.456 22.772-0.801 4.395-4.587 6.935-6.031 11-1.515 4.262-2.111 14.041-9.682 10.716-11.594-5.091 2.66-12.236 8.941-11.716",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m982 4c-17.992 17.992-36.968 35.056-55 53.001-7.004 6.9699-16.266 20.534-26.015 23.486-23.019 6.9705-50.871-4.3642-73.896 1.831-12.274 3.3028-13.036 16.625-18.831 24.534-2.055 2.804-6.097 3.92-8.94 1.544-8.696-7.267 5.525-11.004 10.682-10.396",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m860.06 125.79c7.294-2.558 10.982 9.025 3.882 11.417-7.206 2.427-10.975-8.929-3.882-11.417m29.96 0.015c7.292-2.254 10.306 9.212 2.938 11.348-7.131 2.068-10.286-9.077-2.938-11.348",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m804 153.97c7.532-0.445 8.535 10.354 0.999 11.41-7.678 1.076-8.778-10.951-0.999-11.41m86.058-0.181c7.519-2.632 11.764 8.243 3.922 11.32-8.843 3.469-11.148-8.79-3.922-11.32",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m22 3c5.411 12.823 1.0217 29.506 1 43-0.059 36.685-3 73.332-3 110 0 12.775-6.3814 40.53 2.3048 50.576 21.901 25.328 56.851 4.008 84.695 12.367 6.939 2.083 12.056 9.114 17 14.057 8.508 8.508 17.485 16.485 26 25 4.701 4.701 9.683 11.325 16 13.896 10.399 4.232 28.7 1.104 40 1.104h92c7.4 0 16.786 1.548 23.961-0.318 3.609-0.939 5.45-4.706 9.054-5.599 2.729-0.677 5.684 0.68 7.149 3.05 2.616 4.235-1.751 8.794-6.161 8.455-3.506-0.269-5.839-3.171-8.003-5.588m-287-270c4.2721 4.2725 10.929 9.1678 10.253 16-0.5043 5.0963-8.6168 9.3567-4.6343 14.772 3.262 4.4352 10.384 2.7362 11.245-2.7754 0.6111-3.9145-3.2878-6.7835-5.8634-8.9962",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m146 4c-0.049 5.9331 0.475 15.687-2.179 21-2.013 4.029-6.371 6.484-7.503 11-4.109 16.391-1.318 39.024-1.318 56 0 8.283-2.846 23.108 2.318 30 15.26 20.367 38.63 37.035 56.682 54.999 7.185 7.15 17.547 20.648 27 24.259 5.453 2.083 13.238 0.742 19 0.742h42c10.4 0 23.958-2.312 34 0.434 4.059 1.11 6.313 4.796 10 6.504 4.322 2.001 12.935-0.16 13.454 7.074 0.371 5.18-6.174 8.233-10.11 5.242-3.544-2.694-3.33-7.272-3.344-11.254",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2 422c72.324 0 144.76-1 217-1h71c10.179 0 23.125 2.154 33-0.318 13.113-3.282 18.817-22.672 32-25.403 8.08-1.675 17.756-0.279 26-0.279h53c8.357 0 20.082 2.104 28-0.728 8.632-3.087 16.589-13.974 22.999-20.257 15.49-15.183 31.666-29.68 47.001-45.015 6.636-6.636 15.475-19.411 25-21.686 15.282-3.65 35.266-0.314 51-0.314 32.127 0 64.943-1.962 97 0.044 7.289 0.456 10.011 6.783 16 9.777 6.172 3.086 24.564 2.896 31 0.437 14.531-5.553 4.912-18.65 12.318-27.114 5.223-5.968 13.507-2.042 19.682-5.886 10.263-6.387 16.146-19.652 27-25.079 5.899-2.949 15.547-1.179 22-1.179h45c6.333-2e-3 15.033 1.385 21-0.893 7.354-2.809 13.551-11.658 19-17.107 12.18-12.18 24.817-23.817 37-36 5.142-5.142 11.061-13.607 18-16.258 10.253-3.916 27.05-0.742 38-0.742 27.81 0 56.18 0.185 84-1.019 11.27-0.488 14.99-14.901 26-16.676 10.55-1.701 22.32-0.305 33-0.305h66",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59 179c-2.2011 2.739-5.0418 6.349-8.9954 6.172-5.1594-0.231-7.6913-7.212-3.6867-10.568 5.8965-4.94 11.96 3.843 17.686 4.337 13.127 1.135 26.817 0.059 39.996 0.059 5.445 0 12.999-1.321 18 1.179 5.001 2.501 8.818 7.764 13 11.397 12.775 11.097 25.005 23.488 37 35.425 5.441 5.414 11.54 14.153 19 16.72 4.836 1.665 10.944 0.256 16 0.28 9.323 0.044 18.623 0.999 28 0.999 32.946 0 66.072-1.019 99 0.015 10.909 0.343 14.868 13.62 26 13.97 6.595 0.206 14.565 1.175 19.992-3.264 4.893-4.002 5.963-21.246 14.899-16.527 10.265 5.421-1.926 11.752-7.891 11.806",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m51 3c8.7605 7.1342 22.761 17.632 27.566 28 3.1312 6.756 0.4336 17.621 0.4336 25 0 20.714-1 41.276-1 62 0 7.494 1.4494 21.583-2.6034 28-10.79 17.085-32.779 2.82-42.369 22-1.7926 3.585-0.8526 8.135-1.1173 12-0.2491 3.637-1.5131 7.432-0.1674 11 9.0668 24.038 47.283 16 67.257 16 4.595 0 10.631-1.007 15 0.603 4.308 1.589 7.608 6.026 11 8.973 11.193 9.722 20.807 21.125 32 30.848 3.775 3.279 7.298 8.073 12 10.012 13.37 5.515 34.706 1.564 49 1.564h111c10.507 1e-3 15.838 5.478 23.857 11.799 3.56 2.808 5.285 9.427 11.124 7.554 6.177-1.982 5.501-10.458-0.996-11.205-3.334-0.383-5.66 1.857-7.985 3.852m-289-268c6.2147 6.2146 19.196 14.336 21.566 23 3.5005 12.797 0.9317 31.826-0.1212 45-0.5013 6.2719-2.0187 15.166 1.0116 20.961 3.4951 6.6842 11.955 12.396 17.543 17.325 9.659 8.519 18.571 18.02 28 26.803 22.271 20.746 43.813 42.314 65.83 63.335 9.574 9.14 18.97 21.473 30.17 28.544 6.694 4.226 18.349 2.032 26 2.032h61c7.111 0 21.211 2.687 26.852-2.318 12.051-10.693-5.109-20.86-7.031-29.697-1.026-4.717 6.2-15.332-3.822-15.608-10.992-0.304-3.788 10.838 1.001 13.623m-255-193h9m25 0c2.372 2.3633 4.835 5.4919 8 6.8063 4.362 1.8115 10.322-0.36738 12.712 5.2508 2.072 4.8702-4.324 9.2408-8.565 6.8997-3.659-2.0201-3.855-7.2955-4.147-10.957m33-8-3 39m38-39c14.433 10.997 8.609 18.084 12.318 33 1.267 5.0948 8.717 9.972 3.94 15.566-3.374 3.9506-9.773 1.4531-10.001-3.581-0.188-4.1448 3.14-7.2306 5.743-9.9846m0-35c11.814 11.781 27.482 20.174 23 39m-11-39c13.349 13.349 27.496 25.842 41 39.015 5.36 5.2291 11.55 14.429 19 16.556 10.883 3.1064 29.89 4.3072 35.682-7.5702 5.807-11.908 1.175-29.516-10.682-35.428-5.043-2.5144-12.441 2.7763-15.449-3.6813-4.129-8.8658 11.243-11.309 11.449 0.1088m-70-9c7.015 5.6302 12.131 6.838 21 6",
    style: {
      display: "inline",
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m301.06 210.76c7.359-2.732 11.478 7.876 3.922 10.95-6.742 2.743-10.887-8.365-3.922-10.95m88.364 0.27c6.093-3.968 12.351 5.932 6.349 10.349-6.345 4.669-12.333-6.452-6.349-10.349m117.72 0.014c6.446-3.525 12.557 5.895 5.743 10.168-6.361 3.988-12.185-6.645-5.743-10.168",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m687 654c-0.868-3.654-1.891-8.568 1.434-11.393 4.252-3.614 11.083 1.198 10.189 6.354-0.959 5.536-6.629 4.7-10.233 7.062-8.245 5.403-14.364 18.274-10.787 27.977 2.631 7.135 12.05 13.77 17.397 18.985 7.816 7.624 18.837 22.39 29 26.273 5.453 2.083 13.237 0.742 19 0.742 17.528 0 41.121-4.183 58 0.434 13.094 3.581 18.962 22.229 32 26.633 6.224 2.103 16.35-0.017 23-0.064 17.998-0.127 36.001-3e-3 54-3e-3 7.992 0 18.364-1.729 26 0.854 9.011 3.048 16.57 13.467 23.17 19.98 12.786 12.618 25.903 25.824 39.83 37.166m-278-161c-10.657-9.405 5.936-17.32 8.029-7.895 1.137 5.119-5.665 6.787-6.287 11.154-2.761 19.409-4.33 52.171 15.258 62.427 5.756 3.014 13.737 1.314 20 1.314 14.758 0 30.331-1.427 45 0.174 16.018 1.748 21.204 22.823 36 26.508 7.254 1.807 16.537 0.318 24 0.318h51c7.948 0 18.493-1.791 26 1.148 8.303 3.251 14.616 12.816 21 18.763 16.751 15.603 33.167 31.584 50 47.089",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m542.04 550.8c6.969-2.194 11.811 8.781 3.937 11.413-7.58 2.533-11.935-8.895-3.937-11.413m87.065-0.015c7.936-2.859 10.624 8.553 2.876 11.467-8.373 3.149-9.334-9.14-2.876-11.467",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m751.13 700.76c7.686-3.103 13.205 8.707 4.823 11.619-7.154 2.486-12.091-8.685-4.823-11.619m90.976-0.011c7.194-2.944 13.437 7.399 5.832 11.206-6.631 3.32-13.585-8.034-5.832-11.206m30.039 0.285c6.809-3.882 14.093 7.096 5.832 10.896-6.477 2.979-12.254-7.233-5.832-10.896",
    style: {
      display: "inline",
      fill: "none",
      stroke: "#0a0a0a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m629.11 582.79c8.203-2.951 11.64 9.943 3.847 13.003-6.826 2.68-10.97-10.44-3.847-13.003m30-0.024c7.08-2.702 13.005 8.665 4.847 11.452-7.098 2.424-12.324-8.6-4.847-11.452",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m698 595c12.788 12.349 9 29.245 9 46 0 6.216 1.243 14.019-0.653 19.996-1.068 3.368-3.879 5.192-5.474 8.174-2.381 4.452 0.449 10.511-5.006 13.494-5.246 2.868-11.47-3.263-8.673-8.555 2.329-4.406 7.543-4.097 11.806-4.109",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m685 624c-9.101 11.187-5.581 17.111-8.279 29.996-1.051 5.022-5.991 7.421-7.863 12.008-2.232 5.47-1.683 16.218-0.63 21.996 1.057 5.797 6.802 10.073 10.772 13.996 8.554 8.454 17.49 16.494 26 25.004 4.106 4.106 8.431 9.979 14 12.107 6.342 2.422 15.301 0.893 22 0.893 17.36 0 36.861-2.518 54 0.148 13.247 2.061 18.831 22.254 32 25.534 7.839 1.953 17.932 0.318 26 0.318h54c8.243 0 19.17-1.854 27 1.032 6.021 2.22 10.308 8.545 15 12.682 12.727 11.226 24.998 23.284 37 35.286",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m628.28 672.03c6.222-3.879 14.921 6.359 9.118 10.943-6.349 5.015-16.911-6.086-9.118-10.943",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m486 553c-6.988 0.063-18.733 9.793-6.956 13.338 8.536 2.569 7.68-9.134 9.845-13.338 2.817-5.471 10.073-11.999 16.111-13.467 9.794-2.38 21.945-0.533 32-0.533 22.032 0 44.045 2e-3 66 0.88 10.961 0.438 25.408-4.184 36-0.138 9.113 3.482 18.194 15.452 25 22.258 5.943 5.942 12.983 14.83 20.286 18.972 3.236 1.836 7.286 0.544 10.566 2.485 2.722 1.611 3.934 5.362 3.119 8.409-1.303 4.875-7.935 3.613-10.653 0.83-2.65-2.713-2.659-7.163-3.318-10.696",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m625 562c-19.035 20.669-5.107 57.016-9.148 83-1.89 12.152-18.643 15.052-17.762 29 0.739 11.688 0.91 23.258 0.91 35 0 5.486-1.243 12.804 0.742 18 3.47 9.083 16.47 17.212 23.258 24 9.708 9.708 22.873 28.579 36 33.272 7.658 2.738 18.921 0.728 27 0.728 15.621 0 31.395 0.644 47-0.039 9.851-0.432 20.144-2.238 30-0.517 15.634 2.729 21.827 26.915 38 27.538 29.237 1.124 58.739 0.018 88 0.018 10.708 0 26.81-3.066 36 3",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m658 626c-1.394-2.775-3.236-5.74-2.522-8.985 1.767-8.032 13.604-5.841 12.86 1.967-0.415 4.35-5.267 5.455-8.114 7.782-4.282 3.499-7.164 9.253-11.224 13.221-8.851 8.652-27.062 20.264-31.397 32.015-2.563 6.951-0.603 17.635-0.603 25 0 5.873-1.653 14.793 1.742 19.911 8.637 13.018 24.791 24.583 36.219 35.255 4.864 4.542 9.654 11.653 16.039 14.092 7.991 3.052 20.501 0.742 29 0.742 24.725 0 52.596-3.648 77 0.148 14.183 2.206 20.052 25.596 35 25.972 26.28 0.661 52.705-0.12 79-0.12 9.944 0 24.638-2.727 34 0.738 9.303 3.444 17.169 14.431 24 21.262m-258.96-203.15c7.957-2.295 10.979 9.296 2.941 12.101-8.957 3.126-10.47-9.929-2.941-12.101",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m615 815c-16.167-16.167-32.783-31.86-49-47.999-6.347-6.316-14.27-11.711-19.566-19.001-3.388-4.664-1.091-10.333-4.037-15-6.246-9.893-19.137-15.436-24.37-26-4.054-8.184-1.027-23.942-1.027-33 0-18.621-7.587-49.905 15-56",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m567 656c-1.217-3.9-3.365-8.937-0.258-12.566 4.013-4.686 11.838-0.171 10.881 5.563-0.838 5.027-5.964 5.832-9.209 8.701-7.088 6.268-15.519 17.243-11.811 27.302 4.685 12.707 22.021 20.422 29.978 31 4.479 5.955 1.354 13.19 5.022 19 5.341 8.459 15.281 15.038 22.398 22.015 11.246 11.024 23.147 27.818 37.038 35.412 8.257 4.514 23.727 1.573 32.961 1.573 15.23 0 30.807 0.951 46-0.089 9.187-0.63 22.305-3.511 31 0.523 8.003 3.712 16.227 13.947 22 20.566m-123.85-172.96c7.312-4.058 13.055 7.504 5.743 11.803-9.156 5.385-12.432-8.09-5.743-11.803",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m604 541v72c0 9.057 3.183 21.492-0.148 30-2.496 6.376-9.13 11.278-13.852 16-3.362 3.362-7.848 6.765-10.126 11-1.833 3.408-0.994 7.679-3.463 10.852-1.767 2.271-4.643 3.458-7.352 2.101-10.923-5.47 1.953-13.105 8.941-11.953",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m721.02 582.21c7.959-0.424 9.258 11.922 0.981 12.116-7.712 0.181-8.939-11.693-0.981-12.116",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m420.01 582.97c9.437-0.564 7.997 12.312-1.007 12.785-8.395 0.441-5.645-12.387 1.007-12.785m118.05 0.105c7.036-3.373 12.054 7.954 4.882 11.49-8.567 4.225-12.266-7.951-4.882-11.49m30.074-0.025c6.357-3.348 13.069 7.173 5.808 10.91-6.965 3.585-12.998-7.123-5.808-10.91",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m631 599c0.515 8.96-0.525 18.026 0.089 27 0.381 5.55 2.036 11.557 0.021 17-3.948 10.667-16.539 15.635-22.368 25.004-2.703 4.344-0.873 9.252-0.757 13.996 0.278 11.325-3.39 28.379 0.618 38.985 2.979 7.88 15.431 16.049 21.397 22.015 9.452 9.452 22.349 27.425 35 32.258 7.485 2.859 19.046 0.742 27 0.742h54c8.084 0 18.14-1.616 26 0.317 11.198 2.755 18.144 18.32 28 24.119 7.696 4.529 23.232 1.564 32 1.564h63c8.347 0 20.128-2.114 28 0.893 5.573 2.129 9.884 7.991 14 12.107",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m720.1 611.79c6.971-2.476 12.272 8.297 4.836 11.341-7.753 3.173-12.986-8.446-4.836-11.341m30.004 0c7.684-2.765 12.021 9.02 3.872 11.935-9.37 3.353-11.165-9.311-3.872-11.935m31.906 0.23c8.71 0.224 8.323 13.126 0.024 12.322-6.897-0.668-7.877-12.523-0.024-12.322m28.044 0.031c6.444-3.226 12.964 6.987 5.832 10.759-6.983 3.692-13.442-6.95-5.832-10.759",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m422 628v104c0 11.965-3.846 32.068 1.434 42.961 2.637 5.442 9.223 10.031 13.57 14.128 8.551 8.062 16.687 16.602 24.996 24.911",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m538 657c-3.133-4.603-5.546-19.185 4.941-14.588 3.587 1.572 4.889 6.103 3.03 9.48-1.748 3.176-5.945 3.861-7.368 7.241-1.319 3.136-0.603 7.538-0.603 10.867 0 8.538-2.829 23.287 1.028 31 4.93 9.86 16.894 15.57 23.538 24.089 3.019 3.871 1.982 8.939 4.868 12.911 10.654 14.665 26.731 26.322 39.566 39.004 10.654 10.527 21.466 25.132 34.039 33.254 6.331 4.089 18.677 1.742 25.961 1.742h59c8.693 0 19.487-1.959 27 3",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m657 657c-2.399 8.115-3.82 29.305 0.028 37 6.002 12.003 21.54 21.684 30.972 31.004 7.074 6.989 15.584 19.447 25.039 23.106 6.3 2.439 15.297 0.89 21.961 0.89 17.36 0 36.861-2.518 54 0.148 13.157 2.047 19.108 22.281 32 25.534 12.292 3.102 26.559 1.259 39 0.407 14.203-0.972 28.762-0.089 43-0.089 8.347 0 20.128-2.114 28 0.893 15.922 6.083 30.341 27.817 43 39.107",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m454 672c3.07 4.505 2.538 16.928-5.941 12.878-8.112-3.873-2.865-13.113 3.941-13.878",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m639 684c6.966 6.141 5.512 12.41 10.573 18.83 8.488 10.77 20.668 19.531 30.427 29.174 7.835 7.741 15.596 18.291 25 24.103 5.872 3.628 15.354 1.893 22 1.893 17.231 0 40.406-4.105 57 0.434 12.67 3.465 18.167 22.036 31 25.248 8.123 2.034 18.635 0.318 27 0.318h58c8.356 0 20.116-2.106 28 0.893 12.492 4.753 23.744 20.85 33 30.107",
    style: {
      display: "inline",
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m630.06 701.12c7.095-3.214 12.401 8.283 4.896 11.806-7.186 3.374-12.215-8.491-4.896-11.806",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m456 583c-3.937-0.409-8.679-0.434-11.238 3.228-2.859 4.089 1.619 9.754 6.233 9.306 8.448-0.821 6.068-16.619 15.006-19.931 8.286-3.07 21.197-0.502 29.999-0.607 20.285-0.241 40.641-0.996 61-0.996 9.516 0 21.912-2.198 28.721 6.019 7.06 8.52 3.333 28.451 3.278 38.981-0.023 4.421-0.224 9.324-4.213 12.142-7.521 5.314-18.556-1.771-25.638 5.086-5.616 5.439-1.406 13.267-3.89 19.772-2.042 5.346-7.669 7.911-8.199 14-0.576 6.608-2.029 19.004 0.969 25 5.712 11.424 20.387 18.992 28.342 29 4.531 5.701 2.912 12.614 6.948 18 8.373 11.175 20.636 20.386 30.683 30.039 9.35 8.984 17.844 19.545 27.999 27.617 9.187 7.303 29.734 3.344 41 3.344h50c6.602-3e-3 14.675-2.523 21-0.107 6.338 2.422 10.531 9.255 16 13.107",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m486 596c-5.958-0.054-18.945-8.181-7.891-12.381 8.428-3.203 8.197 6.764 10.165 11.381 4.035 9.467 10.708 11.488 10.726 23 0.052 32.226 1.37 64.808-0.039 97-0.496 11.321-8.572 25.742-2.933 37 7.651 15.277 22.865 3.878 33.972 10.742 6.461 3.993 11.481 11.003 16.999 16.169 12.567 11.762 24.815 23.903 37.001 36.089",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m414 595c-19.077 19.239 0.259 35.79-4e-3 58-0.346 29.274-0.996 58.649-0.996 88 0 10.94-3.184 27.728 0.603 38 1.753 4.754 6.912 8.515 10.397 12l24 24m86-220c-7.268 8.919-20.221 16.5-25.012 27-4.611 10.107-0.988 28.932-0.988 40 0 11.323 0.263 22.681-0.015 34-0.13 5.307-1.951 10.776 0.047 15.961 3.515 9.116 15.799 15.144 21.534 23.039 3.573 4.918 1.295 11.082 4.868 16 17.127 23.577 43.931 43.365 64.566 64",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m419.02 612.79c8.068-1.095 10.925 11.796 2.937 13.614-7.224 1.644-11.442-12.46-2.937-13.614m23.981 11.214c0.073-6.178 7.811-17.867 12.953-7.891 1.802 3.496-0.811 6.984-3.972 8.443-8.862 4.089-19.736 5.669-19.976 18.448-0.545 29.014-1.005 57.945-1.005 87 0 9.229-3.369 26.719 1.028 34.911 2.833 5.278 9.738 9.855 13.972 14.089 11.91 11.91 24.942 23.321 36 36m-7-190c-0.853-3.594-1.712-7.68 1.318-10.562 3.719-3.539 11.046-0.849 11.046 4.562 0 6.27-7.343 5.659-10.974 8.024-3.66 2.383-10.024 10.794-11.072 14.976-2.036 8.121-0.318 18.637-0.318 27v58c0 9.804-2.831 24.782 0.603 33.985 2.338 6.269 10.778 11.419 15.397 16.016 12.697 12.636 25.334 25.333 38 37.999m20.004-202.38c8.417-1.919 11.757 10.094 2.981 11.895-8.132 1.668-12.022-9.835-2.981-11.895m24.996 9.383c0.687-3.475 1.181-7.859 5.059-9.214 5.249-1.834 10.808 4.286 7.333 9.066-4.038 5.553-9.311 0.46-14.392 1.559-5.074 1.098-7.419 6.624-12.039 8.58-6.232 2.637-18.875-2.4-22.933 4.237-4.786 7.828-1.028 27.651-1.028 36.772 0 8.742-2.431 21.769 0.603 30 3.81 10.333 17.559 17.3 24.079 26 3.206 4.278 2.108 9.685 5.662 13.961 21.569 25.944 49.759 48.142 73.656 72.039",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m447.15 643.03c6.772-3.859 13.86 6.924 5.807 10.746-6.875 3.263-12.432-6.969-5.807-10.746",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m478.06 642.88c8.842-3.551 12.648 9.748 3.926 13.063-6.766 2.571-10.999-10.224-3.926-13.063",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m480 658v73c0 8.08-2.727 22.267 2.318 29 2.941 3.924 7.779 9.28 12.682 10.562 8.82 2.308 20.312-2.878 29 1.466 6.101 3.05 11.227 10.199 16 14.972 9.239 9.239 19.662 17.973 28 28",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 450,687 -1,53 0.742,23 16.243,17.911 L 501,815",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m507.23 741.03c6.814-4.053 14.28 6.247 6.663 10.726-6.773 3.982-13.461-6.683-6.663-10.726",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1105 3-27.01 25.821-19.99 1.1936-46 0.9854m107-28c-8.95 11.652-21.57 21.573-32 32-4.61 4.6102-9.76 11.875-16 14.258-10.11 3.8635-23.51-3.2183-33 2.7747-13.95 8.8079-24.61 32.62-41 36.65-6.98 1.7162-15.826 0.3171-23 0.3171-17.242 0-34.802-0.9434-52 0.3812-7.356 0.5666-10.901 7.9421-18 8.5601-11.568 1.0071-28.324-3.672-39 1.1983-19.789 9.0274-30.398 34.074-49 45.132-6.881 4.091-20.132-2.203-25.397 4.046-4.767 5.658 0.157 16.166-1.265 22.682-0.966 4.425-5.215 6.875-6.735 11-1.664 4.518 0.155 10.89-6.618 11.547-5.115 0.496-8.723-5.026-5.381-9.268 2.685-3.408 7.496-3.246 11.396-3.279m352-178c-12.85 12.853-25.72 25.713-39 38.09-5.31 4.9461-10.45 12.607-17 15.883-10.6 5.3017-25.93-4.1219-35.58 4.4221-20.89 18.52-40.46 39.067-60.421 58.621-7.347 7.199-16.262 20.523-25.999 24.243-5.196 1.985-12.514 0.742-18 0.742h-39c-5.775 0-13.719-1.393-19 1.318-7.278 3.736-13.279 11.961-19 17.682-11.181 11.181-22.818 21.818-34 33-8.858 8.858-15.648 18.979-29 19-3.789 6e-3 -8.269-0.642-11.961 0.318-4.141 1.077-11.912 10.41-15.435 2.454-4.38-9.895 7.834-9.576 12.396-3.772m375-212c-15.18 15.182-30.83 29.834-46 45-5.11 5.1036-14.86 11.751-16.68 19-2.26 9.0223 0.24 19.885 0.64 29 0.17 3.8207-0.74 8.458 1.07 11.985 4.64 9.052 16.62 13.526 22.27 22.016 11.64 17.505-9.45 38.695-23.3 47.257-8.01 4.947-24.79 1.742-34 1.742-20.38 0-40.61 1-61 1-9.276 0-22.155-2.31-31 0.564-7.812 2.538-14.378 11.816-20 17.436-11.181 11.177-22.82 21.82-34 33-5.374 5.374-11.13 13.386-18 16.821-6.12 3.06-16.298 1.179-23 1.179h-43c-6.562 0-14.651-1.257-20.999 0.573-10.674 3.076-15.601 17.561-26.001 21.534-9.089 3.472-21.628-2.789-30 2.496-9.849 6.218-17.32 22.151-29 25.079-13.787 3.457-30.826 0.318-45 0.318-30.044 0-60.008 1-90 1-11.989 0-27.378-2.596-39 0.318-8.061 2.021-15.091 12.941-21.039 18.397-17.621 16.164-34.517 33.132-52 49.459-6.209 5.798-13.517 17.083-21.961 19.392-10.337 2.828-24.292 0.417-35 0.434-22.88 0.037-46.055 0.583-69 1.005-8.878 0.163-12.693 8.656-21 9.806-20.53 2.842-43.261 0.189-64 0.189-6.313 0-15.036 1.536-21-0.742-5.43-2.075-8.218-7.816-14-9.395-14.712-4.019-29.528 1.087-41 9.137",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m886 165c-14.51 14.51-29.494 28.494-44 43-6.519 6.519-13.689 16.665-22 20.821-4.54 2.27-11.068 1.179-16 1.179-12.746 0-27.465-2.056-40 0.228-14.158 2.58-20.974 22.524-34 27.624-16.052 6.285-36.45-2.683-53 1.466-13.941 3.495-19.411 24.801-34 27.454-23.076 4.196-50.515 0.228-74 0.228-7.477 0-16.744-1.469-24 0.43-9.276 2.428-18.451 15.021-25 21.57-15.009 15.009-30.911 29.088-46 44.004-6.769 6.691-14.782 18.107-24 21.396-8.59 3.066-21.906 0.6-31 0.6-24.18 0-48.872-1.466-73 0.044-9.644 0.603-14.086 11.414-24 11.916-14.048 0.712-34.45 3.313-48-0.394-8.369-2.289-11.4-10.799-21-11.476-51.438-3.629-104.42-0.09-156-0.09-8.3401 0-21.376-2.423-28.83 1.899-12.523 7.262-20.383 24.159-34.17 29.359-8.5459 3.224-21.908 0.742-31 0.742",
    style: {
      display: "inline",
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m569 225-1.009 19-20.991 22.004-52 49.996-36.715 31.51-17.285 15.596-32 0.894-73 0.019-15 7.663-37 0.209-20-10.872-216-0.019m1039-133c10.64 16.414-21.41 8.685-6.99-0.822 1.23-0.809 2.6-0.897 3.99-1.178",
    style: {
      display: "inline",
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2 264c8.1141 0 21.912-2.638 29 1.742 9.709 6 16.548 20.852 29 21.243 87.139 2.733 174.81 0.015 262 0.015 19.727 0 45.413-4.843 61.576 6.475 3.996 2.798 17.936 0.418 13.816 10.311-4.432 10.641-12.339-1.913-12.392-7.786m243.23-30.968c6.436-3.851 13.586 5.964 6.623 9.936-6.101 3.479-13.066-6.082-6.623-9.936",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2 275c15.46 0.13 20.298 14.009 32 21.397 4.7855 3.021 12.565 1.603 18 1.603 80.533 0 162.7-4.588 243 0.911 18.296 1.253 37.655 0.834 55.985 0.227 5.157-0.17 14.654-8.963 17.303 0.881 2.667 9.914-10.244 8.652-13.288 0.981",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3 290c5.1613 5.161 11.049 13.602 18 16.258 6.4729 2.472 16.139 0.742 23 0.742h268c9.508 0 21.814-2.078 31 0.434 4.699 1.285 7.283 6.067 12 7.248 10.696 2.677 18.123-1.762 27.424 6.1 3.837 3.243 19.749 1.811 15.353 11.175-5.339 11.373-12.753-1.245-12.777-7.957",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m300.06 323.8c7.372-2.452 11.637 8.631 3.902 11.441-7.36 2.675-11.467-8.925-3.902-11.441m24.945 8.203c0.97-8.686 14.268-11.703 13.338-2.011-0.913 9.514-11.5 3.351-16.338 4.766-9.617 2.813-15.13 14.687-27 7.351-7.39-4.566-11.821-13.937-20-17.248-7.904-3.2-20.539-0.858-29-0.858h-244",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2 341h257c15.698 6e-3 18.421 12.683 31 18.972 5.461 2.731 18.048 1.884 24 0.8 5.57-1.015 8.41-6.755 14-7.624 27.526-4.28 58.122 0.565 86-0.163 8.569-0.223 30.833 2.319 24-11.985m-12 9 4-9",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m219.04 400.71c8.102-1.337 9.731 10.523 1.946 12.338-7.963 1.857-10.074-10.996-1.946-12.338",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160.06 402.03c7.361-3.889 12.755 7.312 4.897 10.885-6.672 3.035-11.674-7.304-4.897-10.885",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m388 430c3.259-3.641 17.791-10.147 15.248 0.957-2.22 9.696-16.481-0.945-22.248-0.957-24-0.049-48 0-72 0h-273c-10.976 0-23.288-1.55-34 1",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3 548c26.53-26.53 55.137-50.853 82-77.015 7.4516-7.257 15.196-14.199 22.715-21.395 3.751-3.59 8.058-8.97 13.285-10.272 9.009-2.244 20.721-0.318 30-0.318h62c36.388 0 72.612-1 109-1 15.272 0 32.986-2.508 48 0.228 12.71 2.316 16.482 16.713 21.934 25.602 2.663 4.341 10.453 13.149 0.062 15.418-10.072 2.2-6.729-10.72-1.996-14.248",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3 562c27.157-27.154 56.178-52.569 84-79.039 7.8672-7.484 16.118-14.542 24-21.996 4.487-4.245 9.138-10.513 15.001-12.817 6.216-2.443 14.436-1.148 20.999-1.148h199c5.153 0 12.11-1.2 17 0.603 6.653 2.453 12.607 10.424 12.96 17.397 0.399 7.87-2.346 18.647 7.041 22.258 3.882 1.493 8.915 0.742 12.999 0.742 10.393 0 27.289 3.245 35.995-3.419 5.618-4.299 4.636-15.878 11.049-17.73 4.242-1.225 9.667 3.747 7.819 8.09-2.09 4.916-8.537 4.676-12.863 4.059",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1075 4c-3.24 3.242-6.6 7.5782-11 9.2577-17.2 6.5707-39.72-4.8795-57 1.8904-9.555 3.7426-8.793 20.229-17.012 21.425-5.064 0.7371-8.499-5.2927-5.381-9.2947 2.831-3.6335 7.447-2.9781 11.393-2.2786",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1070 105.97c6.78-1.449 10.12 9.337 2.92 11.317-7.18 1.972-10.45-9.707-2.92-11.317",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1144.2 140.04c6.64-3.688 13.37 7.189 5.79 10.723-6.37 2.973-12.25-7.134-5.79-10.723",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1102 141.79c7.04-2.422 12.31 7.422 4.85 10.533-6.97 2.907-13.24-7.645-4.85-10.533",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m725 276c-4.12 5.111-17.046 7.331-13.377-2.941 3.547-9.932 16.608 5.3 24.377 0.341 6.3-4.022 10.706-12.401 18.015-14.747 9.41-3.021 20.746 2.134 29.985-1.395 8.504-3.249 12.475-14.675 22-16.111 19.726-2.973 42.034-0.147 62-0.147 7.525 0 17.891 1.822 25-0.893 10.089-3.854 19.463-17.573 27-25.107 13.828-13.823 28.156-27.157 42-41 7.852-7.852 16.522-18.609 26-24.412 9.879-6.048 27.11-1.986 38-1.717 23.17 0.572 46.7-0.871 70-0.871",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m784 297c-0.982 7.104-11.784 15.245-13.377 3.988-1.391-9.824 9.877-5.024 14.377-5.422 3.073-0.272 5.784-2.941 8-4.856 8.026-6.938 15.896-19.952 26-23.678 6.519-2.403 15.157-1.032 22-1.032h44c5.992 0 14.325 1.48 20-0.603 6.661-2.446 12.181-10.034 17.17-14.821 13.33-12.793 26.615-25.7 39.83-38.591 5.24-5.111 11.011-13.573 18-16.243 9.751-3.725 25.6-0.742 36-0.742 27.63 0 55.39 0.807 83-0.015 12.29-0.366 15.37-13.997 26-16.667 10.6-2.662 23.14-1.318 34-1.318h61",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m813 294c-3.807-0.404-8.728-0.713-10.971 3.147-2.397 4.124 0.728 10.538 5.956 9.141 6.687-1.787 4.555-8.727 6.904-13.288 3.044-5.91 12.647-15.546 19.111-17.486 16.217-4.869 40.039-0.514 57-0.514 6.765 0 15.887 1.537 22-1.938 6.881-3.912 12.33-11.576 17.999-17.023 11.405-10.957 22.812-21.85 34.001-33.039 5.878-5.878 12.838-15.784 21-18.436 10.73-3.486 26.73-0.564 38-0.564 27.57 0 55.45 0.173 83-1.019 11.29-0.489 14.81-14.887 25-16.753 9.12-1.67 19.73-0.228 29-0.228h59",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m745 397c0.016 4.432 0.043 9.747 5.019 11.632 4.866 1.843 9.511-3.992 6.949-8.407-2.584-4.453-7.947-3.15-11.968-4.673-3.104-1.176-5.067-4.063-8-5.524-3.186-1.587-6.828-0.9-9.999-2.731-12.782-7.379-9.001-24.776-9.001-37.297 0-5.07-1.054-11.498 1.742-15.999 7.244-11.659 22.638-7.652 34.258-8.016 7.275-0.229 10.336-6.801 17-7.837 14.109-2.194 35.272 5.149 48-2.086 12.942-7.357 22.305-29.066 37-32.744 13.376-3.348 31.196-0.318 45-0.318 6.03 0 13.682 1.325 19-2.032 17.162-10.835 33.704-31.337 47.714-46.057 6.337-6.657 15.604-19.106 24.286-22.308 9.25-3.411 24.16-0.603 34-0.603 26.59 0 53.44 1.081 80-0.039 4.43-0.187 10.27 0.207 14-2.409 5.74-4.031 9.92-12.448 17-14.234 25.17-6.351 57.12-1.318 83-1.318",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1220 250c-17.21 5.086-41.03 1-59 1-50.11 0-101.05-2.51-151 0.911-13.62 0.932-29.769-2.91-43 0.407-4.898 1.228-8.584 6.266-12 9.682-8.139 8.138-20.186 24.409-31 28.397-19.336 7.129-44.594-5.838-64 2.167-14.667 6.05-21.202 26.587-36 32.578-17.197 6.962-39.656-6.754-55 6.287-8.56 7.275-23.103 18.414-28.033 28.571-2.322 4.782 6.52 16.496-3.982 17.534-11.48 1.135-4.879-11.858 1.015-14.534",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m760 362c-3.417 3.615-10.208 16.628 0.996 15.534 12.388-1.21-1.699-16.804-0.847-22.534 1.01-6.795 11.906-16.848 17.851-19.821 14.201-7.101 35.735 2.33 51-1.497 15.87-3.979 23.05-27.228 38-32.94 18.92-7.228 44.022 5.614 63-1.635 17.369-6.636 25.518-32.059 43-38.504 6.696-2.468 16.909-0.603 24-0.603h52c56.96 0 113.97-1 171-1",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m785 351c-3.88-0.323-9.368-1.05-12.138 2.433-3.094 3.891 0.032 10.382 5.137 10.021 7.596-0.538 7.366-15.791 15.002-19.441 12.513-5.982 30.081 3.18 42.999-1.755 14.728-5.626 21.789-28.657 37-32.824 18.878-5.172 42.66 5.805 60.961-1.997 11.069-4.719 21.612-20.011 30.039-28.437 3.416-3.416 7.102-8.454 12-9.682 8.704-2.182 20.033-0.318 29-0.318 17.04 0 33.94-1 51-1h164",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m844 352c-14.226-7.297-15.398 14.522-4.055 10.381 6.178-2.255 3.224-9.812 6.631-14.096 7.35-9.238 20.875-24.831 31.424-30.106 17.587-8.794 44.396 6.403 62-2.203 16.35-7.994 25.077-32.133 42-38.373 6.438-2.373 16.186-0.603 23-0.603h50c54.99 0 109.95-1 165-1",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m815 362c-0.188-3.609-0.7-7.96-4.214-9.968-3.969-2.268-9.794 1.266-9.32 5.926 0.647 6.359 8.435 4.981 12.534 6.493 3.779 1.393 6.234 5.016 10 6.54 6.31 2.554 19.913 2.101 26-1.015 18.163-9.297 27.428-34.124 46-42.963 15.038-7.157 38.273 5.049 52-3.616 14.199-8.964 23.915-31.27 40-36.808 5.172-1.781 11.605-0.367 17-0.899 19.11-1.886 38.79-0.69 58-0.69h106c16.63 0 34.6-2.028 51 0",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m846 383c-6.815-4.958-20.361-0.505-11.682 7.551 5.862 5.441 13.451-6.708 17.596-10.103 11.773-9.643 22.317-21.679 33.086-32.448 4.4-4.4 9.718-12.107 16-13.682 15.822-3.967 35.71 4.781 51-1.06 17.231-6.583 24.769-31.933 42-38.516 5.453-2.083 13.24-0.742 19-0.742h40c38.6 0 77.32-1 116-1 15.16 0 36.96-3.95 51 2m-474.89-0.153c7.531-2.397 11.428 8.843 3.848 11.785-7.038 2.731-10.873-9.549-3.848-11.785",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m784 408c-6.123 0.018-18.693 6.245-7.891 11.957 8.683 4.591 10.831-17.411 19.891-19.64 15.256-3.753 36.826 5.591 51-1.496 6.143-3.071 11.202-10.023 16-14.821 12.427-12.426 26.226-30.07 41-39.397 13.115-8.279 36.474 2.478 50.961-2.791 17.562-6.386 25.646-32.425 43.039-39.07 9.75-3.725 25.6-0.742 36-0.742h81c22.72 0 45.33-1 68-1 14.42 0 25.43-1.457 37 8",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m846 410c-1.237 6.264-11.416 17.121-13.458 4.985-1.73-10.288 13.64-4.807 18.458-7.855 15.282-9.665 28.149-27.428 41-40.126 4.846-4.788 11.559-13.026 18-15.401 16.301-6.01 37.729 4.871 54-1.345 17.454-6.668 25.486-32.197 43-38.655 12.82-4.726 34.32-0.603 48-0.603 34.77 0 70.2-1.804 105-0.871 29.56 0.793 12.92 32.583 21.99 47.812 4.27 7.167 31.47 6.246 37.01 1.059",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m871 406c4.236 5.308 3.764 18.906-5.89 12.951-4.559-2.813-3.821-8.109 0.103-11.112 12.218-9.352 22.753-21.805 33.787-32.839 4.61-4.61 9.764-11.876 16-14.258 17.109-6.535 39.382 3.739 57-1.315 15.969-4.58 22.701-27.794 38.09-33.699 9.44-3.625 24.83-0.728 34.91-0.728 25.31 0 52.92-3.155 78 0.133 13.6 1.784 7.95 18.78 10.43 27.867 1.55 5.657 8.75 11.418 13.57 14.4 5.61 3.478 15.61 1.6 22 1.6h51",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m897 406c-10.831 8.508 2.005 20.044 6.954 10.811 3.139-5.856-6.374-11.788-6.859-17.811-0.837-10.395 14.69-24.211 22.905-29.397 4.982-3.144 13.334-1.603 19-1.603 14.79 0 33.657 3.153 48-0.419 14.88-3.705 21.63-23.78 35-30.263 5.36-2.601 13.19-0.318 19-0.318 12.72 1e-3 25.31-1 38-1 5.32 0 12.01-1.064 17 1.09 7.54 3.252 12.05 11.493 19 15.91",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1091 346.97c7.84 0.246 7.94 12.166 0 12.166-7.96 0-8.41-12.43 0-12.166",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1149.1 205.76c7.52-2.793 12.33 9.025 3.92 11.387-6.82 1.918-10.9-8.798-3.92-11.387",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1113 373c-2.32 2.515-5.17 6.37-9 6.288-5.08-0.109-8.67-6.963-4.57-10.595 4.73-4.179 9.49 1.43 13.57 3.498 4.44 2.249 12.05 3.124 17 3.68 29.21 3.28 60.59 0.129 90 0.129",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1002.1 370.76c6.97-2.72 12.25 8.41 4.81 11.361-7.077 2.808-11.954-8.572-4.81-11.361",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m930.11 380.03c6.907-3.765 13.424 6.968 5.831 10.77-6.545 3.277-12.761-6.992-5.831-10.77",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m53.018 127.97c7.2646-1.526 9.9205 10.453 1.9668 11.602-7.4031 1.07-9.1148-10.101-1.9668-11.602",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m70.109 241.05c6.6416-3.423 11.68 7.472 4.8326 10.906-6.853 3.436-11.676-7.379-4.8326-10.906",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2 315h282c15.746 0 36.83-3.716 52 0.434 6.319 1.728 8.99 9.079 15 11.101 4.215 1.418 17.531-8.432 17.248 3.45-0.226 9.558-11.059 4.458-13.248-0.985m-353 3h177c29.147 0 58.916-1.776 88 0.044 9.893 0.619 15.817 11.849 23.015 17.423 4.847 3.754 10.123 3.674 15.985 3.518 8.721-0.231 12.711-8.422 21-8.941 16.86-1.055 34.105-0.044 51-0.044 6.965 0 16.614 1.694 22.956-1.688 9.924-5.294 0.698-21.295 12.049-25.824 8.724-3.481 15.541 1.731 23.085 3.628 4.155 1.045 13.193-0.536 12.444 6.883-0.47 4.655-6.619 7.137-10.217 4.255-2.82-2.259-2.898-6.956-3.317-10.254",
    style: {
      display: "inline",
      fill: "none",
      stroke: "#0a0a0a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m319 4v41c0 8.8408 0.922 16.318-6.019 22.906-6.925 6.5738-12.853 3.3175-20.981 5.5278-5.807 1.5791-13.152 8.5485-16.258 13.566-4.052 6.5472-3.356 26.544-1.424 33.961 1.201 4.611 8.11 7.585 5.61 13.019-2.479 5.391-10.566 4.966-11.961-1.073-0.854-3.697 2.534-6.834 5.033-8.907m83 59c0.144 3.297 0.156 7.815 3.303 9.82 4.126 2.629 10.247-0.598 9.32-5.727-1.447-8.011-16.486-4.179-20.023-14.093-5.78-16.196 5.455-38.087-1.342-53.891-4.641-10.79-27.132 2.901-30.735-8.167-1.385-4.255 2.991-6.578 6.478-6.883 4.941-0.433 27.493 3.152 24.337-7.0011-1.561-5.021-8.296-4.0577-12.338-4.0579-10.663-7e-4 -21.338 0.1448-32-0.0038-3.738-0.0522-9.197-0.5019-10.248-5.0356-2.278-9.8155 24.138-4.3153 28.969-7.2785 3.821-2.3431 2.531-8.0467 7.338-9.3642 5.247-1.4386 15.792 2.4171 18.318-4.4259 4.226-11.445-19.081-2.5162-19.081-12.891 0-9.971 19.408-0.0707 19.408-11.004 0-10.602-16.14-1.8912-19.081-9.2246-4.487-11.186 17.673-4.4149 19.139-11.826 0.457-2.3065-0.784-4.4323-2.899-5.3426-4.286-1.8448-9.543 0.6929-13.715-1.7824-8.171-4.8478 1.46-10.734 6.852-10.61 2.689 0.06189 5.316-0.05426 8-0.21069m12 0c0 36.246-1 72.67-1 109 0 14.707-3.254 33.754 0.318 48 2.494 9.947 16.555 13.269 19.248 23.004 3.671 13.265-11.153 20.147-18.244 28.22-2.745 3.124-2.036 7.761 1.787 9.729 9.639 4.961 8.689-9.462 4.891-13.953m10-204v97c0 14.103-3.108 32.337 0.318 46 4.227 16.86 32.392 21.321 31.638 41-0.684 17.85-18.255 9.293-26.808 17.344-6.265 5.897-1.543 16.243-3.582 23.652-1.27 4.618-5.625 7.248-6.886 12.008-1.249 4.711-4.843 13.39-11.282 8.25-9.936-7.932 6.526-11.253 11.602-11.254m49-234v123c0 11.077-2.197 21.496-2.795 32-0.158 2.785 1.249 5.703 3.854 6.917 3.753 1.75 8.665-1.834 8.279-5.931-0.375-3.976-4.27-6.202-7.338-7.986m28-148v57c0 7.2231-1.862 15.996-0.757 23 1.419 8.9979 12.701 13.246 16.578 21 2.27 4.54 1.179 11.068 1.179 16v36c0 5.397 0.536 11.565-4.214 15.297-7.096 5.575-16.964 0.585-24.785 3.292-7.726 2.673-8.391 23.398-17.853 18.075-11.015-6.198 4.595-11.661 9.852-11.664m33.318-176.97c6.265-4.1259 13.112 5.5042 7.248 10.099-6.387 5.0052-13.361-6.0732-7.248-10.099m18.682-1.0286c-1e-3 5.7024 0.453 12.174-3.299 16.91-4.678 5.9043-13.928 9.8789-14.642 18.09-1.03 11.83-3.643 33.906 0.544 44.985 2.422 6.4075 9.726 8.5849 11.068 16.015 1.715 9.501 0.329 20.355 0.329 30 0 14.521 1.099 29.53-0.093 44-0.503 6.1-5.51 14.692-12.817 13.72-3.499-0.466-5.606-4.173-9.093-4.973-3.951-0.906-8.198 1.899-7.57 6.253 1.305 9.053 10.259 4.447 13.573 0m30-185c0 4.9486 1.046 11.312-0.742 16-1.584 4.1499-5.841 6.6096-6.94 11-1.483 5.9235-0.562 13.912-0.299 20 0.254 5.8701 8.781 12.164 4.377 17.721-6.627 8.3604-14.229-4.9913-5.396-11.721m18-53c0 44.901 4.041 91.393-0.058 136-0.743 8.088-9.142 10.919-13.084 17.089-3.597 5.631-1.096 12.794-0.901 18.911 0.519 16.304-16.925 20.783-23.933 33.004-2.422 4.223-2.495 16.835-10.965 12.773-10.972-5.262 2.06-11.728 7.941-11.777m83-206c-10.213 7.7814-18.412 15.753-19 29",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m606 5c0 8.0751 2.364 20.654-1.457 27.961-6.716 12.845-25.772 26.123-36.543 35.87-4.462 4.0371-11.233 8.3023-13.397 14.17-2.279 6.1817-0.603 15.462-0.603 22 0 19.372 3.248 41.963-0.228 61-2.869 15.711-23.431 2.397-28.169 15.005-3.129 8.329-1.724 22.728 6.398 27.331 4.38 2.483 11.486 0.426 13.337 6.682 1.513 5.113-4.95 9.209-9.11 6.224-3.592-2.577-3.217-7.339-3.228-11.242",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m629 22c0.112 5.443 2.265 11.755 0.142 17-7.802 19.275-35.767 27.638-44.963 46-4.043 8.0731-1.179 23.082-1.179 32 0 26.236 2.285 52.852 0.96 79-0.312 6.155-4.295 8.794-6.678 14-1.458 3.184-0.801 6.956-2.885 9.902-1.577 2.23-4.485 4.375-7.288 3.077-11.52-5.334 1.835-13.728 8.891-12.979",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m252.06 59.758c7.58-2.9182 11.914 8.2214 3.922 10.58-6.393 1.8867-10.681-7.9784-3.922-10.58",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m626.11 210.79c7.379-2.655 11.889 8.888 3.847 11.212-6.876 1.986-10.743-8.73-3.847-11.212",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m450.02 238.85c7.317-2.078 10.724 9.222 2.966 11.487-7.236 2.112-10.519-9.343-2.966-11.487m29.025 0c7.233-2.09 10.875 9.554 2.937 11.438-7.397 1.754-10.31-9.308-2.937-11.438m30-0.089c8.059-1.279 10.275 10.648 1.952 11.656-6.992 0.847-9.29-10.492-1.952-11.656m29.064 0.024c7.192-2.601 11.636 8.922 3.848 11.378-7.352 2.317-10.84-8.849-3.848-11.378m88.04 0.286c6.476-3.357 11.908 7.374 4.793 10.694-6.637 3.097-10.891-7.534-4.793-10.694m58.911-0.31c7.516-2.791 12.112 9.068 3.922 11.387-6.822 1.931-10.895-8.799-3.922-11.387m29.05 0.281c6.402-3.386 12.172 6.222 5.743 9.925-6.802 3.919-13.109-6.029-5.743-9.925m58.325-0.014c5.688-3.865 13.601 4.714 7.414 9.367-6.317 4.75-13.639-5.139-7.414-9.367",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m425 267c12.353 15.651-19.197 11.479-5.986 0.603 1.237-1.019 2.505-1.186 3.986-1.603",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m389.06 268.03c6.493-3.432 12.938 5.916 5.882 9.865-6.584 3.684-13.192-6.001-5.882-9.865",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m419.06 296.07c6.727-3.227 12.011 7.525 4.882 10.845-6.65 3.098-11.976-7.443-4.882-10.845",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m419.06 324.12c6.868-3.108 12.475 8.297 4.882 11.116-6.946 2.579-12.034-7.88-4.882-11.116",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m635 182c-3.405 2e-3 -7.858-0.588-10.682 1.742-3.485 2.876-2.52 8.804 1.741 10.345 9.07 3.281 8.075-9.717 10.834-14.072 2.694-4.251 7.791-6.498 10.079-11.019 2.21-4.366-0.133-9.619 2.056-13.996 3.114-6.228 10.264-10.925 14.914-16 11.416-12.46-1.933-33.962 5.086-48 5.019-10.039 17.869-18.541 25.972-26.09 14.471-13.48 28.61-27.469 42.714-41.335 6.895-6.778 14.498-16.477 23.286-20.576m123 0c-3.839 3.8293-8.011 9.1238-13.089 11.312-7.349 3.1658-17.108 1.6883-24.911 1.6883h-50c-6.868 0-16.488-1.7239-23 0.5995-7.343 2.62-13.649 11.049-19 16.4-11.48 11.48-23.265 22.739-35 33.961-5.817 5.5623-15.285 11.258-18.258 19.039-3.158 8.2668 1.064 18.395 0.084 27-0.639 5.607-4.435 8.224-6.683 13-2.03 4.311-0.711 12.976-8.139 12.454-4.756-0.335-7.36-6.49-4.4-10.151 2.798-3.46 7.534-2.711 11.396-2.303",
    style: {
      display: "inline",
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m944.15 64.072c6.445-3.3405 12.002 7.4759 4.793 10.644-6.623 2.9113-10.913-7.4721-4.793-10.644",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m959.15 97.047c6.221-3.3661 12.71 7.1119 5.742 10.755-6.841 3.578-12.364-7.172-5.742-10.755",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m926.43 118.03c6.152-4.12 13.299 6.01 6.418 9.936-6.175 3.522-12.157-6.094-6.418-9.936",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m712.23 155.03c6.595-3.987 13.415 5.892 6.544 9.939-6.079 3.579-13.076-5.99-6.544-9.939",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m939.02 169.97c7.399-1.549 9.8 10.462 1.963 11.602-7.401 1.078-9.109-10.107-1.963-11.602",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m804.02 181.92c8.063-0.692 9.549 11.626 0.994 11.626-6.818 0-8.176-11.01-0.994-11.626",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m366 3v103c0 16.399-2.37 34.809 0.148 51 1.007 6.475 14.446 20.763 20.227 23.817 4.005 2.116 9.077 0.076 11.553 5.24 2.498 5.21-4.267 9.547-8.7 6.911-3.712-2.207-3.217-7.271-3.228-10.968",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m529 3c-6.481 6.2543-17.992 13.451-21.258 22-5.59 14.633-0.172 38.304 2.045 53 2.12 14.053 0.213 29.784 0.213 44 0 8.12-2.286 20.334 0.603 27.961 1.805 4.765 9.433 9.089 3.959 14.605-3.904 3.934-10.263 0.803-10.266-4.567-2e-3 -3.753 3.319-6.534 5.704-8.999m48-148c-5.829 5.8284-17.913 13.256-18.891 22-0.361 3.2226-0.697 7.845 0.494 10.91 1.736 4.4708 7.989 8.133 4.369 13.694-5.233 8.0392-15.355-4.167-5.972-11.605",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m626.23 8.0316c7.618-4.537 12.627 6.7059 5.664 11.401-6.358 4.2876-11.778-7.7593-5.664-11.401",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m330.15 155.03c6.994-3.988 12.979 7.016 5.547 10.896-6.21 3.243-11.796-7.332-5.547-10.896",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m449.11 154.76c6.701-2.557 12.112 7.794 4.832 10.699-7.096 2.833-12.291-7.853-4.832-10.699",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m567.11 182.84c7.453-2.474 11.991 8.855 3.872 11.363-6.835 2.112-10.84-9.049-3.872-11.363",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m463 445c-5.01-4.487-8.212-20.678 2.891-14.806 8.677 4.589-2.767 13.499-2.886 19.807-0.345 18.268 7.867 55.035-12.005 64.971-12.557 6.279-31.038-3.181-44 1.77-13.202 5.043-19.606 23.248-33 28.364-9.136 3.491-23.288 0.894-33 0.894h-75c-18.706 0-58.106-6.486-66.397 16-6.015 16.315-0.889 39.791-1.642 57-1.967 44.904-2.961 90.008-2.961 135 0 15.444 0.475 31.656-1.174 47-0.608 5.665-2.416 12.587-8.83 13.772-17.962 3.318-17.014-16.289-15.826-28.772 3.464-36.4 2.83-74.415 2.83-111 0-9.438 5.693-39.547-10.001-39.623-16.677-0.081-10.205 29.493-11.169 39.623-3.341 35.109-2.83 71.712-2.83 107 0 10.881 3.128 31.798-12 33.52-17.381 1.978-13-22.908-13-33.52 0-30.554 0.702-61.459 2.039-92 0.398-9.086 3.92-27.747-10.039-28.876-17.77-1.437-13.999 23.96-14 34.876-2e-3 29.627-2.2599 59.388-2.9853 89-0.1991 8.126 2.6603 25.839-7.0587 29.517-17.256 6.531-18.441-12.542-17.917-24.517 1.1078-25.301 1.1409-50.734 2.8711-76 0.5288-7.721-0.1961-21.124-9.9113-22.768-15.84-2.68-14.999 16.688-14.999 26.768 0 17.303-1.9158 34.708-1.9992 52-0.0605 12.542 1.9274 26.941-2.3449 38.985-3.1363 8.841-17.022 9.03-21.199 0.997-4.3612-8.387-1.4568-23.692-1.4568-32.982 0-12.234 3.2428-25.924 0.4707-38-2.6512-11.549-19.93-19.853-22.471-4",
    style: {
      display: "inline",
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3 576c28.648-28.057 58.669-54.767 88-82.09 11.592-10.798 25.389-30.009 40-36.396 14.383-6.287 39.429-1.514 55-1.514h130c7.938 0 19.56-2.124 26.961 1.009 4.459 1.888 6.319 6.872 10.464 9.013 4.143 2.139 13.631-1.07 13.823 6.99 0.106 4.406-5.513 7.631-9.189 5.341-3.763-2.345-4.012-6.392-4.059-10.353",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2 591c33.56-25.57 63.425-58.95 94-88.039 11.58-11.017 25.796-29.373 40.001-36.504 11.13-5.588 32.651-1.457 44.999-1.457h110c11.215 0 21.98-0.034 33 1.541 4.381 0.626 10.454-0.605 12.712 4.568 2.086 4.778-4.179 10.083-8.653 7.844-4.238-2.121-4.045-6.913-4.059-10.953",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3 605c31.385-31.298 64.9-60.487 97-91.039 9.947-9.467 19.703-19.164 30-28.246 4.047-3.57 7.837-9 13-10.973 5.964-2.278 14.687-0.742 21-0.742h44c31.475 0 66.848-6.082 98-0.775 8.719 1.485 12.229 11.064 20 14.033 11.807 4.51 26.813-1.995 39 1.06 7.274 1.823 10.999 10.532 18 13.079 4.387 1.597 10.391 0.603 15 0.603 10.1 0 23.187 2.228 32.961-0.318 3.369-0.878 5.02-4.082 8.078-5.46 3.343-1.506 7.147 0.411 8.338 3.821 3.831 10.968-10.604 6.337-14.377 1.957",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m258 813c0-11.97-3.205-36.977 3.564-47 9.932-14.706 34.306-24.53 39.783-42 5.423-17.295-0.246-40.834 1.483-59 0.487-5.11-1.099-11.45 1.773-16 3.346-5.3 11.116-13.186 17.397-14.686 5.493-1.312 11.939 1.289 16.945-2.056 8.624-5.763 1.845-17.201 8.334-24.11 6.285-6.692 17.384-0.906 24.721-7.281 10.086-8.764 24.118-19.319 30.991-30.867 4.227-7.102-0.812-17.021 7.064-22.397 8.778-5.991 22.629 2.04 31.945-3.46 14.561-8.597 23.312-28.934 39-35.285 5-2.024 11.706-0.743 17-0.873 10.336-0.253 20.606-0.985 31-0.985h144c5.229 0 12.07-1.138 17 0.858 9.015 3.65 28.413 21.506 30.517 31.142 1.767 8.094-2.515 19.769 2.225 26.911 10.266 15.466 27.285 1.091 39.125 9.692 7.693 5.59 1.753 17.847 8.281 24.169 7.082 6.858 19.933-1.175 25.279 8.283 5.647 9.988-2.525 25.277 10.859 31.828 3.824 1.872 8.63-1.372 12.396 1.145 7.518 5.024-5.977 19.579-11.118 7.928-1.064-2.411-1.235-5.371-1.564-7.956",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m805 584c0.513 3.709 1.279 7.975 5.058 9.777 4.719 2.25 10.001-2.85 8.18-7.672-2.48-6.571-9.709-2.816-14.237-5.629-7.527-4.674-13.57-27.106-5.683-33.877 4.6-3.949 14.088-2.599 19.682-2.599h48c23.796 0 51.62-4.032 75 0.228 7.36 1.342 10.711 9.82 18 11.469 10.966 2.48 24.755 0.303 36 0.303 20.27 0 41.86 2.14 62-0.109 11.48-1.282 15.77-15.641 26-19.292 16.08-5.736 37.21 2.232 54-0.827 11-2.006 14.2-14.598 27-14.593 17.03 7e-3 28.69 21.683 41.42 30.633 4.56 3.205 12.62-0.239 14.24 7.203 1.08 4.935-4.07 9.357-8.55 6.363-3.92-2.618-4.07-7.159-4.11-11.378m-751-1c-4.048 0.037-8.603 0.031-10.816 4.109-2.635 4.853 2.527 11.063 7.761 8.657 5.838-2.683 3.635-9.332 6.543-13.766 5.522-8.421 15.09-15.47 22.512-22.17 3.034-2.738 5.864-6.475 10-7.512 11.622-2.914 27.011-0.318 39-0.318h82c14.368 0 28.729 0.901 43 1.069 4.325 0.051 12.603 1.612 11.11 7.913-3.123 13.181-13.288-0.619-14.11-6.982",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m152.04 482.04c7.476-3.723 12.95 8.207 4.915 11.534-7.392 3.061-12.614-7.699-4.915-11.534",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2 620c30.453-30.201 62.999-58.396 94-88.039 14.363-13.734 31.196-36.738 50-43.961m-144 146c37.675-28.705 69.821-66.395 105-98.17 10.678-9.645 21.969-25.621 35-31.817 6.135-2.917 13.704 0.62 20-1.755 6.797-2.563 10.632-9.897 17-13.079 4.541-2.269 11.067-1.179 16-1.179h59c9.27 0 19.877-1.437 29 0.228 4.201 0.767 5.938 3.959 9.285 6.087 4.031 2.562 16.711 0.771 13.914 9.641-4.028 12.774-12.473-2.245-13.199-7.956",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3 648c31.632-30.979 64.172-61.466 97-91.17 12.523-11.331 25.7-30.542 41-37.817 10.413-4.951 28.559-0.319 40-1.102 39.545-2.709 79.381 0.594 119-0.93 10.21-0.392 13.348-10.934 22-14.239 8.252-3.152 21.211-0.742 30-0.742",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m327.15 526.03c6.92-3.943 13.175 7.056 5.743 10.922-6.786 3.53-12.277-7.197-5.743-10.922m90.08-3e-3c6.696-4.04 13.794 5.529 6.662 10.21-6.51 4.274-13.492-6.089-6.662-10.21",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m352 563c1.303-3.193 2.413-6.977 6.044-8.214 4.254-1.449 9.654 2.55 8.294 7.199-0.801 2.738-3.535 4.949-6.339 5.277-3.159 0.368-5.906-1.786-8.999-1.971-6.552-0.393-13.437 1.418-20 1.58-17.527 0.433-35.345 0.129-53 0.129-7.09 0-17.305-1.865-24 0.603-5.982 2.206-12.572 10.207-16.682 14.973-4.211 4.882-2.29 14.372-2.319 20.424-0.073 15.174 1.109 33.041-1.304 48-2.01 12.465-18.447 15.53-21.378 27-4.174 16.335-1.317 36.245-1.317 53 0 27.321-2 54.692-2 82m178.11-257.97c7.034-3.811 13.195 6.818 5.832 10.951-8.697 4.882-13.769-6.65-5.832-10.951",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m228 814c0-18.361-0.342-36.711 0.91-55 0.396-5.782-1.006-12.361 0.408-18 2.471-9.855 15.746-14.041 20.225-23 5.098-10.196 2.457-28.741 2.457-40 0-18.722 1-37.313 1-56 0-8.169-1.854-17.557 4.059-23.999 13.343-14.539 45.43-8.001 63.941-8.001",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m267.13 496.76c7.532-3.042 12.456 7.463 4.823 11.195-6.937 3.392-11.954-8.315-4.823-11.195m89.966 0.271c7.496-4.128 14.345 6.882 5.857 10.737-6.458 2.933-12.962-6.825-5.857-10.737",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3 663c33.344-33.344 67.894-66.037 102.91-97.589 12.647-11.396 26.031-30.363 41.09-38.093 5.056-2.595 12.478-1.318 18-1.318h106c10.913 0 23.241 1.608 34-0.225 6.363-1.083 9.748-7.657 16-8.627 6.257-0.971 18.045-1.762 23.996 0.455 3.405 1.269 5.011 4.762 8.174 6.28 4.577 2.198 11.161-0.703 13.168 6.136 1.353 4.609-4.005 9.073-8.279 6.934-4.278-2.14-4.531-7.801-5.059-11.953",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m419.02 553.89c7.12-1.683 10.569 10.105 2.962 12.259-7.67 2.171-10.977-10.364-2.962-12.259",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m383 567c-9.916 9.826-19.851 8-33 8h-64c-7.455 0-19.21-2.205-26 1.179-26.897 13.405-14.368 55.188-17.174 79.821-1.464 12.847-18.543 16.172-21.508 28-3.695 14.737-1.318 34.751-1.318 50 0 26.672-1.779 53.363-2 80",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m159.11 576.04c6.729-3.558 12.92 6.897 5.782 10.773-7.113 3.863-13.191-6.855-5.782-10.773",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m327.02 584.05c6.965-3.308 12.803 7.893 4.929 11.08-7.607 3.078-12.982-7.255-4.929-11.08",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m266.09 613.79c7.772-2.725 11.389 8.886 3.887 12.128-7.216 3.117-11.83-9.342-3.887-12.128m25.906 11.214c0.153-3.505 0.284-7.873 3.303-10.257 4.019-3.174 10.532-0.047 10.035 5.253-0.645 6.886-7.823 5.107-12.338 6.183-4.628 1.103-8.781 6.277-9.721 10.821-3.474 16.789-1.279 38.79-1.279 56 0 6.975 1.627 16.402-0.894 23-7.027 18.395-32.347 27.365-42.248 44-2.895 4.864-1.858 11.575-1.858 17v37m83-193c2.952-4.276 14.388-13.565 15.534-1.985 0.353 3.566-3.117 6.681-6.535 6.689-3.76 8e-3 -6.261-4.12-9.999-3.648-7.233 0.913-22.861 17.722-25.972 23.944-2.662 5.324-1.028 14.171-1.028 20 0 15.343 2.634 37.334-1.573 52-1.637 5.709-7.389 9.962-11.427 14-9.39 9.39-23.201 18.926-30.4 30.039-2.442 3.769-1.384 8.709-1.885 12.961-1.516 12.847-0.715 26.066-0.715 39m111-186c-1.861-2.839-4.325-6.336-3.628-9.956 0.953-4.948 7.846-6.299 11.024-2.61 2.188 2.539 1.342 6.035-0.714 8.342-5.738 6.438-14.584 11.083-18.654 19.224-3.37 6.74 0.711 14.255-7.047 19.258-6.709 4.326-15.766-1.177-21.833 4.89-4.698 4.698-3.148 12.782-3.148 18.852 0 12.561 2.692 34.509-2.228 45.985-7.03 16.398-29.673 24.461-38.199 40.054-5.515 10.085-1.573 30.596-1.573 41.961m120-186c-5.394-3.44-12.366-17.195-4e-3 -14.522 10.739 2.321 1.463 10.963 2.926 16.522 1.3 4.939 6.832 7.562 9.05 12 2.551 5.103 1.028 13.42 1.028 19 0 51.386-1 102.66-1 154",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.058 641.9c8.0285-3.001 12.413 9.616 3.8997 12.297-7.064 2.224-11.055-9.622-3.8997-12.297",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m975 701c-10.534 2.859-16.143-12.704-5.995-12.704 7.334 0 10.125 14.878 14.995 19.708 7.906 7.841 19.57 23.546 30 27.393 5.15 1.897 13.46 1.196 19 1.51 14.01 0.792 28.87-0.739 43-0.571 11.29 0.134 23.87 2.589 35-0.184 8.95-2.228 12.4-13.072 21-14.873 8.98-1.88 19.84-0.279 29-0.279h59m-1194-31.238c7.9096-2.861 11.683 8.952 3.9367 12.101-7.1103 2.891-11.787-9.262-3.9367-12.101",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m353 656c-0.449-3.569-1.634-7.609 0.743-10.772 3.162-4.206 9.841-3.1 11.634 1.862 2.462 6.812-6.305 7.758-10.168 10.038-5.195 3.066-11.787 11.826-12.165 17.872-2.876 45.969-1.049 92.969-1.044 139",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m387.06 643.05c6.877-3.441 12.127 7.681 4.882 11.13-8.85 4.215-12.494-7.322-4.882-11.13",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1133 653 36-0.228 15-10.169 36-0.603m-894.85 2.032c7.363-4.241 14.366 6.748 5.808 10.921-6.52 3.18-12.173-7.256-5.808-10.921",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m383 654c-7.263 8.315-14.751 24.231-6.682 35 5.36 7.153 16.444 12.766 18.338 22 2.889 14.092 6e-3 30.781-0.617 45-0.843 19.256-0.039 38.724-0.039 58",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m326.11 672.76c8.471-3.231 12.231 9.501 3.876 13.066-7.287 3.11-10.928-10.377-3.876-13.066m32.891 15.238c-4.264-3.558-11.845-16.522 0-15.663 3.691 0.268 7.295 3.777 6.288 7.66-0.96 3.699-4.965 5.603-6.394 9.092-2.267 5.534-2.321 19.334-0.152 24.906 2.866 7.362 30.05 5.042 22.476 16.896-5.245 8.209-24.519-0.579-25.752 12.106-1.328 13.662 27.787 0.366 26.756 15.003-0.902 12.806-23.002 1.786-26.56 14.015-3.693 12.697 23.864 3.575 25.796 14.997 0.474 2.805-1.208 5.305-3.567 6.67-5.582 3.23-13.376 0.364-18.832 4.06-8.967 6.074-0.418 13.047 6.941 13.243 5.715 0.152 9.811 0.407 15 3.015m5.148-140.97c7.24-4.171 14.042 6.792 5.808 10.925-6.891 3.458-12.266-7.205-5.808-10.925",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m328 688c0 14.385-0.634 28.679-0.985 43-0.146 5.954 1.634 14.526-1.333 19.911-2.511 4.557-8.679 9.93-13.682 11.365-5.505 1.579-18.364-0.584-18.364 8.721 0 10.073 19.346 6.83 25.364 7.018 3.171 0.1 8.364 0.763 8.364 5.025 0 11.235-24.788 6.064-31.364 7.185-4.392 0.748-10.228 4.49-8.377 9.721 1.904 5.383 8.768 5.047 13.377 5.054 9.947 0.016 24.483-3.242 29 8",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m235.02 702.88c7.897-1.072 10.144 10.897 1.97 12.496-8.08 1.581-10.388-11.352-1.97-12.496m29.044 0.162c7.46-3.838 12.93 8.06 4.922 11.734-7.285 3.343-11.917-8.135-4.922-11.734",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m816 419c-0.197-3.648-0.845-7.901-4.329-9.968-4.154-2.465-9.967 1.042-9.129 5.953 1.196 7.001 8.936 4.633 13.458 6.9 3.614 1.812 6.013 5.212 10 6.462 10.182 3.192 23.573 0.149 34-0.308 15.217-0.666 34.315 3.544 49-0.473 17.268-4.723 24.235-32.244 42-36.263 11.862-2.683 26.833-0.303 39-0.303h82c14.64 0 31.61 2.394 46-0.228 5.85-1.067 8.93-6.985 15-7.663 28.24-3.156 58.57-0.109 87-0.109",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m847 446c-2.642 1.951-5.479 4.296-8.981 3.087-5.091-1.758-6.791-9.385-0.96-11.464 5.986-2.136 19.636 14.427 24.941 17.774 6.165 3.889 26.058 3.173 33 1.089 5.622-1.688 9.137-7.19 13.17-11.062 9.397-9.021 18.616-18.21 27.83-27.424 4.021-4.021 8.528-10.379 14-12.397 10.272-3.787 27.06-0.603 38-0.603h88c14.31 0 34.34 3.63 48-0.653 7.91-2.48 10.84-12.197 19-14.044 7.68-1.738 17.14-0.303 25-0.303h52",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m816 449c-0.013-3.757 0.235-7.894-3.148-10.396-4.114-3.042-10.416-0.059-9.475 5.357 1.265 7.286 9.167 4.252 13.623 6.731 3.231 1.798 5.251 5.05 9 5.99 7.38 1.85 15.62-1.212 23 0.636 4.8 1.202 7.488 5.998 12 7.824 8.506 3.443 31.182 2.874 39.985 0.285 4.882-1.435 8.344-6.688 11.976-10.003 9.968-9.096 19.489-18.875 29.039-28.424 4.021-4.021 8.528-10.379 14-12.397 4.63-1.707 11.125-0.603 16-0.603h35c39.31 0 78.73 0.95 118-0.015 14.16-0.347 17.09-13.013 29-16.757 19.06-5.994 46.08-1.228 66-1.228",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m768 431c0.292-6.398-8.842-16.851-12.377-6.941-0.968 2.713 0.297 5.672 2.525 7.338 3.249 2.429 7.403 0.721 10.852 2.492 5.336 2.739 9.492 8.77 14 12.687 6.591 5.725 12.872 14.978 21 18.486 11.669 5.035 28.522-0.816 41 1.152 6.125 0.966 9.271 6.787 15 8.352 11.074 3.025 28.558 1.338 40 0.34 7.782-0.679 12.837-7.765 18-12.905 9.541-9.499 19.164-18.925 29-28.091 3.832-3.571 7.686-9.26 13-10.592 11.297-2.832 25.364 0.152 37-0.357 29.28-1.282 58.65-0.961 88-0.961 17.42 0 40.13 3.911 57-0.318 7.45-1.868 10.79-10.399 19-11.494 18.89-2.516 39.72 1.334 59-0.188",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1092 441c3.04-1.753 6.46-3.452 9.98-1.782 4.82 2.289 6.26 8.645 0.91 11.281-7.9 3.894-8.48-7.438-13.12-10.181-4.22-2.5-11.06-1.318-15.77-1.318-26.19 0-55.1-2.538-80.982 1.189-7.281 1.048-5.502 12.326-13.015 12.326-5.414 0-8.067-7.515-4.565-11.197 3.067-3.226 7.747-2.226 11.562-1.318",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m959.15 452.03c6.915-3.948 13.192 7.082 5.743 10.921-6.341 3.268-11.957-7.372-5.743-10.921",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m980 454c0 13.971-13.321 31.881-27 37.106-8.378 3.201-21.107 0.894-30 0.894-21.864 0-44.182 1.313-66-0.044-8.779-0.546-14.37-6.878-24-5.782-5.377 0.613-8.857 4.888-14 5.678-8.567 1.315-19.859-2.554-27.917 0.89-5.897 2.521-2.968 18.256-13.024 13.707-10.832-4.9 1.776-12.393 7.941-12.449",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m749 480c-1.947-2.382-4.547-5.432-7.995-5.263-5.233 0.255-7.542 7.207-3.687 10.595 5.686 4.997 9.651-2.713 14.721-4.015 8.066-2.071 18.642-0.317 26.961-0.317 9.819 0 15.11-4.169 24-5.772 11.696-2.108 27.149-1.145 39-0.17 6.212 0.511 9.279 6.218 15 7.625 13.785 3.389 37.954 2.354 52 0.169 6.153-0.957 10.849-7.701 15-11.852 9.867-9.867 19.828-19.587 29.961-29.169 3.949-3.734 7.432-9.178 13.039-10.517 16.461-3.933 38.05-0.314 55-0.314 40.32 0 80.68 0.559 121-4e-3 10.99-0.153 14.16-11.466 24-13.693 16.04-3.629 36.53-0.303 53-0.303",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1101 464c5.63-2.208 9.18-8.922 15.01-9.852 13.3-2.12 30.35 3.937 42.99-0.89 12.27-4.689 18.81-20.738 30-27.4 7.75-4.611 22.23-1.858 31-1.858",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1009 450c-4.31-0.357-9.454-0.685-12.393 3.228-3.47 4.619 1.029 10.466 6.383 9.294 7.96-1.744 3.24-11.334 9.16-13.919 4.06-1.774 10.49-0.603 14.85-0.603 11.66 0 27.83-2.914 38.99 0.514 8.78 2.698 7.91 10.269 11.75 16.486 6.16 9.948 15.59 16.196 27.26 14.891 8.85-0.988 11.83-11.525 20-13.573 14.48-3.631 37.05 5.942 50-2.06 16.4-10.133 23.9-33.258 45-33.258",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m977 494c3.838-3.022 7.284-7.78 12.001-9.411 6.044-2.091 14.649-0.589 20.999-0.589 13.49 0 27.58-1.237 41-0.246 4.57 0.337 8.35 3.051 13 3.227 13.24 0.504 35.63 4.002 48-0.723 6.77-2.588 9.86-11.151 17-12.94 14.24-3.571 30.51 1.925 45-0.543 19.15-3.262 25.84-34.537 46-34.775",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1008 493c3.04 11.218-12.704 14.566-12.704 4.015 0-5.939 6.494-5.774 10.704-5.988 11.02-0.561 21.91-1.046 33-1.027 6.17 0.01 10.22 3.038 16 3.856 16.73 2.368 42.46 3.191 59-0.2 8.4-1.723 11.61-12.203 20-13.508 14.47-2.251 32.07 3.86 46-0.851 16.34-5.527 22.55-30.776 40-34.297",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1220 452c-9.81 9.813-22.97 29.28-36 34.258-14.13 5.398-32.39-2.603-47 1.06-7.6 1.906-11.18 11.207-19 13.252-15.92 4.165-37.53 0.43-54 0.43-8.59 0-21.92-2.509-29.89 0.894-3.7 1.579-4.52 6.076-8.16 7.744-3.05 1.393-6.42 0.02-8.16-2.748-6.42-10.201 9.47-8.542 14.21-4.89",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1057 461.97c7.09-1.485 10.7 10.303 2.96 12.139-7.02 1.664-10.79-10.502-2.96-12.139",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m847 506c-6.033 1.641-19.622-3.11-10.602-10.253 2.81-2.225 6.087-0.957 8.323 1.402 2.345 2.473 2.639 6.687 5.582 8.533 6.362 3.991 20.384 1.318 27.697 1.318h59c7.321 0 15.866-1.823 23-0.782 9.03 1.316 12.569 11.64 21 14.058 16.568 4.753 39.89 0.73 57 0.695 10.61-0.022 13.6-11.36 23-12.823 19.59-3.046 40.41 2.728 60-0.362 8.85-1.395 11.68-11.777 20-13.507 8.08-1.68 17.76-0.279 26-0.279h53",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m758 523c-5.396 4e-3 -20.581 3.919-10.851 11.446 9.583 7.413 11.533-14.237 17.852-17.418 5.996-3.019 14.482-0.239 20.999-1.662 5.116-1.117 7.56-5.127 12-7.338 5.065-2.522 17.544-2.069 23-0.71 5.01 1.248 7.836 6.335 13 7.403 9.906 2.05 21.887 0.279 32 0.279 29.742 0 61.459-3.181 91 0.109 9.477 1.055 13.338 12.088 22 14.457 6.614 1.809 15.171 0.434 22 0.434 13.85 0 28.21 1.109 42-0.094 9.9-0.864 13.07-12.031 22-14.472 18.7-5.116 40.84 2.38 60-0.648 8.79-1.389 12.25-12.266 21-13.638 10.26-1.608 24.86-2.323 35 0.169 4.54 1.117 7.34 5.441 12 6.404 8.39 1.736 18.44 0.279 27 0.279",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m788 526c-5.062-2.918-18.596-1.89-12.381 6.852 2.021 2.843 6.165 3.863 8.962 1.544 6.889-5.712 9.134-16.153 19.419-18.962 12.373-3.38 16.751 5.333 27 8.132 10.9 2.978 25.706 0.434 37 0.434 27.287 0 58.069-4.041 85 0.148 8.493 1.321 11.655 12.033 20 13.95 7.753 1.781 17.978-0.098 26-0.098 16.14 0 32.93 1.341 49-0.059 9.68-0.842 13.03-13.053 22-15.507 18-4.923 39.51 1.937 58-0.623 9.07-1.255 12.28-12.306 21-13.663 7.72-1.2 22.69-2.198 30 0.594 5.88 2.248 9.42 8.55 15 11.489 6.99 3.682 18.5 2.16 26 0.769",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m818 532c-4.467 3.777-17.7 4.318-12.953-4.891 1.716-3.328 5.755-4.379 8.844-2.351 2.78 1.825 3.38 5.751 6.411 7.094 11.075 4.905 30.697 1.148 42.698 1.148 26.73 0 55.437-4.487 82-0.811 9.439 1.306 13.322 12.317 22 14.493 8.996 2.256 20.73 0.318 30 0.318 17.87 0 37.3 2.187 55-0.133 9.92-1.3 13.46-13.848 22.09-17.264 4.49-1.778 11.14-0.603 15.91-0.603 13.69 0 29.54 2.225 43-0.228 8.74-1.592 11.94-12.651 21-13.663 6.05-0.677 16.36-1.606 22 0.829 9.09 3.922 13.82 14.583 23 18.538 4.27 1.838 9.5 0.636 14 0.524",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m878 582c-8.99-2.626-17.811 9.158-6.985 11.522 8.093 1.767 7.106-6.819 9.267-11.522 2.822-6.143 11.805-15.779 18.718-16.852 18.723-2.905 40.036-0.148 59-0.148 28.805 0 58.34-2.345 87-0.231 12.38 0.913 17.33 19.224 30 20.176 13.18 0.991 26.78 0.055 40 0.055 6.33 0 14.69 1.446 20.79-0.318 3.06-0.884 4.41-4.165 7.25-5.46 3.71-1.688 8.19 1.027 9.3 4.79 2.88 9.778-9.8 6.849-13.34 1.988",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m850 593c-0.339-6.524-9.506-18.333-13.377-6.981-3.205 9.399 10.013 7.642 14.377 10.468 14.799 9.585 39.008 8.415 57 6.404 15.037-1.68 21.427-24.283 35-29.288 6.951-2.563 17.634-0.603 25-0.603h47c6.54 0 15.82-1.674 22 0.603 10.42 3.839 15.72 16.87 26 21.169 7.94 3.32 17.6-0.744 26 0.966 5.4 1.099 9.86 6.893 14 10.262",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m790 590c-2.495 2.099-5.412 4.973-8.995 4.353-5.334-0.923-7.911-8.117-2.777-11.17 6.683-3.974 12.385 5.956 16.777 9.411 3.905 3.072 7.258 7.854 11.995 9.664 4.28 1.635 8.905-0.046 13 2.484 6.384 3.946 10.353 11.438 17.039 14.944 6.516 3.417 17.76 1.314 24.961 1.314 20.533 0 43.823 2.949 64-0.305 14.696-2.37 21.347-22.341 34-28.667 5.103-2.552 13.421-1.028 19-1.028 14.325 0 30.92-2.337 45 0.228 10.1 1.841 17.08 14.549 25 20.199 6.99 4.983 15.51 0.49 23 3.315 11.28 4.254 14.84 17.231 28 17.258 18.73 0.039 40.6 3.125 59-0.228 5.26-0.96 7.95-6.189 13-7.454 6.42-1.607 13.5 0.638 20-0.546 4.65-0.848 6.59-4.699 10.42-6.834 6.04-3.359 18.32-2.122 10.58-12.938",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m821 640c8.386-11.896 20.968-9 34-9 25.375 0 55.071 4.314 80-0.228 11.893-2.168 17.613-18.551 28-23.744 9.65-4.825 29.249-1.028 40-1.028",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m977 632 30 1.179 25 19.593 32 0.228h65",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1038 641c12.24 7.5 35.9 3 50 3 25.17 0 52 2.685 77-0.109 6.33-0.707 8.39-7.093 14.04-8.573 12.86-3.372 27.9-0.426 40.96-0.318",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m855 647c-4.016 3.799-21.929 11.127-17.377-1.956 3.685-10.592 15.274 1.673 21.377 1.937 23.237 1.004 46.738 0.019 70 0.019 8.666 0 18.49-1.274 27 0.479 5.651 1.164 10.097 4.75 16 5.35 9.688 0.985 20.547-1.751 30 0.729 9.86 2.587 14.12 13.085 25 14.268 20.51 2.231 42.36 0.174 63 0.174h124",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m790 654c13.236 12.953 36.52 8 54 8h69c9.904 0 22.38-2.048 32 0.317 6.75 1.66 10.314 9.195 17 11.11 5.456 1.564 16.715 1.824 21.911-0.65 2.982-1.421 4.664-4.822 8.103-5.4 3.186-0.536 6.201 1.668 7.2 4.642 3.246 9.674-9.711 8.12-13.214 1.981",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m762 677c4.062 0 9.263-0.841 13 1.028 9.392 4.696 14.345 16.781 24.001 21.037 7.635 3.365 14.861-0.861 21.999 5.029 8.445 6.969 18.39 22.57 29 25.472 6.9 1.888 15.873 0.434 23 0.434h48c7.426 0 19.477-2.278 26 1.742 20.081 12.378 37.95 34.994 55 51.297 6.1 5.829 12.81 15.44 21 18.361 8.34 2.976 20.35 1.018 29 0.639 17.55-0.768 35.35-0.039 53-0.039 8.38 0 19.07-1.669 27 1.563 5.31 2.163 9.97 7.49 14 11.437m-262-138c11.48 0 32.711-4.117 43 1.028 8.716 4.358 17.127 15.11 24 21.972 12.671 12.651 26.249 24.413 39 36.996 6.104 6.025 13.28 15.128 21 18.976 8.19 4.084 25 1.458 34 1.067 19.37-0.84 38.69 0.727 58 0.957 9.17 0.109 21.19-2.127 30 0.518 7.66 2.299 14.93 11.967 20.58 17.406 13.67 13.167 27.98 25.671 41.42 39.08",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m853 682c5.42 2.112 9.428 7.233 15 8.701 7.148 1.882 15.367-1.342 22 1.733 6.821 3.161 10.385 12.081 18 13.743 11.32 2.472 28.82-3.594 39 2.387 17.917 10.527 33.986 31.119 49 45.475 5.59 5.344 11.63 14.402 19 17.219 7.74 2.956 19.77 0.742 28 0.742h58c8.62 0 19.67-1.845 28 0.434 6.29 1.721 11.75 8.885 16.29 13.295 10.32 10.039 21.12 19.52 31.71 29.271",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1161 541 36 32.142 23 0.858",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1147 555c-3.66 0.868-7.7 1.67-10.68-1.318-3.31-3.315-2.33-9.441 2.7-10.305 7.7-1.326 6.75 8.913 12.12 11.14 4.85 2.006 10.31-0.145 14.86 2.341 10.68 5.833 17.09 18.513 28 23.824 7.01 3.41 18.36 1.318 26 1.318",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1115 549 16 13.697 32 1.906 27 22.94 30 0.457",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m780.02 552.97c7.583-1.568 10.634 11.152 1.981 12.098-7.55 0.824-9.71-10.5-1.981-12.098m36.985 13.029c-3.902-0.092-8.758-0.385-10.968-4.214-2.98-5.161 2.503-11.371 7.909-8.592 4.862 2.5 3.41 7.634 5.283 11.806 1.684 3.751 5.392 6.098 6.883 10 1.958 5.128-0.093 10.798 1.211 16 1.728 6.893 14.659 19.492 21.682 20.772 15.944 2.905 34.781 0.228 51 0.228 6.352 0 15.142 1.533 21-1.318 13.004-6.329 20.434-28.178 36-28.667 17.296-0.542 34.694-0.015 52-0.015 7.25 0 17.15-1.725 24 0.894 10.44 3.987 16.15 16.731 26 21.788 6.23 3.198 13.92-0.685 20 3.06 5.77 3.555 9.98 11.03 17 12.364 7.1 1.349 15.73-0.189 23-0.102 11.66 0.139 26.63 2.673 38-0.438 10.57-2.891 14.43-11.125 27-10.566m-344.89-56.238c6.982-2.668 12.84 8.581 4.847 11.476-7.164 2.596-12.293-8.632-4.847-11.476",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1097 558c3.97 4.049 7.66 9.746 13 12.062 14.34 6.219 33.98-2.736 49 1.372 10.84 2.964 17.12 17.175 27 22.248 8.53 4.38 24.52 1.318 34 1.318",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1088 546.8c6.36-2.002 13.15 9.615 5.89 12.187-7.92 2.802-14.87-9.358-5.89-12.187",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m901.04 581.85c7.518-2.179 11.55 10.423 2.952 12.178-7.2 1.47-10.392-10.022-2.952-12.178",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1010 599.85c7.83-2.275 12.25 9.338 3.97 12.106-7.52 2.513-12.97-9.488-3.97-12.106",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1063 622.85c6.97-2.011 11.2 8.922 3.92 11.642-7.44 2.777-11.99-9.309-3.92-11.642",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1030 628.85c6.91-1.963 12.64 11.139 4.92 13.106-8.1 2.066-14.02-10.52-4.92-13.106",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1161 815c-7.81-7.814-18.61-22.29-29-26.258-7.74-2.956-19.77-0.742-28-0.742-18.98 0-38.07-1.79-57-0.961-7.72 0.339-19.72 2.76-27 0.064-6.29-2.329-11.04-9.371-16-13.679-11.755-10.212-22.978-21.42-34-32.424-6.106-6.096-13.198-14.654-21-18.543-6.369-3.175-16.058-1.457-23-1.457-18.11 0-39.201 3.02-57-0.228-13.706-2.502-5.48-21.366-17.171-27.608-13.694-7.313-31.15 3.16-44.829-1.902-11.327-4.193-20.087-18.092-29-25.838-3.914-3.401-8.785-7.009-9.772-12.424-2.263-12.422 2.575-28.101-1.97-40-3.592-9.402-28.354-21.206-17.258-31m4 0c6.539 3.669 4.898 8.725 1 14",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m745 624c-2.621 3.303-6.156 6.903-7.432 11-1.396 4.481 0.424 10.325 0.432 15 0.022 13.401-4.267 32.055 9 40.258 7.417 4.586 17.898 0.067 26 2.059 8.456 2.079 12.567 11.939 20 15.655 5.54 2.77 12.449-0.694 18 2.055 12.376 6.128 21.03 27.407 35 29.154 22.48 2.812 47.251-0.181 70-0.181 8.154 0 20.43-2.254 27.911 1.433 6.828 3.365 12.603 11.311 18.085 16.478 12.358 11.645 24.988 23.092 37.004 35.089 6.01 6.003 14.45 17.541 23 19.682 7.83 1.96 17.94 0.318 26 0.318h54c10.01 0 23.2-2.39 32 3",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m780.11 641.76c6.598-2.606 14.287 8.392 7.573 11.638-7.35 3.553-16.44-8.136-7.573-11.638",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m751.11 670.79c8.036-2.89 13.144 9.78 3.876 12.363-7.264 2.024-10.922-9.829-3.876-12.363m60.935 0.011c7.521-2.466 11.807 8.992 3.937 11.81-7.339 2.628-11.963-9.178-3.937-11.81m30.065-0.035c6.934-2.646 14.048 9.428 5.857 12.162-7.724 2.579-14.046-9.038-5.857-12.162m29.95 0.309c6.813-3.303 14.263 6.738 5.932 10.897-7.145 3.566-13.622-7.17-5.932-10.897",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1097.1 683.03c6.49-3.651 13.45 6.939 6.71 10.784-6.66 3.805-13.78-6.81-6.71-10.784",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1208.1 685.76c7.5-2.969 12.42 8.574 4.79 11.48-6.87 2.614-11.98-8.634-4.79-11.48",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m996 697 15 11.566 21 0.449 47-0.012 141-3e-3m-1218-11c8.1604 2.347 6.9121 8.693 1 13",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1204 742c-3.95-0.699-8.56-1.355-11.39 2.279-3.04 3.899 0.27 10.753 5.39 10.255 7.8-0.758 5.37-8.886 7.89-13.49 2.91-5.305 8.9-5.041 14.11-5.044",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1208 765c7.95 6e-3 15.54 7.739 4.95 12.777-7.73 3.674-9.17-7.07-6.95-11.777",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m733.13 337.76c7.55-3.054 12.361 8.76 4.758 11.29-6.473 2.153-11.647-8.504-4.758-11.29",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m539.02 351.97c6.839-1.432 10.269 9.21 2.962 11.367-7.176 2.118-10.689-9.75-2.962-11.367m29.999-0.09c7.537-1.031 9.874 10.096 1.967 11.627-7.729 1.496-9.941-10.535-1.967-11.627m29.026-0.03c6.921-2 11.403 8.671 3.912 11.387-7.473 2.71-11.823-9.101-3.912-11.387m29.975 0c7.386-2.091 10.638 9.24 2.965 11.487-7.232 2.118-10.52-9.348-2.965-11.487m34.981 0.149c3.128 4.764 2.056 14.032-5.941 10.647-7.887-3.339-2.084-11.189 3.941-11.647",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m664 381c9.112 19.073-24.554 5.161-4-2",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m539.04 380.68c8.106-1.517 10.276 11.04 1.952 11.853-7.011 0.685-9.245-10.487-1.952-11.853m29.015 0.441c6.972-3.16 11.887 8.486 4.727 11.255-6.796 2.629-11.765-8.066-4.727-11.255m30-0.336c7.404-2.595 11.763 8.932 3.897 11.413-6.794 2.143-10.898-8.958-3.897-11.413",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m626.15 381.03c6.791-3.877 13.449 7.068 5.793 10.745-6.4 3.074-12.071-7.16-5.793-10.745",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m716.13 397.76c7.524-3.038 12.987 7.639 4.848 11.156-6.459 2.79-11.925-8.299-4.848-11.156",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m627.19 409.04c6.594-3.6 12.682 7.056 5.701 10.763-7 3.716-12.905-6.829-5.701-10.763m31.854-0.242c7.459-0.837 9.778 10.821 1.942 12.062-7.358 1.166-9.411-11.224-1.942-12.062",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m358.13 410.04c6.833-3.706 13.123 6.779 5.757 10.773-7.044 3.82-12.685-7.015-5.757-10.773m179.98-0.281c7.586-2.896 12.406 9.078 3.876 11.576-6.725 1.97-10.627-9-3.876-11.576m29.119 0.27c6.797-4.008 13.412 7.202 5.666 10.885-6.257 2.977-11.817-7.257-5.666-10.885",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m597.11 410.03c6.677-3.639 12.821 5.918 5.831 10.182-6.392 3.899-12.818-6.374-5.831-10.182",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m659.02 436.97c7.459-1.547 10.314 11.014 1.97 12.148-7.733 1.05-9.768-10.531-1.97-12.148m208.03-0.12c6.943-2.005 11.648 8.898 3.937 11.526-7.576 2.583-11.99-9.2-3.937-11.526",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m539.04 437.85c7.435-2.147 10.982 9.173 2.951 11.487-7.283 2.098-10.34-9.353-2.951-11.487m28.181 0.181c6.649-3.883 13.201 7.151 5.716 10.745-6.565 3.153-12.203-6.956-5.716-10.745m30.003 0c6.163-3.628 12.75 5.915 6.623 10.21-6.821 4.782-13.713-6.035-6.623-10.21m30.866-0.235c7.329-2.47 11.946 9.166 3.887 11.541-7.014 2.067-11.531-8.965-3.887-11.541",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m738.11 452.07c6.36-3.134 12.697 6.982 5.758 10.734-6.966 3.765-13.291-7.022-5.758-10.734",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m420 467.09c7.736-1.398 9.952 10.319 1.99 11.943-7.592 1.55-10.077-10.481-1.99-11.943m119.04-0.235c6.932-2.003 11.521 9.008 3.912 11.502-7.374 2.417-11.863-9.205-3.912-11.502m29.065 0.196c6.372-3.284 12.582 7.045 5.701 10.755-6.751 3.641-13.013-6.987-5.701-10.755m30.91-0.246c6.853-2.118 10.806 9.002 3.872 11.402-7.227 2.502-11.908-8.918-3.872-11.402m28.195 0.242c6.673-3.736 13.307 6.963 5.727 10.759-6.604 3.307-12.436-7.002-5.727-10.759",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m658.11 466.76c6.956-2.655 11.85 7.8 4.832 11.166-6.899 3.31-12.303-8.316-4.832-11.166",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m747.11 496.03c6.907-3.765 13.424 6.968 5.831 10.77-6.545 3.277-12.761-6.992-5.831-10.77",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m722 499c8.359 16.538-20.094 7.885-6.985-0.822 1.221-0.811 2.601-0.898 3.985-1.178",
    style: {
      fill: "none",
      stroke: "#0a0a0a"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m632.28-43.386c6.6e-4 -0.62931 0.0575-1.5332-0.40591-2.608-0.40451-0.93824-0.83387-1.2491-1.3715-1.8236-3.2056-3.4254-8.6744-5.9095-5.7104-11.815 2.2715-4.5266 9.7088-3.6949 11.357 0.87976 1.5382 4.2609-1.4257 7.7582-4.0791 10.683",
    style: {
      fill: "none",
      strokeWidth: 0.98372,
      stroke: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "cpu",
    transform: "translate(.84703 -1.875)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "screenGlow",
    d: "m493.99 346.99h212.03v106.01h-212.03z",
    style: {
      fill: "url(#radialGradient1865)",
      opacity: 0.98098,
      strokeWidth: 1.1902
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "screen",
    d: "m515 355h170c2.77 0 5 2.23 5 5v80c0 2.77-2.23 5-5 5h-170c-2.77 0-5-2.23-5-5v-80c0-2.77 2.23-5 5-5z",
    style: {
      fill: "#222",
      opacity: 0.98098,
      strokeWidth: 1.0104
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "welcomeText",
    transform: "matrix(1.0585 0 0 1.0585 -35.121 -22.479)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m544.99 392.01-2.8516 19.609h-4.1211l-2.832-8.2031-0.56641-1.9922-0.64453 2.1094-2.7148 8.0859h-4.0039l-2.832-19.609h3.3203l1.6406 13.32 0.35156 2.9688 0.83985-2.5976 2.8516-8.8086h2.4414l3.0664 8.6914 0.87891 2.5977 0.29297-2.7539 1.5234-13.418z",
    style: {
      fill: "#76ff03",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      whiteSpace: "pre"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m565.42 400.78q0 0.72266-0.0195 1.2109t-0.0586 0.91797h-13.77q0 3.0078 1.6797 4.6289 1.6797 1.6016 4.8438 1.6016 0.85937 0 1.7188-0.0586 0.85937-0.0781 1.6602-0.19531 0.80078-0.11719 1.5234-0.2539 0.74219-0.15625 1.3672-0.33204v2.793q-1.3867 0.39063-3.1445 0.625-1.7383 0.25391-3.6133 0.25391-2.5195 0-4.3359-0.68359-1.8164-0.6836-2.9883-1.9727-1.1524-1.3086-1.7188-3.1836-0.54688-1.8945-0.54688-4.2774 0-2.0703 0.58594-3.9062 0.60547-1.8555 1.7383-3.2422 1.1523-1.4062 2.8125-2.2266t3.7695-0.82031q2.0508 0 3.6328 0.64453 1.582 0.64453 2.6562 1.8359 1.0938 1.1719 1.6406 2.8711 0.56641 1.6797 0.56641 3.7695zm-3.5352-0.48828q0.0586-1.3086-0.25391-2.3828-0.3125-1.0938-0.97656-1.875-0.64453-0.78125-1.6211-1.2109-0.97657-0.44922-2.2656-0.44922-1.1133 0-2.0312 0.42969t-1.582 1.2109-1.0742 1.875q-0.41015 1.0938-0.50781 2.4023z",
    style: {
      fill: "#76ff03",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      whiteSpace: "pre"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m577.57 386.82h-5.8008v-2.793h9.2383v24.766h5.8398v2.832h-15.723v-2.832h6.4453z",
    style: {
      fill: "#76ff03",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      whiteSpace: "pre"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m608.15 410.9q-1.3281 0.50781-2.7344 0.74219-1.3867 0.2539-2.8711 0.2539-4.6484 0-7.168-2.5195-2.5-2.5195-2.5-7.3633 0-2.3242 0.72266-4.2188t2.0312-3.2422q1.3086-1.3476 3.125-2.0703 1.8164-0.74219 4.0039-0.74219 1.5234 0 2.8516 0.21485 1.3281 0.21484 2.5391 0.70312v3.2422q-1.2695-0.66406-2.5977-0.95703-1.3086-0.3125-2.7148-0.3125-1.3086 0-2.4805 0.50781-1.1523 0.48828-2.0312 1.4258-0.8789 0.9375-1.3867 2.2852-0.50781 1.3477-0.50781 3.0469 0 3.5547 1.7188 5.332 1.7383 1.7578 4.8047 1.7578 1.3867 0 2.6758-0.3125 1.3086-0.3125 2.5195-0.9375z",
    style: {
      fill: "#76ff03",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      whiteSpace: "pre"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m632.02 401.66q0 2.2852-0.64453 4.1992-0.64453 1.8945-1.8555 3.2617-1.2109 1.3476-2.9492 2.1094-1.7383 0.74219-3.9453 0.74219-2.1094 0-3.7891-0.64453-1.6602-0.66406-2.832-1.9336-1.1523-1.2695-1.7773-3.1445-0.60547-1.875-0.60547-4.3164 0-2.2852 0.64453-4.1602 0.64453-1.8945 1.8555-3.2422 1.2109-1.3672 2.9492-2.1094 1.7383-0.76172 3.9453-0.76172 2.1094 0 3.7695 0.66406 1.6797 0.64453 2.832 1.9141 1.1719 1.25 1.7774 3.125 0.625 1.875 0.625 4.2969zm-3.4766 0.15625q0-1.8164-0.41016-3.1641-0.39063-1.3672-1.1328-2.2656-0.74219-0.91797-1.8164-1.3672-1.0547-0.46875-2.3633-0.46875-1.5234 0-2.6172 0.60547-1.0742 0.58594-1.7773 1.582-0.6836 0.9961-1.0156 2.3242-0.3125 1.3086-0.3125 2.7539 0 1.8164 0.39063 3.1836 0.41015 1.3672 1.1523 2.2852 0.74219 0.89844 1.7969 1.3672 1.0547 0.44922 2.3828 0.44922 1.5234 0 2.5977-0.58594 1.0938-0.60547 1.7773-1.6016 0.70312-0.9961 1.0156-2.3047 0.33204-1.3281 0.33204-2.793z",
    style: {
      fill: "#76ff03",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      whiteSpace: "pre"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m650.97 411.62v-14.082q0-0.91797-0.0781-1.5039-0.0586-0.58594-0.21485-0.91797-0.13672-0.35156-0.37109-0.48828-0.21485-0.13672-0.54688-0.13672-0.39062 0-0.72265 0.23438-0.33203 0.23437-0.72266 0.76171-0.37109 0.52735-0.83984 1.4062-0.44922 0.85938-1.0742 2.1289v12.598h-3.1055v-13.711q0-1.0742-0.0781-1.7383-0.0586-0.66406-0.21484-1.0352-0.13672-0.37109-0.37109-0.50781-0.23438-0.13672-0.56641-0.13672-0.35156 0-0.66406 0.19531-0.3125 0.19532-0.70313 0.70313-0.37109 0.50781-0.83984 1.3867-0.46875 0.8789-1.1133 2.2461v12.598h-3.125v-19.609h2.5976l0.15625 3.7305q0.50782-1.1133 0.97657-1.8945 0.48828-0.78125 0.99609-1.25 0.50781-0.48828 1.0742-0.70313 0.58594-0.23437 1.2891-0.23437 1.582 0 2.4024 1.0352 0.82031 1.0352 0.82031 3.2031 0.46875-1.0156 0.91797-1.7969 0.44922-0.80079 0.95703-1.3281 0.52734-0.54687 1.1523-0.82031 0.625-0.29297 1.4453-0.29297 3.6914 0 3.6914 5.6836v14.277z",
    style: {
      fill: "#76ff03",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      whiteSpace: "pre"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m675.58 400.78q0 0.72266-0.0195 1.2109t-0.0586 0.91797h-13.77q0 3.0078 1.6797 4.6289 1.6797 1.6016 4.8438 1.6016 0.85937 0 1.7188-0.0586 0.85937-0.0781 1.6602-0.19531 0.80078-0.11719 1.5234-0.2539 0.74219-0.15625 1.3672-0.33204v2.793q-1.3867 0.39063-3.1445 0.625-1.7383 0.25391-3.6133 0.25391-2.5195 0-4.3359-0.68359-1.8164-0.6836-2.9883-1.9727-1.1524-1.3086-1.7188-3.1836-0.54688-1.8945-0.54688-4.2774 0-2.0703 0.58594-3.9062 0.60547-1.8555 1.7383-3.2422 1.1523-1.4062 2.8125-2.2266t3.7695-0.82031q2.0508 0 3.6328 0.64453 1.582 0.64453 2.6562 1.8359 1.0938 1.1719 1.6406 2.8711 0.56641 1.6797 0.56641 3.7695zm-3.5352-0.48828q0.0586-1.3086-0.25391-2.3828-0.3125-1.0938-0.97656-1.875-0.64453-0.78125-1.6211-1.2109-0.97657-0.44922-2.2656-0.44922-1.1133 0-2.0312 0.42969t-1.582 1.2109-1.0742 1.875q-0.41015 1.0938-0.50781 2.4023z",
    style: {
      fill: "#76ff03",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      whiteSpace: "pre"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "cursors",
    transform: "matrix(.97872 0 0 1 149.41 65.507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m378.02 317.31h23.5v32h-23.5z",
    style: {
      fill: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m401.82 317.31h23.5v32h-23.5z",
    style: {
      fill: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m425.91 317.31h23.5v32h-23.5z",
    style: {
      fill: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m449.19 317.31h23.5v32h-23.5z",
    style: {
      fill: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m473.32 317.31h23.5v32h-23.5z",
    style: {
      fill: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m497.15 317.31h23.5v32h-23.5z",
    style: {
      fill: "#76ff03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m520.96 317.31h23.5v32h-23.5z",
    style: {
      fill: "#76ff03"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircuitBoard);
export default __webpack_public_path__ + "static/media/circuit-board.b267a27d.svg";
export { ForwardRef as ReactComponent };